"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.footprints = void 0;
var footprints = {
  _children: {
    "FOOD AND NON-ALCOHOLIC BEVERAGES": {
      icon: "shopping-cart",
      intensityKilograms: {
        AT: 0.5343799565570979,
        AU: 0.9728272152026072,
        BE: 0.7309710456582461,
        BG: 0.7101497680609757,
        BR: 1.5683241050582177,
        CA: 1.0199525915022476,
        CH: 0.49706032489409785,
        CN: 2.2935901921453525,
        CY: 0.9955099939851199,
        CZ: 0.9636715695236164,
        DE: 0.6505547690588043,
        DK: 0.817390437852872,
        EE: 1.4090507334725522,
        ES: 0.5735894582156583,
        FI: 0.49482483030098173,
        FR: 0.6177632719273307,
        GB: 0.5983709842857473,
        GR: 0.8184213218917619,
        HR: 0.6953397580397929,
        HU: 0.8954240374882119,
        ID: 1.0257234527403039,
        IE: 0.9963156652109284,
        IN: 1.8848752434917917,
        IT: 0.6116844186338382,
        JP: 0.7958752906183161,
        KR: 0.8488610127405243,
        LT: 1.8095424274114351,
        LU: 1.203833917823845,
        LV: 1.3308501439644416,
        MT: 0.458862163898547,
        MX: 1.447213449395304,
        NL: 0.7966504751312278,
        NO: 0.7200394390458047,
        PL: 0.995905241143346,
        PT: 0.7793799478733805,
        RO: 0.685345049055374,
        RU: 1.0496705712750907,
        SE: 0.4015730836995318,
        SI: 0.7073367263212595,
        SK: 0.8658500455716434,
        TR: 1.03296626866704,
        TW: 0.9188054181996063,
        US: 1.5364118088902992,
        WA: 1.7350952874168,
        WE: 2.5882699304742083,
        WF: 2.911992173797467,
        WL: 1.5390818481438304,
        WM: 1.653008860728267,
        ZA: 2.2718077885896837
      },
      oldKeys: ["PURCHASE_CATEGORY_FOOD_SUPERMARKET", "Grocery store"],
      source: "https://github.com/tmrowco/bloom-contrib/tree/master/co2eq/purchase/exiobase",
      unit: "EUR",
      coicopCode: "01",
      year: 2011,
      _children: {
        Food: {
          coicopCode: "01.1",
          _children: {
            "Cereals and cereal products (ND)": {
              _children: {
                Barley: {
                  icon: null,
                  intensityKilograms: 0.43,
                  source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                  unit: "kg",
                  displayName: "Barley",
                  associatedPurchaseCategory: "Cereals and cereal products (ND)"
                },
                "Beans/tofu": {
                  icon: "burrito",
                  intensityKilograms: 2,
                  source: "From http://www.greeneatz.com/foods-carbon-footprint.html",
                  unit: "kg",
                  displayName: "Beans/tofu",
                  associatedPurchaseCategory: "Cereals and cereal products (ND)"
                },
                "Butter beans": {
                  icon: null,
                  intensityKilograms: 0.39,
                  source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                  unit: "kg",
                  displayName: "Butter beans",
                  associatedPurchaseCategory: "Cereals and cereal products (ND)"
                },
                "Chick peas": {
                  icon: null,
                  intensityKilograms: 0.77,
                  source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                  unit: "kg",
                  displayName: "Chick peas",
                  associatedPurchaseCategory: "Cereals and cereal products (ND)"
                },
                Corn: {
                  icon: null,
                  intensityKilograms: 0.47,
                  source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                  unit: "kg",
                  displayName: "Corn",
                  associatedPurchaseCategory: "Cereals and cereal products (ND)"
                },
                "Dry beans": {
                  icon: null,
                  intensityKilograms: 2,
                  source: "http://static.ewg.org/reports/2011/meateaters/pdf/methodology_ewg_meat_eaters_guide_to_health_and_climate_2011.pdf",
                  unit: "kg",
                  displayName: "Dry beans",
                  associatedPurchaseCategory: "Cereals and cereal products (ND)"
                },
                "Green beans": {
                  icon: null,
                  intensityKilograms: 0.31,
                  source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                  unit: "kg",
                  displayName: "Green beans",
                  associatedPurchaseCategory: "Cereals and cereal products (ND)"
                },
                Lentils: {
                  icon: null,
                  intensityKilograms: 1.03,
                  source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                  unit: "kg",
                  displayName: "Lentils",
                  associatedPurchaseCategory: "Cereals and cereal products (ND)"
                },
                "Morning cereals": {
                  icon: null,
                  intensityKilograms: 0.864,
                  source: "From http://web.agrsci.dk/djfpublikation/djfpdf/DCArapport158.pdf",
                  unit: "kg",
                  displayName: "Morning cereals",
                  associatedPurchaseCategory: "Cereals and cereal products (ND)"
                },
                Oats: {
                  icon: null,
                  intensityKilograms: 0.38,
                  source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                  unit: "kg",
                  displayName: "Oats",
                  associatedPurchaseCategory: "Cereals and cereal products (ND)"
                },
                Pasta: {
                  icon: "wheat",
                  intensityKilograms: 1.2,
                  source: "From https://naturerhverv.dk/fileadmin/user_upload/NaturErhverv/Filer/Tvaergaaende/Foedevarernes_klimaaftryk_tabel_1.pdf",
                  unit: "kg",
                  displayName: "Pasta",
                  associatedPurchaseCategory: "Cereals and cereal products (ND)"
                },
                Peas: {
                  icon: null,
                  intensityKilograms: 0.38,
                  source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                  unit: "kg",
                  conversions: {
                    portion: {
                      kilograms: 0.045,
                      incrementStepSize: 1,
                      source: "https://www.who.int/dietphysicalactivity/publications/f&v_intake_measurement.pdf"
                    }
                  },
                  displayName: "Peas",
                  associatedPurchaseCategory: "Cereals and cereal products (ND)"
                },
                Quinoa: {
                  icon: null,
                  intensityKilograms: 1.15,
                  source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                  unit: "kg",
                  displayName: "Quinoa",
                  associatedPurchaseCategory: "Cereals and cereal products (ND)"
                },
                Rice: {
                  icon: "soup",
                  intensityKilograms: 2.55,
                  source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                  unit: "kg",
                  displayName: "Rice",
                  associatedPurchaseCategory: "Cereals and cereal products (ND)"
                },
                Rye: {
                  icon: null,
                  intensityKilograms: 0.38,
                  source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                  unit: "kg",
                  displayName: "Rye",
                  associatedPurchaseCategory: "Cereals and cereal products (ND)"
                },
                "Rye bread": {
                  icon: "bread-loaf",
                  intensityKilograms: 0.93,
                  source: "From http://web.agrsci.dk/djfpublikation/djfpdf/DCArapport158.pdf",
                  unit: "kg",
                  displayName: "Rye bread",
                  associatedPurchaseCategory: "Cereals and cereal products (ND)"
                },
                "Sesame seeds": {
                  icon: null,
                  intensityKilograms: 0.88,
                  source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                  unit: "kg",
                  displayName: "Sesame seeds",
                  associatedPurchaseCategory: "Cereals and cereal products (ND)"
                },
                "Sesame (oil)": {
                  icon: null,
                  intensityKilograms: 2.334,
                  source: "https://iopscience.iop.org/1748-9326/13/4/044004/media/ERL_044004_SD.pdf",
                  unit: "kg",
                  displayName: "Sesame (oil)",
                  associatedPurchaseCategory: "Cereals and cereal products (ND)"
                },
                Soybean: {
                  icon: null,
                  intensityKilograms: 0.49,
                  source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                  unit: "kg",
                  displayName: "Soybean",
                  associatedPurchaseCategory: "Cereals and cereal products (ND)"
                },
                "Sunflower seed": {
                  icon: null,
                  intensityKilograms: 1.41,
                  source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                  unit: "kg",
                  displayName: "Sunflower seed",
                  associatedPurchaseCategory: "Cereals and cereal products (ND)"
                },
                Tofu: {
                  icon: null,
                  intensityKilograms: 2,
                  source: "http://static.ewg.org/reports/2011/meateaters/pdf/methodology_ewg_meat_eaters_guide_to_health_and_climate_2011.pdf",
                  unit: "kg",
                  displayName: "Tofu",
                  associatedPurchaseCategory: "Cereals and cereal products (ND)"
                },
                Wheat: {
                  icon: null,
                  intensityKilograms: 0.52,
                  source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                  unit: "kg",
                  displayName: "Wheat",
                  associatedPurchaseCategory: "Cereals and cereal products (ND)"
                },
                "Wheat (flour)": {
                  icon: null,
                  intensityKilograms: 0.358,
                  source: "https://iopscience.iop.org/1748-9326/13/4/044004/media/ERL_044004_SD.pdf",
                  unit: "kg",
                  displayName: "Wheat (flour)",
                  associatedPurchaseCategory: "Cereals and cereal products (ND)"
                },
                "White bread": {
                  icon: "bread-loaf",
                  intensityKilograms: 1.054,
                  source: "From http://web.agrsci.dk/djfpublikation/djfpdf/DCArapport158.pdf",
                  unit: "kg",
                  displayName: "White bread",
                  associatedPurchaseCategory: "Cereals and cereal products (ND)"
                }
              },
              icon: "bread-loaf",
              intensityKilograms: {
                AT: 0.5796355639292761,
                AU: 0.7765223530248717,
                BE: 0.7276016508281827,
                BG: 0.8300273460226688,
                BR: 0.765847324688302,
                CA: 0.7304384359957806,
                CH: 0.3043466431273558,
                CN: 1.3600266910385344,
                CY: 0.9976753302259916,
                CZ: 0.9670453200781373,
                DE: 0.6669478175008127,
                DK: 0.8440935751371709,
                EE: 1.5435216627688226,
                ES: 0.5230141007926525,
                FI: 0.45929415649677585,
                FR: 0.5566679438461153,
                GB: 0.5927877556019518,
                GR: 0.851614588136208,
                HR: 0.773353972945894,
                HU: 0.8868747878289489,
                ID: 0.5310892793547999,
                IE: 0.8588975401265386,
                IN: 1.2003899164356155,
                IT: 0.6185259429235767,
                JP: 0.6328195994241832,
                KR: 0.864656600035137,
                LT: 6.46065746156083,
                LU: 1.3427824541042481,
                LV: 3.020860948476191,
                MT: 0.5287325108344074,
                MX: 0.7584816523743887,
                NL: 0.8036138168493192,
                NO: 0.5432913815525177,
                PL: 1.1370669453204165,
                PT: 0.8399986552511414,
                RO: 0.6100918016666759,
                RU: 0.6664725827731105,
                SE: 0.32756258544055417,
                SI: 0.9327657807132559,
                SK: 0.8890878978636372,
                TR: 0.8369797181231712,
                TW: 0.841995196885714,
                US: 0.7856562785935884,
                WA: 1.2338476698424519,
                WE: 1.734066132401566,
                WF: 1.7172312163114247,
                WL: 1.2005104801865152,
                WM: 1.4821349454314823,
                ZA: 3.0786680244747933
              },
              oldKeys: ["PURCHASE_CATEGORY_FOOD_BAKERY", "Bakery"],
              source: "https://github.com/tmrowco/bloom-contrib/tree/master/co2eq/purchase/exiobase",
              unit: "EUR",
              coicopCode: "01.1.1",
              year: 2011,
              displayName: "Cereals and cereal products",
              keywords: ["wheat", "rice", "oat"]
            },
            "Live animals, meat and other parts of slaughtered land animals (ND)": {
              _children: {
                Beef: {
                  icon: "steak",
                  intensityKilograms: 26.61,
                  source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                  unit: "kg",
                  displayName: "Beef",
                  associatedPurchaseCategory: "Live animals, meat and other parts of slaughtered land animals (ND)"
                },
                Buffalo: {
                  icon: null,
                  intensityKilograms: 60.43,
                  source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                  unit: "kg",
                  displayName: "Buffalo",
                  associatedPurchaseCategory: "Live animals, meat and other parts of slaughtered land animals (ND)"
                },
                Chicken: {
                  icon: "drumstick",
                  intensityKilograms: 3.65,
                  source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                  unit: "kg",
                  displayName: "Chicken",
                  associatedPurchaseCategory: "Live animals, meat and other parts of slaughtered land animals (ND)"
                },
                Duck: {
                  icon: null,
                  intensityKilograms: 3.09,
                  source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                  unit: "kg",
                  displayName: "Duck",
                  associatedPurchaseCategory: "Live animals, meat and other parts of slaughtered land animals (ND)"
                },
                Eggs: {
                  icon: "egg",
                  intensityKilograms: 3.46,
                  source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                  unit: "kg",
                  conversions: {
                    item: {
                      kilograms: 0.057,
                      incrementStepSize: 1,
                      source: "https://web.extension.illinois.edu/eggs/res16-egg.html",
                      "default": true
                    }
                  },
                  displayName: "Eggs",
                  associatedPurchaseCategory: "Live animals, meat and other parts of slaughtered land animals (ND)"
                },
                Ham: {
                  icon: "pig",
                  intensityKilograms: 4.453,
                  source: "https://link.springer.com/article/10.1007/s11367-018-1460-x#MOESM1",
                  unit: "kg",
                  displayName: "Ham",
                  associatedPurchaseCategory: "Live animals, meat and other parts of slaughtered land animals (ND)"
                },
                Lamb: {
                  icon: "sheep",
                  intensityKilograms: 25.58,
                  source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                  unit: "kg",
                  displayName: "Lamb",
                  associatedPurchaseCategory: "Live animals, meat and other parts of slaughtered land animals (ND)"
                },
                Pork: {
                  icon: "pig",
                  intensityKilograms: 5.74,
                  source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                  unit: "kg",
                  displayName: "Pork",
                  associatedPurchaseCategory: "Live animals, meat and other parts of slaughtered land animals (ND)"
                },
                Rabbit: {
                  icon: null,
                  intensityKilograms: 4.7,
                  source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                  unit: "kg",
                  displayName: "Rabbit",
                  associatedPurchaseCategory: "Live animals, meat and other parts of slaughtered land animals (ND)"
                },
                Turkey: {
                  icon: "turkey",
                  intensityKilograms: 7.17,
                  source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                  unit: "kg",
                  displayName: "Turkey",
                  associatedPurchaseCategory: "Live animals, meat and other parts of slaughtered land animals (ND)"
                }
              },
              coicopCode: "01.1.2",
              year: 2011,
              unit: "EUR",
              source: "https://github.com/tmrowco/bloom-contrib/tree/master/co2eq/purchase/exiobase",
              intensityKilograms: {
                AT: 0.6458596804033253,
                AU: 1.2200355970120131,
                BE: 0.8101450162489309,
                BG: 0.8672624786899459,
                BR: 3.532344175590584,
                CA: 1.3596433559436427,
                CH: 0.5261237452489711,
                CN: 3.549136360954643,
                CY: 0.8291673729616511,
                CZ: 0.8247686303365562,
                DE: 0.6942431226657375,
                DK: 0.8010192178906386,
                EE: 1.7000324367884965,
                ES: 0.6085149338778476,
                FI: 0.5179672444537143,
                FR: 0.7436822833672974,
                GB: 0.6553351124068887,
                GR: 0.909753802441774,
                HR: 0.7349725878633286,
                HU: 0.8772141853397828,
                ID: 1.5621465866390154,
                IE: 0.7552188873225312,
                IN: 2.8829174885338085,
                IT: 0.5646340772200414,
                JP: 1.3658585235641003,
                KR: 1.1086610796753824,
                LT: 1.0558991050953932,
                LU: 1.4876023962689686,
                LV: 1.2034895886406332,
                MT: 0.35783763275378744,
                MX: 2.7906972696486467,
                NL: 0.6724523949377128,
                NO: 0.8234687406543508,
                PL: 1.1710927788945238,
                PT: 0.9511482645486583,
                RO: 0.7270821139078303,
                RU: 0.4864790882767934,
                SE: 0.37845621468932494,
                SI: 0.9885682987262772,
                SK: 1.2685251863585356,
                TR: 0.8053474117122315,
                TW: 1.3671427939124512,
                US: 3.3763463112293737,
                WA: 1.2323732966223317,
                WE: 1.4336424270821353,
                WF: 2.229663654913278,
                WL: 1.9733027739683502,
                WM: 1.2869110617788275,
                ZA: 2.483712981842457
              },
              displayName: "Live animals, meat and other parts of slaughtered land animals"
            },
            "Fish and other seafood (ND)": {
              _children: {
                Seafood: {
                  _children: {
                    Anglerfish: {
                      icon: "fish",
                      intensityKilograms: 12.29,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      displayName: "Anglerfish",
                      associatedPurchaseCategory: "Fish and other seafood (ND)"
                    },
                    Brill: {
                      icon: "fish",
                      intensityKilograms: 8.41,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      displayName: "Brill",
                      associatedPurchaseCategory: "Fish and other seafood (ND)"
                    },
                    "Canned Tuna": {
                      icon: "fish",
                      intensityKilograms: 6.1,
                      source: "http://static.ewg.org/reports/2011/meateaters/pdf/methodology_ewg_meat_eaters_guide_to_health_and_climate_2011.pdf",
                      unit: "kg",
                      displayName: "Canned tuna",
                      associatedPurchaseCategory: "Fish and other seafood (ND)"
                    },
                    Carp: {
                      icon: "fish",
                      intensityKilograms: 1.76,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      displayName: "Carp",
                      associatedPurchaseCategory: "Fish and other seafood (ND)"
                    },
                    Clams: {
                      icon: null,
                      intensityKilograms: 0.1,
                      source: "From https://naturerhverv.dk/fileadmin/user_upload/NaturErhverv/Filer/Tvaergaaende/Foedevarernes_klimaaftryk_tabel_1.pdf",
                      unit: "kg",
                      displayName: "Clams",
                      associatedPurchaseCategory: "Fish and other seafood (ND)"
                    },
                    Cod: {
                      icon: "fish",
                      intensityKilograms: 3.51,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      displayName: "Cod",
                      associatedPurchaseCategory: "Fish and other seafood (ND)"
                    },
                    "Common Ling": {
                      icon: "fish",
                      intensityKilograms: 6.45,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      displayName: "Common ling",
                      associatedPurchaseCategory: "Fish and other seafood (ND)"
                    },
                    Eel: {
                      icon: "fish",
                      intensityKilograms: 3.88,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      displayName: "Eel",
                      associatedPurchaseCategory: "Fish and other seafood (ND)"
                    },
                    "Farmed Salmon": {
                      icon: "fish",
                      intensityKilograms: 11.9,
                      source: "http://static.ewg.org/reports/2011/meateaters/pdf/methodology_ewg_meat_eaters_guide_to_health_and_climate_2011.pdf",
                      unit: "kg",
                      displayName: "Farmed salmon",
                      associatedPurchaseCategory: "Fish and other seafood (ND)"
                    },
                    "Fish (all species)": {
                      icon: "fish",
                      intensityKilograms: 3.49,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      displayName: "Fish (all species)",
                      associatedPurchaseCategory: "Fish and other seafood (ND)"
                    },
                    Flatfish: {
                      icon: "fish",
                      intensityKilograms: 6.2,
                      source: "From https://naturerhverv.dk/fileadmin/user_upload/NaturErhverv/Filer/Tvaergaaende/Foedevarernes_klimaaftryk_tabel_1.pdf",
                      unit: "kg",
                      displayName: "Flatfish",
                      associatedPurchaseCategory: "Fish and other seafood (ND)"
                    },
                    Haddock: {
                      icon: "fish",
                      intensityKilograms: 3.41,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      displayName: "Haddock",
                      associatedPurchaseCategory: "Fish and other seafood (ND)"
                    },
                    Hake: {
                      icon: "fish",
                      intensityKilograms: 9.77,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      displayName: "Hake",
                      associatedPurchaseCategory: "Fish and other seafood (ND)"
                    },
                    Herring: {
                      icon: "fish",
                      intensityKilograms: 1.16,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      displayName: "Herring",
                      associatedPurchaseCategory: "Fish and other seafood (ND)"
                    },
                    Lobster: {
                      icon: null,
                      intensityKilograms: 27.8,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      displayName: "Lobster",
                      associatedPurchaseCategory: "Fish and other seafood (ND)"
                    },
                    Mackerel: {
                      icon: "fish",
                      intensityKilograms: 1.8,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      displayName: "Mackerel",
                      associatedPurchaseCategory: "Fish and other seafood (ND)"
                    },
                    Megrim: {
                      icon: "fish",
                      intensityKilograms: 14.15,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      displayName: "Megrim",
                      associatedPurchaseCategory: "Fish and other seafood (ND)"
                    },
                    Mussels: {
                      icon: null,
                      intensityKilograms: 9.51,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      displayName: "Mussels",
                      associatedPurchaseCategory: "Fish and other seafood (ND)"
                    },
                    "Octopus/squid/cuttlefish": {
                      icon: null,
                      intensityKilograms: 7.13,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      displayName: "Octopus/squid/cuttlefish",
                      associatedPurchaseCategory: "Fish and other seafood (ND)"
                    },
                    Pollock: {
                      icon: "fish",
                      intensityKilograms: 1.61,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      displayName: "Pollock",
                      associatedPurchaseCategory: "Fish and other seafood (ND)"
                    },
                    Pomfret: {
                      icon: "fish",
                      intensityKilograms: 6.63,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      displayName: "Pomfret",
                      associatedPurchaseCategory: "Fish and other seafood (ND)"
                    },
                    Porbeagle: {
                      icon: "fish",
                      intensityKilograms: 11.44,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      displayName: "Porbeagle",
                      associatedPurchaseCategory: "Fish and other seafood (ND)"
                    },
                    "Prawns/shrimp": {
                      icon: null,
                      intensityKilograms: 7.8,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      displayName: "Prawns/shrimp",
                      associatedPurchaseCategory: "Fish and other seafood (ND)"
                    },
                    "Rock fish": {
                      icon: "fish",
                      intensityKilograms: 6.94,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      displayName: "Rock fish",
                      associatedPurchaseCategory: "Fish and other seafood (ND)"
                    },
                    Salmon: {
                      icon: "fish",
                      intensityKilograms: 3.47,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      displayName: "Salmon",
                      associatedPurchaseCategory: "Fish and other seafood (ND)"
                    },
                    "Sea bass": {
                      icon: "fish",
                      intensityKilograms: 3.27,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      displayName: "Sea bass",
                      associatedPurchaseCategory: "Fish and other seafood (ND)"
                    },
                    "Shrimp (Fresh)": {
                      icon: null,
                      intensityKilograms: 3,
                      source: "https://naturerhverv.dk/fileadmin/user_upload/NaturErhverv/Filer/Tvaergaaende/Foedevarernes_klimaaftryk_tabel_1.pdf",
                      unit: "kg",
                      displayName: "Shrimp (fresh)",
                      associatedPurchaseCategory: "Fish and other seafood (ND)"
                    },
                    "Shrimp (Frozen)": {
                      icon: null,
                      intensityKilograms: 10.5,
                      source: "https://naturerhverv.dk/fileadmin/user_upload/NaturErhverv/Filer/Tvaergaaende/Foedevarernes_klimaaftryk_tabel_1.pdf",
                      unit: "kg",
                      displayName: "Shrimp (frozen)",
                      associatedPurchaseCategory: "Fish and other seafood (ND)"
                    },
                    Sole: {
                      icon: "fish",
                      intensityKilograms: 20.86,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      displayName: "Sole",
                      associatedPurchaseCategory: "Fish and other seafood (ND)"
                    },
                    Swordfish: {
                      icon: "fish",
                      intensityKilograms: 12.84,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      displayName: "Swordfish",
                      associatedPurchaseCategory: "Fish and other seafood (ND)"
                    },
                    Trout: {
                      icon: "fish",
                      intensityKilograms: 4.2,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      displayName: "Trout",
                      associatedPurchaseCategory: "Fish and other seafood (ND)"
                    },
                    Tuna: {
                      icon: "fish",
                      intensityKilograms: 2.15,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      displayName: "Tuna",
                      associatedPurchaseCategory: "Fish and other seafood (ND)"
                    },
                    Turbot: {
                      icon: "fish",
                      intensityKilograms: 14.51,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      displayName: "Turbot",
                      associatedPurchaseCategory: "Fish and other seafood (ND)"
                    },
                    Whiting: {
                      icon: "fish",
                      intensityKilograms: 2.66,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      displayName: "Whiting",
                      associatedPurchaseCategory: "Fish and other seafood (ND)"
                    }
                  },
                  icon: "fish",
                  intensityKilograms: 3.49,
                  source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                  unit: "kg",
                  displayName: "Seafood",
                  associatedPurchaseCategory: "Fish and other seafood (ND)"
                }
              },
              coicopCode: "01.1.3",
              year: 2011,
              unit: "EUR",
              source: "https://github.com/tmrowco/bloom-contrib/tree/master/co2eq/purchase/exiobase",
              intensityKilograms: {
                AT: 0.6538071632591153,
                AU: 0.7151866436004488,
                BE: 0.8770966801263465,
                BG: 1.1483154697464188,
                BR: 0.4040159976386069,
                CA: 0.5888188658489415,
                CH: 0.529175949363863,
                CN: 2.1172924442209617,
                CY: 1.0176420332374627,
                CZ: 0.8176451198225632,
                DE: 0.758771360745418,
                DK: 0.9554304992154936,
                EE: 1.5039324221673425,
                ES: 0.7519227358475568,
                FI: 0.9208445791289288,
                FR: 0.7445262843990599,
                GB: 0.36658811764593596,
                GR: 0.7727569979788703,
                HR: 0.7635102574891545,
                HU: 0.6105311557723654,
                ID: 0.7735946375830041,
                IE: 0.9515262791196683,
                IN: 1.3830707854051385,
                IT: 0.6621184546905651,
                JP: 0.4127238173724249,
                KR: 0.7653960888917829,
                LT: 1.0669585316018826,
                LU: 0.8805610954622815,
                LV: 0.9267205442443451,
                MT: 0.9489694390329579,
                MX: 0.4958283635196873,
                NL: 0.7560954291016627,
                NO: 0.38986564085727987,
                PL: 1.1292689667190532,
                PT: 0.8220554279759907,
                RO: 1.401386655624311,
                RU: 0.8202489251440128,
                SE: 0.5260007031325853,
                SI: 0.6340781336928022,
                SK: 1.2097186266394602,
                TR: 0.6666608166686838,
                TW: 0.8355431428390306,
                US: 0.5201283990080153,
                WA: 1.9231968854765975,
                WE: 2.121423265895356,
                WF: 1.645118575225866,
                WL: 0.8269237643477146,
                WM: 1.4257802653945844,
                ZA: 2.4258845572090926
              },
              displayName: "Fish and other seafood"
            },
            "Milk, other dairy products and eggs (ND)": {
              _children: {
                Butter: {
                  icon: null,
                  intensityKilograms: 9.25,
                  source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                  unit: "kg",
                  displayName: "Butter",
                  associatedPurchaseCategory: "Milk, other dairy products and eggs (ND)"
                },
                Cheddar: {
                  icon: "cheese-swiss",
                  intensityKilograms: 13.02,
                  source: "https://www.researchgate.net/publication/309672245_Protein_versus_global_warming_potential_-_a_meta---analysis_of_the_global_warming_potential_and_protein_ratios_for_human_food",
                  unit: "kg",
                  displayName: "Cheddar",
                  associatedPurchaseCategory: "Milk, other dairy products and eggs (ND)"
                },
                Cheese: {
                  icon: "cheese-swiss",
                  intensityKilograms: 8.55,
                  source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                  unit: "kg",
                  displayName: "Cheese",
                  associatedPurchaseCategory: "Milk, other dairy products and eggs (ND)"
                },
                Cream: {
                  icon: null,
                  intensityKilograms: 5.64,
                  source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                  unit: "kg",
                  displayName: "Cream",
                  associatedPurchaseCategory: "Milk, other dairy products and eggs (ND)"
                },
                Milk: {
                  icon: "glass",
                  intensityKilograms: 1.29,
                  source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                  unit: "kg",
                  conversions: {
                    glass: {
                      kilograms: 0.225,
                      incrementStepSize: 1
                    }
                  },
                  displayName: "Milk",
                  associatedPurchaseCategory: "Milk, other dairy products and eggs (ND)"
                },
                "Milk Yogurt": {
                  icon: null,
                  intensityKilograms: 1.31,
                  source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                  unit: "kg",
                  displayName: "Milk yogurt",
                  associatedPurchaseCategory: "Milk, other dairy products and eggs (ND)"
                },
                "Ice cream (Vanilla regular)": {
                  icon: null,
                  intensityKilograms: 3.75,
                  unit: "kg",
                  source: "https://www.sciencedirect.com/science/article/pii/S0959652618332633",
                  conversions: {
                    portion: {
                      kilograms: 0.068,
                      incrementStepSize: 1
                    }
                  },
                  displayName: "Ice cream (vanilla regular)",
                  associatedPurchaseCategory: "Milk, other dairy products and eggs (ND)"
                },
                "Ice cream (Vanilla premium)": {
                  icon: null,
                  intensityKilograms: 3.94,
                  unit: "kg",
                  source: "https://www.sciencedirect.com/science/article/pii/S0959652618332633",
                  conversions: {
                    portion: {
                      kilograms: 0.068,
                      incrementStepSize: 1
                    }
                  },
                  displayName: "Ice cream (vanilla premium)",
                  associatedPurchaseCategory: "Milk, other dairy products and eggs (ND)"
                },
                "Ice cream (Chocolate regular)": {
                  icon: null,
                  intensityKilograms: 3.66,
                  unit: "kg",
                  source: "https://www.sciencedirect.com/science/article/pii/S0959652618332633",
                  conversions: {
                    portion: {
                      kilograms: 0.068,
                      incrementStepSize: 1
                    }
                  },
                  displayName: "Ice cream (chocolate regular)",
                  associatedPurchaseCategory: "Milk, other dairy products and eggs (ND)"
                },
                "Ice cream (Chocolate premium)": {
                  icon: null,
                  intensityKilograms: 3.91,
                  unit: "kg",
                  source: "https://www.sciencedirect.com/science/article/pii/S0959652618332633",
                  conversions: {
                    portion: {
                      kilograms: 0.068,
                      incrementStepSize: 1
                    }
                  },
                  displayName: "Ice cream (chocolate premium)",
                  associatedPurchaseCategory: "Milk, other dairy products and eggs (ND)"
                },
                Mozzarella: {
                  icon: "cheese-swiss",
                  intensityKilograms: 7.5,
                  source: "https://www.researchgate.net/publication/309672245_Protein_versus_global_warming_potential_-_a_meta---analysis_of_the_global_warming_potential_and_protein_ratios_for_human_food",
                  unit: "kg",
                  displayName: "Mozzarella",
                  associatedPurchaseCategory: "Milk, other dairy products and eggs (ND)"
                },
                Parmesan: {
                  icon: "cheese-swiss",
                  intensityKilograms: 8.79,
                  source: "https://www.researchgate.net/publication/309672245_Protein_versus_global_warming_potential_-_a_meta---analysis_of_the_global_warming_potential_and_protein_ratios_for_human_food",
                  unit: "kg",
                  displayName: "Parmesan",
                  associatedPurchaseCategory: "Milk, other dairy products and eggs (ND)"
                }
              },
              coicopCode: "01.1.4",
              year: 2011,
              unit: "EUR",
              source: "https://github.com/tmrowco/bloom-contrib/tree/master/co2eq/purchase/exiobase",
              intensityKilograms: {
                AT: 0.7436543711534668,
                AU: 1.2798545299946813,
                BE: 0.8846209828675939,
                BG: 0.7142762053308263,
                BR: 2.474928102927795,
                CA: 1.4586746593264133,
                CH: 1.035929355670783,
                CN: 4.521001657021448,
                CY: 1.795070593245675,
                CZ: 1.3725200597378184,
                DE: 0.9497354360911452,
                DK: 1.35103150182659,
                EE: 1.8128175495079266,
                ES: 0.8226637074259598,
                FI: 0.6480886145724185,
                FR: 0.9484605611870138,
                GB: 1.0394629690889043,
                GR: 1.3079007745328435,
                HR: 0.8479286651280258,
                HU: 1.2661648200536053,
                ID: 2.035662335937325,
                IE: 1.7167589512216566,
                IN: 3.303471749822845,
                IT: 0.9718348102128398,
                JP: 0.9425517237072817,
                KR: 0.9772526775648205,
                LT: 1.077302860402114,
                LU: 1.7378032528757896,
                LV: 1.632105648855575,
                MT: 0.4852065345755263,
                MX: 2.6183259476309786,
                NL: 1.097449343396859,
                NO: 0.9923615490346327,
                PL: 0.8116546543135539,
                PT: 0.9117738874685539,
                RO: 0.8977667678267977,
                RU: 2.827653666398889,
                SE: 0.7939006524097145,
                SI: 0.5325602933239807,
                SK: 0.9793451736127805,
                TR: 2.510401564847991,
                TW: 0.7361342345594772,
                US: 1.532540934010749,
                WA: 4.241437415358039,
                WE: 7.207266359395898,
                WF: 9.195287225180252,
                WL: 3.355271467864395,
                WM: 2.584798206095876,
                ZA: 1.6191725458493484
              },
              displayName: "Milk, other dairy products and eggs",
              keywords: ["cheese", "butter", "cream"]
            },
            "Oils and fats (ND)": {
              coicopCode: "01.1.5",
              year: 2011,
              unit: "EUR",
              source: "https://github.com/tmrowco/bloom-contrib/tree/master/co2eq/purchase/exiobase",
              intensityKilograms: {
                AT: 0.6057337241594754,
                AU: 1.2909064223784799,
                BE: 0.8169020288550296,
                BG: 0.7442998635175551,
                BR: 1.71025619537981,
                CA: 1.2498969325739833,
                CH: 0.8120719027213625,
                CN: 3.3229425719918235,
                CY: 1.5816985784633777,
                CZ: 1.1805903379572473,
                DE: 0.8254930052205811,
                DK: 1.0470470596951365,
                EE: 1.508656352603702,
                ES: 0.822514472830125,
                FI: 0.5815805028378751,
                FR: 0.8150894939076545,
                GB: 0.8110717300735253,
                GR: 1.5002964858039913,
                HR: 1.0555247796120235,
                HU: 1.0616943660045932,
                ID: 1.4811817108445047,
                IE: 1.2753050335195395,
                IN: 2.7994585497136866,
                IT: 0.8703357384303629,
                JP: 0.889871109076015,
                KR: 0.8754577669120894,
                LT: 0.9255138998383791,
                LU: 1.3311246607934037,
                LV: 1.3631449088140097,
                MT: 0.5802897829322897,
                MX: 2.033100612242347,
                NL: 1.016427861595171,
                NO: 0.8800351030908476,
                PL: 0.7304803444023279,
                PT: 0.8565197453310444,
                RO: 0.8121454821951722,
                RU: 2.2540870886988627,
                SE: 0.5874581283799667,
                SI: 0.3851067679291018,
                SK: 0.8347292149582227,
                TR: 2.0529241265003173,
                TW: 0.6514422653403462,
                US: 1.3890818792890611,
                WA: 2.8581013809384688,
                WE: 5.287974100470407,
                WF: 6.257443094672921,
                WL: 2.24258688332632,
                WM: 2.0578307924002273,
                ZA: 1.841108269860735
              },
              displayName: "Oils and fats"
            },
            "Fruits and nuts (ND)": {
              _children: {
                Fruits: {
                  _children: {
                    Apples: {
                      icon: null,
                      intensityKilograms: 0.29,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      conversions: {
                        item: {
                          kilograms: 0.112,
                          incrementStepSize: 1,
                          source: "https://www.who.int/dietphysicalactivity/publications/f&v_intake_measurement.pdf"
                        }
                      },
                      displayName: "Apples",
                      associatedPurchaseCategory: "Fruits and nuts (ND)"
                    },
                    Apricot: {
                      icon: null,
                      intensityKilograms: 0.43,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      conversions: {
                        portion: {
                          kilograms: 0.025,
                          incrementStepSize: 1,
                          source: "https://www.yazio.com/de/kalorientabelle/aprikose-frisch.html",
                          "default": true
                        },
                        item: {
                          kilograms: 0.05,
                          incrementStepSize: 1,
                          source: "https://www.yazio.com/de/kalorientabelle/aprikose-frisch.html"
                        }
                      },
                      displayName: "Apricot",
                      associatedPurchaseCategory: "Fruits and nuts (ND)"
                    },
                    Avocados: {
                      icon: null,
                      intensityKilograms: 1.3,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      conversions: {
                        item: {
                          kilograms: 0.27,
                          incrementStepSize: 1,
                          source: "https://www.yazio.com/en/foods/avocado.html"
                        }
                      },
                      displayName: "Avocados",
                      associatedPurchaseCategory: "Fruits and nuts (ND)"
                    },
                    Bananas: {
                      icon: null,
                      intensityKilograms: 0.72,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      conversions: {
                        item: {
                          kilograms: 0.1,
                          incrementStepSize: 1,
                          source: "https://www.who.int/dietphysicalactivity/publications/f&v_intake_measurement.pdf"
                        }
                      },
                      displayName: "Bananas",
                      associatedPurchaseCategory: "Fruits and nuts (ND)"
                    },
                    Blueberry: {
                      icon: null,
                      intensityKilograms: 0.92,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      conversions: {
                        portion: {
                          kilograms: 0.045,
                          incrementStepSize: 1,
                          source: "https://www.yazio.com/de/kalorientabelle/blaubeeren-frisch.html"
                        }
                      },
                      displayName: "Blueberry",
                      associatedPurchaseCategory: "Fruits and nuts (ND)"
                    },
                    Blackberry: {
                      icon: null,
                      intensityKilograms: 0.599,
                      source: "https://iopscience.iop.org/1748-9326/13/4/044004/media/ERL_044004_SD.pdf",
                      unit: "kg",
                      conversions: {
                        portion: {
                          kilograms: 0.076,
                          incrementStepSize: 1,
                          source: "https://www.who.int/dietphysicalactivity/publications/f&v_intake_measurement.pdf"
                        }
                      },
                      displayName: "Blackberry",
                      associatedPurchaseCategory: "Fruits and nuts (ND)"
                    },
                    Blackcurrant: {
                      icon: null,
                      intensityKilograms: 0.29,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      conversions: {
                        portion: {
                          kilograms: 0.04,
                          incrementStepSize: 1,
                          source: "https://www.who.int/dietphysicalactivity/publications/f&v_intake_measurement.pdf"
                        }
                      },
                      displayName: "Blackcurrant",
                      associatedPurchaseCategory: "Fruits and nuts (ND)"
                    },
                    Boysenberry: {
                      icon: null,
                      intensityKilograms: 0.599,
                      source: "https://iopscience.iop.org/1748-9326/13/4/044004/media/ERL_044004_SD.pdf",
                      unit: "kg",
                      displayName: "Boysenberry",
                      associatedPurchaseCategory: "Fruits and nuts (ND)"
                    },
                    Cantaloupe: {
                      icon: null,
                      intensityKilograms: 0.49,
                      source: "https://iopscience.iop.org/1748-9326/13/4/044004/media/ERL_044004_SD.pdf",
                      unit: "kg",
                      conversions: {
                        portion: {
                          kilograms: 0.069,
                          incrementStepSize: 1,
                          source: "https://www.yazio.com/en/foods/cantaloupe-melon.html",
                          "default": true
                        },
                        item: {
                          kilograms: 0.35,
                          incrementStepSize: 1,
                          source: "https://www.yazio.com/en/foods/cantaloupe-melon.html"
                        }
                      },
                      displayName: "Cantaloupe",
                      associatedPurchaseCategory: "Fruits and nuts (ND)"
                    },
                    Cherries: {
                      icon: null,
                      intensityKilograms: 0.39,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      conversions: {
                        portion: {
                          kilograms: 0.08,
                          incrementStepSize: 1,
                          source: "https://www.yazio.com/en/foods/cherries.html",
                          "default": true
                        },
                        item: {
                          kilograms: 0.008,
                          incrementStepSize: 1,
                          source: "https://www.yazio.com/en/foods/cherries.html"
                        }
                      },
                      displayName: "Cherries",
                      associatedPurchaseCategory: "Fruits and nuts (ND)"
                    },
                    Cinnamon: {
                      icon: null,
                      intensityKilograms: 1.87,
                      source: "http://assets.wwf.org.uk/downloads/how_low_report_1.pdf",
                      unit: "kg",
                      displayName: "Cinnamon",
                      associatedPurchaseCategory: "Fruits and nuts (ND)"
                    },
                    Cranberries: {
                      icon: null,
                      intensityKilograms: 0.92,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      conversions: {
                        portion: {
                          kilograms: 0.03,
                          incrementStepSize: 1,
                          source: "https://www.yazio.com/de/kalorientabelle/preiselbeeren-frisch.html",
                          "default": true
                        },
                        item: {
                          kilograms: 0.003,
                          incrementStepSize: 1,
                          source: "https://www.yazio.com/de/kalorientabelle/preiselbeeren-frisch.html"
                        }
                      },
                      displayName: "Cranberries",
                      associatedPurchaseCategory: "Fruits and nuts (ND)"
                    },
                    Coconut: {
                      icon: null,
                      intensityKilograms: 1.521,
                      source: "https://iopscience.iop.org/1748-9326/13/4/044004/media/ERL_044004_SD.pdf",
                      unit: "kg",
                      conversions: {
                        portion: {
                          kilograms: 0.08,
                          incrementStepSize: 1,
                          source: "https://www.yazio.com/en/foods/coconut-meat.html",
                          "default": true
                        },
                        item: {
                          kilograms: 0.397,
                          incrementStepSize: 1,
                          source: "https://www.yazio.com/en/foods/coconut-meat.html"
                        }
                      },
                      displayName: "Coconut",
                      associatedPurchaseCategory: "Fruits and nuts (ND)"
                    },
                    Currants: {
                      icon: null,
                      intensityKilograms: 0.84,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      conversions: {
                        portion: {
                          kilograms: 0.03,
                          incrementStepSize: 1,
                          source: "https://www.yazio.com/de/kalorientabelle/johannisbeeren-schwarz-frisch.html",
                          "default": true
                        },
                        item: {
                          kilograms: 0.003,
                          incrementStepSize: 1,
                          source: "https://www.yazio.com/de/kalorientabelle/johannisbeeren-schwarz-frisch.html"
                        }
                      },
                      displayName: "Currants",
                      associatedPurchaseCategory: "Fruits and nuts (ND)"
                    },
                    Dates: {
                      icon: null,
                      intensityKilograms: 0.32,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      conversion: {
                        portion: {
                          kilograms: 0.035,
                          incrementStepSize: 1,
                          source: "https://www.yazio.com/de/kalorientabelle/datteln.html",
                          "default": true
                        },
                        item: {
                          kilograms: 0.007,
                          incrementStepSize: 1,
                          source: "https://www.yazio.com/de/kalorientabelle/datteln.html"
                        }
                      },
                      displayName: "Dates",
                      associatedPurchaseCategory: "Fruits and nuts (ND)"
                    },
                    Figs: {
                      icon: null,
                      intensityKilograms: 0.43,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      conversion: {
                        item: {
                          kilograms: 0.048,
                          incrementStepSize: 1,
                          source: "https://www.yazio.com/de/kalorientabelle/feigen-frisch.html"
                        }
                      },
                      displayName: "Figs",
                      associatedPurchaseCategory: "Fruits and nuts (ND)"
                    },
                    Gooseberries: {
                      icon: null,
                      intensityKilograms: 0.84,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      conversion: {
                        portion: {
                          kilograms: 0.04,
                          incrementStepSize: 1,
                          source: "https://www.yazio.com/de/kalorientabelle/datteln.html",
                          "default": true
                        },
                        item: {
                          kilograms: 0.004,
                          incrementStepSize: 1,
                          source: "https://www.yazio.com/de/kalorientabelle/stachelbeeren-frisch.html"
                        }
                      },
                      displayName: "Gooseberries",
                      associatedPurchaseCategory: "Fruits and nuts (ND)"
                    },
                    Grapefruit: {
                      icon: null,
                      intensityKilograms: 0.51,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      conversions: {
                        portion: {
                          kilograms: 0.116,
                          incrementStepSize: 1,
                          source: "https://www.who.int/dietphysicalactivity/publications/f&v_intake_measurement.pdf"
                        }
                      },
                      displayName: "Grapefruit",
                      associatedPurchaseCategory: "Fruits and nuts (ND)"
                    },
                    Grapes: {
                      icon: null,
                      intensityKilograms: 0.37,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      conversions: {
                        portion: {
                          kilograms: 0.07,
                          incrementStepSize: 1,
                          source: "https://www.who.int/dietphysicalactivity/publications/f&v_intake_measurement.pdf"
                        }
                      },
                      displayName: "Grapes",
                      associatedPurchaseCategory: "Fruits and nuts (ND)"
                    },
                    "Grapes (raisins)": {
                      icon: null,
                      intensityKilograms: 0.684,
                      source: "https://iopscience.iop.org/1748-9326/13/4/044004/media/ERL_044004_SD.pdf",
                      unit: "kg",
                      displayName: "Grapes (raisins)",
                      associatedPurchaseCategory: "Fruits and nuts (ND)"
                    },
                    Guavas: {
                      icon: null,
                      intensityKilograms: 0.28,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      conversion: {
                        item: {
                          kilograms: 0.055,
                          incrementStepSize: 1,
                          source: "https://www.yazio.com/en/foods/guava.html"
                        }
                      },
                      displayName: "Guavas",
                      associatedPurchaseCategory: "Fruits and nuts (ND)"
                    },
                    Kiwi: {
                      icon: null,
                      intensityKilograms: 0.36,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      conversions: {
                        item: {
                          kilograms: 0.06,
                          incrementStepSize: 1,
                          source: "https://www.who.int/dietphysicalactivity/publications/f&v_intake_measurement.pdf"
                        }
                      },
                      displayName: "Kiwi",
                      associatedPurchaseCategory: "Fruits and nuts (ND)"
                    },
                    Kumquat: {
                      icon: null,
                      intensityKilograms: 0.32,
                      source: "https://iopscience.iop.org/1748-9326/13/4/044004/media/ERL_044004_SD.pdf",
                      unit: "kg",
                      conversion: {
                        portion: {
                          kilograms: 0.095,
                          incrementStepSize: 1,
                          source: "https://www.yazio.com/de/kalorientabelle/datteln.html",
                          "default": true
                        },
                        item: {
                          kilograms: 0.019,
                          incrementStepSize: 1,
                          source: "https://www.yazio.com/en/foods/kumquat.html"
                        }
                      },
                      displayName: "Kumquat",
                      associatedPurchaseCategory: "Fruits and nuts (ND)"
                    },
                    Lemons: {
                      icon: null,
                      intensityKilograms: 0.26,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      conversion: {
                        item: {
                          kilograms: 0.058,
                          incrementStepSize: 1,
                          source: "https://www.yazio.com/de/kalorientabelle/zitrone-ohne-schale-frisch.html"
                        }
                      },
                      displayName: "Lemons",
                      associatedPurchaseCategory: "Fruits and nuts (ND)"
                    },
                    Limes: {
                      icon: null,
                      intensityKilograms: 0.26,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      conversion: {
                        item: {
                          kilograms: 0.067,
                          incrementStepSize: 1,
                          source: "https://www.yazio.com/de/kalorientabelle/limette-limone-frisch.html"
                        }
                      },
                      displayName: "Limes",
                      associatedPurchaseCategory: "Fruits and nuts (ND)"
                    },
                    Lychee: {
                      icon: null,
                      intensityKilograms: 0.893,
                      source: "https://iopscience.iop.org/1748-9326/13/4/044004/media/ERL_044004_SD.pdf",
                      unit: "kg",
                      conversion: {
                        portion: {
                          kilograms: 0.06,
                          incrementStepSize: 1,
                          source: "https://www.yazio.com/en/foods/lychee.html",
                          "default": true
                        },
                        item: {
                          kilograms: 0.0096,
                          incrementStepSize: 1,
                          source: "https://www.yazio.com/en/foods/lychee.html"
                        }
                      },
                      displayName: "Lychee",
                      associatedPurchaseCategory: "Fruits and nuts (ND)"
                    },
                    Mandarin: {
                      icon: null,
                      intensityKilograms: 0.45,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      conversion: {
                        item: {
                          kilograms: 0.105,
                          incrementStepSize: 1,
                          source: "https://www.yazio.com/de/kalorientabelle/mandarine-frisch.html"
                        }
                      },
                      displayName: "Mandarin",
                      associatedPurchaseCategory: "Fruits and nuts (ND)"
                    },
                    Mango: {
                      icon: null,
                      intensityKilograms: 0.639,
                      source: "https://iopscience.iop.org/1748-9326/13/4/044004/media/ERL_044004_SD.pdf",
                      unit: "kg",
                      conversion: {
                        portion: {
                          kilograms: 0.168,
                          incrementStepSize: 1,
                          source: "https://www.yazio.com/en/foods/mango.html",
                          "default": true
                        },
                        item: {
                          kilograms: 0.336,
                          incrementStepSize: 1,
                          source: "https://www.yazio.com/en/foods/mango.html"
                        }
                      },
                      displayName: "Mango",
                      associatedPurchaseCategory: "Fruits and nuts (ND)"
                    },
                    Melons: {
                      icon: null,
                      intensityKilograms: 0.25,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      conversions: {
                        portion: {
                          kilograms: 0.151,
                          incrementStepSize: 1,
                          source: "https://www.who.int/dietphysicalactivity/publications/f&v_intake_measurement.pdf"
                        }
                      },
                      displayName: "Melons",
                      associatedPurchaseCategory: "Fruits and nuts (ND)"
                    },
                    Nectarines: {
                      icon: null,
                      intensityKilograms: 0.43,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      conversion: {
                        item: {
                          kilograms: 0.125,
                          incrementStepSize: 1,
                          source: "https://www.yazio.com/de/kalorientabelle/nektarine-frisch.html"
                        }
                      },
                      displayName: "Nectarines",
                      associatedPurchaseCategory: "Fruits and nuts (ND)"
                    },
                    Orange: {
                      icon: null,
                      intensityKilograms: 0.33,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      conversions: {
                        item: {
                          kilograms: 0.16,
                          incrementStepSize: 1,
                          source: "https://www.who.int/dietphysicalactivity/publications/f&v_intake_measurement.pdf"
                        }
                      },
                      displayName: "Orange",
                      associatedPurchaseCategory: "Fruits and nuts (ND)"
                    },
                    Papaya: {
                      icon: null,
                      intensityKilograms: 0.216,
                      source: "https://iopscience.iop.org/1748-9326/13/4/044004/media/ERL_044004_SD.pdf",
                      unit: "kg",
                      conversion: {
                        portion: {
                          kilograms: 0.125,
                          incrementStepSize: 1,
                          source: "https://www.yazio.com/en/foods/papaya.html",
                          "default": true
                        },
                        item: {
                          kilograms: 0.5,
                          incrementStepSize: 1,
                          source: "https://www.yazio.com/en/foods/papaya.html"
                        }
                      },
                      displayName: "Papaya",
                      associatedPurchaseCategory: "Fruits and nuts (ND)"
                    },
                    "Passion fruit": {
                      icon: null,
                      intensityKilograms: 1.663,
                      source: "https://iopscience.iop.org/1748-9326/13/4/044004/media/ERL_044004_SD.pdf",
                      unit: "kg",
                      conversion: {
                        item: {
                          kilograms: 0.0018,
                          incrementStepSize: 1,
                          source: "https://www.yazio.com/en/foods/passion-fruit.html"
                        }
                      },
                      displayName: "Passion fruit",
                      associatedPurchaseCategory: "Fruits and nuts (ND)"
                    },
                    Peaches: {
                      icon: null,
                      intensityKilograms: 0.43,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      conversions: {
                        item: {
                          kilograms: 0.12,
                          incrementStepSize: 1,
                          source: "https://www.who.int/dietphysicalactivity/publications/f&v_intake_measurement.pdf"
                        }
                      },
                      displayName: "Peaches",
                      associatedPurchaseCategory: "Fruits and nuts (ND)"
                    },
                    Pears: {
                      icon: null,
                      intensityKilograms: 0.31,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      conversions: {
                        item: {
                          kilograms: 0.16,
                          incrementStepSize: 1,
                          source: "https://www.who.int/dietphysicalactivity/publications/f&v_intake_measurement.pdf"
                        }
                      },
                      displayName: "Pears",
                      associatedPurchaseCategory: "Fruits and nuts (ND)"
                    },
                    Pineapples: {
                      icon: null,
                      intensityKilograms: 0.5,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      conversions: {
                        portion: {
                          kilograms: 0.08,
                          incrementStepSize: 1,
                          source: "https://www.who.int/dietphysicalactivity/publications/f&v_intake_measurement.pdf"
                        }
                      },
                      displayName: "Pineapples",
                      associatedPurchaseCategory: "Fruits and nuts (ND)"
                    },
                    Plum: {
                      icon: null,
                      intensityKilograms: 0.576,
                      source: "https://iopscience.iop.org/1748-9326/13/4/044004/media/ERL_044004_SD.pdf",
                      unit: "kg",
                      conversions: {
                        item: {
                          kilograms: 0.092,
                          incrementStepSize: 1,
                          source: "https://www.who.int/dietphysicalactivity/publications/f&v_intake_measurement.pdf"
                        }
                      },
                      displayName: "Plum",
                      associatedPurchaseCategory: "Fruits and nuts (ND)"
                    },
                    Pomegranate: {
                      icon: null,
                      intensityKilograms: 0.462,
                      source: "https://iopscience.iop.org/1748-9326/13/4/044004/media/ERL_044004_SD.pdf",
                      unit: "kg",
                      conversions: {
                        portion: {
                          kilograms: 0.141,
                          incrementStepSize: 1,
                          source: "https://www.yazio.com/en/foods/pomegranate.html",
                          "default": true
                        },
                        item: {
                          kilograms: 0.282,
                          incrementStepSize: 1,
                          source: "https://www.yazio.com/en/foods/pomegranate.html"
                        }
                      },
                      displayName: "Pomegranate",
                      associatedPurchaseCategory: "Fruits and nuts (ND)"
                    },
                    Pomelo: {
                      icon: null,
                      intensityKilograms: 0.51,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      conversion: {
                        portion: {
                          kilograms: 0.06,
                          incrementStepSize: 1,
                          source: "https://www.yazio.com/de/kalorientabelle/pomelo-frisch.html",
                          "default": true
                        },
                        item: {
                          kilograms: 0.12,
                          incrementStepSize: 1,
                          source: "https://www.yazio.com/de/kalorientabelle/pomelo-frisch.html"
                        }
                      },
                      displayName: "Pomelo",
                      associatedPurchaseCategory: "Fruits and nuts (ND)"
                    },
                    Prunes: {
                      icon: null,
                      intensityKilograms: 0.273,
                      source: "https://iopscience.iop.org/1748-9326/13/4/044004/media/ERL_044004_SD.pdf",
                      unit: "kg",
                      conversions: {
                        item: {
                          kilograms: 0.024,
                          incrementStepSize: 1,
                          source: "https://www.who.int/dietphysicalactivity/publications/f&v_intake_measurement.pdf"
                        }
                      },
                      displayName: "Prunes",
                      associatedPurchaseCategory: "Fruits and nuts (ND)"
                    },
                    Quinces: {
                      icon: null,
                      intensityKilograms: 0.31,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      conversion: {
                        item: {
                          kilograms: 0.092,
                          incrementStepSize: 1,
                          source: "https://www.yazio.com/de/kalorientabelle/quitte-frisch.html"
                        }
                      },
                      displayName: "Quinces",
                      associatedPurchaseCategory: "Fruits and nuts (ND)"
                    },
                    Raspberries: {
                      icon: null,
                      intensityKilograms: 0.84,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      conversions: {
                        portion: {
                          kilograms: 0.114,
                          incrementStepSize: 1,
                          source: "https://www.who.int/dietphysicalactivity/publications/f&v_intake_measurement.pdf"
                        }
                      },
                      displayName: "Raspberries",
                      associatedPurchaseCategory: "Fruits and nuts (ND)"
                    },
                    Rhubarb: {
                      icon: null,
                      intensityKilograms: 1.528,
                      source: "https://iopscience.iop.org/1748-9326/13/4/044004/media/ERL_044004_SD.pdf",
                      unit: "kg",
                      conversions: {
                        portion: {
                          kilograms: 0.09,
                          incrementStepSize: 1,
                          source: "https://www.who.int/dietphysicalactivity/publications/f&v_intake_measurement.pdf"
                        }
                      },
                      displayName: "Rhubarb",
                      associatedPurchaseCategory: "Fruits and nuts (ND)"
                    },
                    Strawberries: {
                      icon: null,
                      intensityKilograms: 0.58,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      conversions: {
                        portion: {
                          kilograms: 0.096,
                          incrementStepSize: 1,
                          source: "https://www.who.int/dietphysicalactivity/publications/f&v_intake_measurement.pdf"
                        }
                      },
                      displayName: "Strawberries",
                      associatedPurchaseCategory: "Fruits and nuts (ND)"
                    },
                    Tangerines: {
                      icon: null,
                      intensityKilograms: 0.51,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      conversion: {
                        item: {
                          kilograms: 0.105,
                          incrementStepSize: 1,
                          source: "https://www.yazio.com/de/kalorientabelle/mandarine-frisch.html"
                        }
                      },
                      displayName: "Tangerines",
                      associatedPurchaseCategory: "Fruits and nuts (ND)"
                    },
                    Vanilla: {
                      icon: null,
                      intensityKilograms: 13.71,
                      source: "http://assets.wwf.org.uk/downloads/how_low_report_1.pdf",
                      unit: "kg",
                      displayName: "Vanilla",
                      associatedPurchaseCategory: "Fruits and nuts (ND)"
                    },
                    Watermelon: {
                      icon: null,
                      intensityKilograms: 0.32,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      conversion: {
                        portion: {
                          kilograms: 0.15,
                          incrementStepSize: 1,
                          source: "https://www.yazio.com/de/kalorientabelle/wassermelone-frisch.html",
                          "default": true
                        },
                        item: {
                          kilograms: 2.5,
                          incrementStepSize: 1,
                          source: "https://www.yazio.com/de/kalorientabelle/wassermelone-frisch.html"
                        }
                      },
                      displayName: "Watermelon",
                      associatedPurchaseCategory: "Fruits and nuts (ND)"
                    }
                  },
                  icon: "lemon",
                  intensityKilograms: 0.52,
                  oldKeys: ["Fruit"],
                  source: "http://www.greeneatz.com/foods-carbon-footprint.html",
                  unit: "kg",
                  displayName: "Fruits",
                  associatedPurchaseCategory: "Fruits and nuts (ND)"
                },
                Nuts: {
                  _children: {
                    Almonds: {
                      icon: null,
                      intensityKilograms: 1.54,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      displayName: "Almonds"
                    },
                    "Cashew nut": {
                      icon: null,
                      intensityKilograms: 1.44,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      displayName: "Cashew nut"
                    },
                    Chestnuts: {
                      icon: null,
                      intensityKilograms: 0.43,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      displayName: "Chestnuts"
                    },
                    Hazelnuts: {
                      icon: null,
                      intensityKilograms: 0.97,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      displayName: "Hazelnuts"
                    },
                    "Macadamia nuts": {
                      icon: null,
                      intensityKilograms: 2.057,
                      source: "https://iopscience.iop.org/1748-9326/13/4/044004/media/ERL_044004_SD.pdf",
                      unit: "kg",
                      displayName: "Macadamia nuts"
                    },
                    "Pecan nuts": {
                      icon: null,
                      intensityKilograms: 2.057,
                      source: "https://iopscience.iop.org/1748-9326/13/4/044004/media/ERL_044004_SD.pdf",
                      unit: "kg",
                      displayName: "Pecan nuts"
                    },
                    "Peanut butter": {
                      icon: null,
                      intensityKilograms: 2.3,
                      source: "http://static.ewg.org/reports/2011/meateaters/pdf/methodology_ewg_meat_eaters_guide_to_health_and_climate_2011.pdf",
                      unit: "kg",
                      oldKeys: ["Peanut Butter"],
                      displayName: "Peanut butter"
                    },
                    Peanuts: {
                      icon: null,
                      intensityKilograms: 0.83,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      displayName: "Peanuts"
                    },
                    "Pine nuts": {
                      icon: null,
                      intensityKilograms: 2.057,
                      source: "https://iopscience.iop.org/1748-9326/13/4/044004/media/ERL_044004_SD.pdf",
                      unit: "kg",
                      displayName: "Pine nuts"
                    },
                    Pistachios: {
                      icon: null,
                      intensityKilograms: 1.53,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      displayName: "Pistachios"
                    },
                    Walnuts: {
                      icon: null,
                      intensityKilograms: 1.51,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      displayName: "Walnuts"
                    }
                  },
                  icon: "acorn",
                  intensityKilograms: 2.3,
                  source: "http://static.ewg.org/reports/2011/meateaters/pdf/methodology_ewg_meat_eaters_guide_to_health_and_climate_2011.pdf",
                  unit: "kg",
                  displayName: "Nuts",
                  associatedPurchaseCategory: "Fruits and nuts (ND)"
                }
              },
              coicopCode: "01.1.6",
              year: 2011,
              unit: "EUR",
              source: "https://github.com/tmrowco/bloom-contrib/tree/master/co2eq/purchase/exiobase",
              intensityKilograms: {
                AT: 0.19370289605367663,
                AU: 0.8611099568546641,
                BE: 0.5669969811014046,
                BG: 0.28199622352183107,
                BR: 0.3838871786509871,
                CA: 0.957569528826825,
                CH: 0.27189037749660055,
                CN: 0.44488996585462737,
                CY: 0.5172321247719786,
                CZ: 0.8503041670413641,
                DE: 0.3367672334810709,
                DK: 0.3686602348119587,
                EE: 0.5894849425790438,
                ES: 0.3572764949999683,
                FI: 0.30537020758048977,
                FR: 0.2954902567230915,
                GB: 0.30939642594176425,
                GR: 0.3036375199985826,
                HR: 0.20802484172348057,
                HU: 0.7254646448493757,
                ID: 0.22028264375625908,
                IE: 1.0393764746129033,
                IN: 0.5901287679040031,
                IT: 0.3775972145843141,
                JP: 0.3033274567633227,
                KR: 0.5029108740190356,
                LT: 0.48959102847358915,
                LU: 0.4804274323900829,
                LV: 0.31492040263787424,
                MT: 0.2869485942914488,
                MX: 0.3490053267138037,
                NL: 0.7456621752189408,
                NO: 0.7489103735597213,
                PL: 0.9090584384571325,
                PT: 0.5392768893875546,
                RO: 0.38003909900925237,
                RU: 0.7495445855596188,
                SE: 0.19394034155404624,
                SI: 0.4240334112984585,
                SK: 0.30070599598083514,
                TR: 0.42805564082630587,
                TW: 0.570522864705291,
                US: 0.24439855012863423,
                WA: 0.7638943727557526,
                WE: 1.2937904775082636,
                WF: 0.5183582453603165,
                WL: 0.3699193859305382,
                WM: 1.725160493190905,
                ZA: 2.0962066964898174
              },
              displayName: "Fruits and nuts"
            },
            "Vegetables, tubers, plantains, cooking bananas and pulses (ND)": {
              _children: {
                Vegetables: {
                  _children: {
                    Artichokes: {
                      icon: null,
                      intensityKilograms: 0.48,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      displayName: "Artichokes",
                      associatedPurchaseCategory: "Vegetables, tubers, plantains, cooking bananas and pulses (ND)"
                    },
                    Aspargus: {
                      icon: null,
                      intensityKilograms: 0.83,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      displayName: "Aspargus",
                      associatedPurchaseCategory: "Vegetables, tubers, plantains, cooking bananas and pulses (ND)"
                    },
                    "Basil (dried)": {
                      icon: null,
                      intensityKilograms: 2.495,
                      source: "https://iopscience.iop.org/1748-9326/13/4/044004/media/ERL_044004_SD.pdf",
                      unit: "kg",
                      displayName: "Basil (dried)",
                      associatedPurchaseCategory: "Vegetables, tubers, plantains, cooking bananas and pulses (ND)"
                    },
                    "Basil (fresh)": {
                      icon: null,
                      intensityKilograms: 0.221,
                      source: "https://iopscience.iop.org/1748-9326/13/4/044004/media/ERL_044004_SD.pdf",
                      unit: "kg",
                      displayName: "Basil (fresh)",
                      associatedPurchaseCategory: "Vegetables, tubers, plantains, cooking bananas and pulses (ND)"
                    },
                    Beetroot: {
                      icon: null,
                      intensityKilograms: 0.24,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      displayName: "Beetroot",
                      associatedPurchaseCategory: "Vegetables, tubers, plantains, cooking bananas and pulses (ND)"
                    },
                    Broccoli: {
                      icon: null,
                      intensityKilograms: 2,
                      source: "http://static.ewg.org/reports/2011/meateaters/pdf/methodology_ewg_meat_eaters_guide_to_health_and_climate_2011.pdf",
                      unit: "kg",
                      conversions: {
                        portion: {
                          kilograms: 0.054,
                          incrementStepSize: 1,
                          source: "https://www.who.int/dietphysicalactivity/publications/f&v_intake_measurement.pdf"
                        }
                      },
                      displayName: "Broccoli",
                      associatedPurchaseCategory: "Vegetables, tubers, plantains, cooking bananas and pulses (ND)"
                    },
                    "Brussels sprouts": {
                      icon: null,
                      intensityKilograms: 0.49,
                      source: "https://iopscience.iop.org/1748-9326/13/4/044004/media/ERL_044004_SD.pdf",
                      unit: "kg",
                      conversions: {
                        portion: {
                          kilograms: 0.056,
                          incrementStepSize: 1,
                          source: "https://www.who.int/dietphysicalactivity/publications/f&v_intake_measurement.pdf"
                        }
                      },
                      displayName: "Brussels sprouts",
                      associatedPurchaseCategory: "Vegetables, tubers, plantains, cooking bananas and pulses (ND)"
                    },
                    Carrots: {
                      icon: null,
                      intensityKilograms: 0.2,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      conversions: {
                        item: {
                          kilograms: 0.061,
                          incrementStepSize: 1,
                          source: "https://www.who.int/dietphysicalactivity/publications/f&v_intake_measurement.pdf"
                        }
                      },
                      displayName: "Carrots",
                      associatedPurchaseCategory: "Vegetables, tubers, plantains, cooking bananas and pulses (ND)"
                    },
                    Cabbage: {
                      icon: null,
                      intensityKilograms: 0.45,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      conversions: {
                        portion: {
                          kilograms: 0.09,
                          incrementStepSize: 1,
                          source: "https://www.who.int/dietphysicalactivity/publications/f&v_intake_measurement.pdf"
                        }
                      },
                      displayName: "Cabbage",
                      associatedPurchaseCategory: "Vegetables, tubers, plantains, cooking bananas and pulses (ND)"
                    },
                    Cauliflowers: {
                      icon: null,
                      intensityKilograms: 0.45,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      conversions: {
                        portion: {
                          kilograms: 0.06,
                          incrementStepSize: 1,
                          source: "https://www.who.int/dietphysicalactivity/publications/f&v_intake_measurement.pdf"
                        }
                      },
                      displayName: "Cauliflowers",
                      associatedPurchaseCategory: "Vegetables, tubers, plantains, cooking bananas and pulses (ND)"
                    },
                    Celery: {
                      icon: null,
                      intensityKilograms: 0.18,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      displayName: "Celery",
                      associatedPurchaseCategory: "Vegetables, tubers, plantains, cooking bananas and pulses (ND)"
                    },
                    Cilantro: {
                      icon: null,
                      intensityKilograms: 0.261,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      displayName: "Cilantro",
                      associatedPurchaseCategory: "Vegetables, tubers, plantains, cooking bananas and pulses (ND)"
                    },
                    Chive: {
                      icon: null,
                      intensityKilograms: 0.221,
                      source: "https://iopscience.iop.org/1748-9326/13/4/044004/media/ERL_044004_SD.pdf",
                      unit: "kg",
                      displayName: "Chive",
                      associatedPurchaseCategory: "Vegetables, tubers, plantains, cooking bananas and pulses (ND)"
                    },
                    Courgette: {
                      icon: null,
                      intensityKilograms: 0.21,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      conversions: {
                        portion: {
                          kilograms: 0.06,
                          incrementStepSize: 1,
                          source: "https://www.who.int/dietphysicalactivity/publications/f&v_intake_measurement.pdf"
                        }
                      },
                      displayName: "Courgette",
                      associatedPurchaseCategory: "Vegetables, tubers, plantains, cooking bananas and pulses (ND)"
                    },
                    Cucumbers: {
                      icon: null,
                      intensityKilograms: 0.23,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      conversions: {
                        portion: {
                          kilograms: 0.024,
                          incrementStepSize: 1,
                          source: "https://www.who.int/dietphysicalactivity/publications/f&v_intake_measurement.pdf"
                        }
                      },
                      displayName: "Cucumbers",
                      associatedPurchaseCategory: "Vegetables, tubers, plantains, cooking bananas and pulses (ND)"
                    },
                    Dill: {
                      icon: null,
                      intensityKilograms: 0.221,
                      source: "https://iopscience.iop.org/1748-9326/13/4/044004/media/ERL_044004_SD.pdf",
                      unit: "kg",
                      displayName: "Dill",
                      associatedPurchaseCategory: "Vegetables, tubers, plantains, cooking bananas and pulses (ND)"
                    },
                    Endive: {
                      icon: null,
                      intensityKilograms: 0.065,
                      source: "https://iopscience.iop.org/1748-9326/13/4/044004/media/ERL_044004_SD.pdf",
                      unit: "kg",
                      displayName: "Endive",
                      associatedPurchaseCategory: "Vegetables, tubers, plantains, cooking bananas and pulses (ND)"
                    },
                    Eggplants: {
                      icon: null,
                      intensityKilograms: 1.35,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      displayName: "Eggplants",
                      associatedPurchaseCategory: "Vegetables, tubers, plantains, cooking bananas and pulses (ND)"
                    },
                    Fennel: {
                      icon: null,
                      intensityKilograms: 0.48,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      displayName: "Fennel",
                      associatedPurchaseCategory: "Vegetables, tubers, plantains, cooking bananas and pulses (ND)"
                    },
                    Garlic: {
                      icon: null,
                      intensityKilograms: 0.57,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      displayName: "Garlic",
                      associatedPurchaseCategory: "Vegetables, tubers, plantains, cooking bananas and pulses (ND)"
                    },
                    "Green onion": {
                      icon: null,
                      intensityKilograms: 0.085,
                      source: "https://iopscience.iop.org/1748-9326/13/4/044004/media/ERL_044004_SD.pdf",
                      unit: "kg",
                      displayName: "Green onion",
                      associatedPurchaseCategory: "Vegetables, tubers, plantains, cooking bananas and pulses (ND)"
                    },
                    Ginger: {
                      icon: null,
                      intensityKilograms: 0.88,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      displayName: "Ginger",
                      associatedPurchaseCategory: "Vegetables, tubers, plantains, cooking bananas and pulses (ND)"
                    },
                    Horseradish: {
                      icon: null,
                      intensityKilograms: 0.88,
                      source: "https://iopscience.iop.org/1748-9326/13/4/044004/media/ERL_044004_SD.pdf",
                      unit: "kg",
                      displayName: "Horseradish",
                      associatedPurchaseCategory: "Vegetables, tubers, plantains, cooking bananas and pulses (ND)"
                    },
                    Kale: {
                      icon: null,
                      intensityKilograms: 0.193,
                      source: "https://iopscience.iop.org/1748-9326/13/4/044004/media/ERL_044004_SD.pdf",
                      unit: "kg",
                      displayName: "Kale",
                      associatedPurchaseCategory: "Vegetables, tubers, plantains, cooking bananas and pulses (ND)"
                    },
                    Leek: {
                      icon: null,
                      intensityKilograms: 0.45,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      conversions: {
                        portion: {
                          kilograms: 0.067,
                          incrementStepSize: 1,
                          source: "https://www.who.int/dietphysicalactivity/publications/f&v_intake_measurement.pdf"
                        }
                      },
                      displayName: "Leek",
                      associatedPurchaseCategory: "Vegetables, tubers, plantains, cooking bananas and pulses (ND)"
                    },
                    Lettuce: {
                      icon: null,
                      intensityKilograms: 0.22,
                      source: "https://iopscience.iop.org/1748-9326/13/4/044004/media/ERL_044004_SD.pdf",
                      unit: "kg",
                      conversions: {
                        portion: {
                          kilograms: 0.024,
                          incrementStepSize: 1,
                          source: "https://www.who.int/dietphysicalactivity/publications/f&v_intake_measurement.pdf"
                        }
                      },
                      displayName: "Lettuce",
                      associatedPurchaseCategory: "Vegetables, tubers, plantains, cooking bananas and pulses (ND)"
                    },
                    Mushrooms: {
                      icon: null,
                      intensityKilograms: 0.27,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      conversions: {
                        portion: {
                          kilograms: 0.04,
                          incrementStepSize: 1,
                          source: "https://www.who.int/dietphysicalactivity/publications/f&v_intake_measurement.pdf"
                        }
                      },
                      displayName: "Mushrooms",
                      associatedPurchaseCategory: "Vegetables, tubers, plantains, cooking bananas and pulses (ND)"
                    },
                    Nutmeg: {
                      icon: null,
                      intensityKilograms: 4.82,
                      source: "http://assets.wwf.org.uk/downloads/how_low_report_1.pdf",
                      unit: "kg",
                      displayName: "Nutmeg",
                      associatedPurchaseCategory: "Vegetables, tubers, plantains, cooking bananas and pulses (ND)"
                    },
                    Olives: {
                      icon: null,
                      intensityKilograms: 0.63,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      displayName: "Olives",
                      associatedPurchaseCategory: "Vegetables, tubers, plantains, cooking bananas and pulses (ND)"
                    },
                    "Olive (oil)": {
                      icon: null,
                      intensityKilograms: 3.206,
                      source: "https://iopscience.iop.org/1748-9326/13/4/044004/media/ERL_044004_SD.pdf",
                      unit: "kg",
                      displayName: "Olive (oil)",
                      associatedPurchaseCategory: "Vegetables, tubers, plantains, cooking bananas and pulses (ND)"
                    },
                    Onion: {
                      icon: null,
                      intensityKilograms: 0.17,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      conversions: {
                        portion: {
                          kilograms: 0.046,
                          incrementStepSize: 1,
                          source: "https://www.who.int/dietphysicalactivity/publications/f&v_intake_measurement.pdf"
                        }
                      },
                      displayName: "Onion",
                      associatedPurchaseCategory: "Vegetables, tubers, plantains, cooking bananas and pulses (ND)"
                    },
                    Parsley: {
                      icon: null,
                      intensityKilograms: 0.232,
                      source: "https://iopscience.iop.org/1748-9326/13/4/044004/media/ERL_044004_SD.pdf",
                      unit: "kg",
                      displayName: "Parsley",
                      associatedPurchaseCategory: "Vegetables, tubers, plantains, cooking bananas and pulses (ND)"
                    },
                    Parsnip: {
                      icon: null,
                      intensityKilograms: 0.243,
                      source: "https://iopscience.iop.org/1748-9326/13/4/044004/media/ERL_044004_SD.pdf",
                      unit: "kg",
                      conversions: {
                        portion: {
                          kilograms: 0.042,
                          incrementStepSize: 1,
                          source: "https://www.who.int/dietphysicalactivity/publications/f&v_intake_measurement.pdf"
                        }
                      },
                      displayName: "Parsnip",
                      associatedPurchaseCategory: "Vegetables, tubers, plantains, cooking bananas and pulses (ND)"
                    },
                    Peppers: {
                      icon: null,
                      intensityKilograms: 0.66,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      conversions: {
                        portion: {
                          kilograms: 0.02,
                          incrementStepSize: 1,
                          source: "https://www.who.int/dietphysicalactivity/publications/f&v_intake_measurement.pdf"
                        }
                      },
                      displayName: "Peppers",
                      associatedPurchaseCategory: "Vegetables, tubers, plantains, cooking bananas and pulses (ND)"
                    },
                    Potatoes: {
                      icon: null,
                      intensityKilograms: 0.18,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      displayName: "Potatoes",
                      associatedPurchaseCategory: "Vegetables, tubers, plantains, cooking bananas and pulses (ND)"
                    },
                    Pumpkins: {
                      icon: null,
                      intensityKilograms: 0.25,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      displayName: "Pumpkins",
                      associatedPurchaseCategory: "Vegetables, tubers, plantains, cooking bananas and pulses (ND)"
                    },
                    Rutabage: {
                      icon: null,
                      intensityKilograms: 0.29,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      conversions: {
                        portion: {
                          kilograms: 0.047,
                          incrementStepSize: 1,
                          source: "https://www.who.int/dietphysicalactivity/publications/f&v_intake_measurement.pdf"
                        }
                      },
                      displayName: "Rutabage",
                      associatedPurchaseCategory: "Vegetables, tubers, plantains, cooking bananas and pulses (ND)"
                    },
                    Scallion: {
                      icon: null,
                      intensityKilograms: 0.085,
                      source: "https://iopscience.iop.org/1748-9326/13/4/044004/media/ERL_044004_SD.pdf",
                      unit: "kg",
                      displayName: "Scallion",
                      associatedPurchaseCategory: "Vegetables, tubers, plantains, cooking bananas and pulses (ND)"
                    },
                    Shallot: {
                      icon: null,
                      intensityKilograms: 0.275,
                      source: "https://iopscience.iop.org/1748-9326/13/4/044004/media/ERL_044004_SD.pdf",
                      unit: "kg",
                      displayName: "Shallot",
                      associatedPurchaseCategory: "Vegetables, tubers, plantains, cooking bananas and pulses (ND)"
                    },
                    Spinach: {
                      icon: null,
                      intensityKilograms: 0.54,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      conversions: {
                        portion: {
                          kilograms: 0.097,
                          incrementStepSize: 1,
                          source: "https://www.who.int/dietphysicalactivity/publications/f&v_intake_measurement.pdf"
                        }
                      },
                      displayName: "Spinach",
                      associatedPurchaseCategory: "Vegetables, tubers, plantains, cooking bananas and pulses (ND)"
                    },
                    "Sweet potatoes": {
                      icon: null,
                      intensityKilograms: 0.302,
                      source: "https://iopscience.iop.org/1748-9326/13/4/044004/media/ERL_044004_SD.pdf",
                      unit: "kg",
                      displayName: "Sweet potatoes",
                      associatedPurchaseCategory: "Vegetables, tubers, plantains, cooking bananas and pulses (ND)"
                    },
                    Tomatoes: {
                      icon: null,
                      intensityKilograms: 0.45,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      conversions: {
                        item: {
                          kilograms: 0.085,
                          incrementStepSize: 1,
                          source: "https://www.who.int/dietphysicalactivity/publications/f&v_intake_measurement.pdf"
                        }
                      },
                      displayName: "Tomatoes",
                      associatedPurchaseCategory: "Vegetables, tubers, plantains, cooking bananas and pulses (ND)"
                    },
                    "Tomatoe ketchup": {
                      icon: null,
                      intensityKilograms: 0.747,
                      source: "https://link.springer.com/article/10.1007/s11367-018-1460-x#MOESM1",
                      unit: "kg",
                      displayName: "Tomatoe ketchup",
                      associatedPurchaseCategory: "Vegetables, tubers, plantains, cooking bananas and pulses (ND)"
                    },
                    Turmeric: {
                      icon: null,
                      intensityKilograms: 0.213,
                      source: "https://iopscience.iop.org/1748-9326/13/4/044004/media/ERL_044004_SD.pdf",
                      unit: "kg",
                      displayName: "Turmeric",
                      associatedPurchaseCategory: "Vegetables, tubers, plantains, cooking bananas and pulses (ND)"
                    },
                    "Vegetable oil": {
                      icon: null,
                      intensityKilograms: 3.74,
                      source: "https://link.springer.com/article/10.1007/s11367-018-1460-x#MOESM1",
                      unit: "kg",
                      displayName: "Vegetable oil",
                      associatedPurchaseCategory: "Vegetables, tubers, plantains, cooking bananas and pulses (ND)"
                    },
                    Vinegar: {
                      icon: null,
                      intensityKilograms: 1.327,
                      source: "https://link.springer.com/article/10.1007/s11367-018-1460-x#MOESM1",
                      unit: "kg",
                      displayName: "Vinegar",
                      associatedPurchaseCategory: "Vegetables, tubers, plantains, cooking bananas and pulses (ND)"
                    },
                    Zucchini: {
                      icon: null,
                      intensityKilograms: 0.21,
                      source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
                      unit: "kg",
                      conversions: {
                        portion: {
                          kilograms: 0.06,
                          incrementStepSize: 1,
                          source: "https://www.who.int/dietphysicalactivity/publications/f&v_intake_measurement.pdf"
                        }
                      },
                      displayName: "Zucchini",
                      associatedPurchaseCategory: "Vegetables, tubers, plantains, cooking bananas and pulses (ND)"
                    }
                  },
                  icon: "carrot",
                  intensityKilograms: 1.32,
                  source: "https://orbit.dtu.dk/ws/files/110722384/Climate_friendly_dietary_guidelines.pdf",
                  unit: "kg",
                  displayName: "Vegetables",
                  associatedPurchaseCategory: "Vegetables, tubers, plantains, cooking bananas and pulses (ND)"
                }
              },
              coicopCode: "01.1.7",
              year: 2011,
              unit: "EUR",
              source: "https://github.com/tmrowco/bloom-contrib/tree/master/co2eq/purchase/exiobase",
              intensityKilograms: {
                AT: 0.19370289605367663,
                AU: 0.8611099568546641,
                BE: 0.5669969811014046,
                BG: 0.28199622352183107,
                BR: 0.3838871786509871,
                CA: 0.957569528826825,
                CH: 0.27189037749660055,
                CN: 0.44488996585462737,
                CY: 0.5172321247719786,
                CZ: 0.8503041670413641,
                DE: 0.3367672334810709,
                DK: 0.3686602348119587,
                EE: 0.5894849425790438,
                ES: 0.3572764949999683,
                FI: 0.30537020758048977,
                FR: 0.2954902567230915,
                GB: 0.30939642594176425,
                GR: 0.3036375199985826,
                HR: 0.20802484172348057,
                HU: 0.7254646448493757,
                ID: 0.22028264375625908,
                IE: 1.0393764746129033,
                IN: 0.5901287679040031,
                IT: 0.3775972145843141,
                JP: 0.3033274567633227,
                KR: 0.5029108740190356,
                LT: 0.48959102847358915,
                LU: 0.4804274323900829,
                LV: 0.31492040263787424,
                MT: 0.2869485942914488,
                MX: 0.3490053267138037,
                NL: 0.7456621752189408,
                NO: 0.7489103735597213,
                PL: 0.9090584384571325,
                PT: 0.5392768893875546,
                RO: 0.38003909900925237,
                RU: 0.7495445855596188,
                SE: 0.19394034155404624,
                SI: 0.4240334112984585,
                SK: 0.30070599598083514,
                TR: 0.42805564082630587,
                TW: 0.570522864705291,
                US: 0.24439855012863423,
                WA: 0.7638943727557526,
                WE: 1.2937904775082636,
                WF: 0.5183582453603165,
                WL: 0.3699193859305382,
                WM: 1.725160493190905,
                ZA: 2.0962066964898174
              },
              displayName: "Vegetables, tubers, plantains, cooking bananas and pulses"
            },
            "Sugar, confectionery and desserts (ND)": {
              _children: {
                Chocolate: {
                  icon: null,
                  intensityKilograms: 11.25,
                  source: "https://iopscience.iop.org/1748-9326/13/4/044004/media/ERL_044004_SD.pdf",
                  unit: "kg",
                  displayName: "Chocolate",
                  associatedPurchaseCategory: "Sugar, confectionery and desserts (ND)"
                },
                "Cocoa powder": {
                  icon: null,
                  intensityKilograms: 33.647,
                  source: "https://iopscience.iop.org/1748-9326/13/4/044004/media/ERL_044004_SD.pdf",
                  unit: "kg",
                  displayName: "Cocoa powder",
                  associatedPurchaseCategory: "Sugar, confectionery and desserts (ND)"
                },
                Honey: {
                  icon: null,
                  intensityKilograms: 2.44,
                  source: "https://iopscience.iop.org/1748-9326/13/4/044004/media/ERL_044004_SD.pdf",
                  unit: "kg",
                  displayName: "Honey",
                  associatedPurchaseCategory: "Sugar, confectionery and desserts (ND)"
                },
                "Maple syrup": {
                  icon: null,
                  intensityKilograms: 6.754,
                  source: "https://iopscience.iop.org/1748-9326/13/4/044004/media/ERL_044004_SD.pdf",
                  unit: "kg",
                  conversions: {
                    L: {
                      kilograms: 1.34,
                      incrementStepSize: 0.05,
                      source: "http://convert-to.com/571/maple-syrup-amounts-conversion-plus-nutritional-facts.html"
                    }
                  },
                  displayName: "Maple syrup",
                  associatedPurchaseCategory: "Sugar, confectionery and desserts (ND)"
                },
                "Sugar (sugarcane)": {
                  icon: null,
                  intensityKilograms: 0.7,
                  source: "https://iopscience.iop.org/1748-9326/13/4/044004/media/ERL_044004_SD.pdf",
                  unit: "kg",
                  displayName: "Sugar (sugarcane)",
                  associatedPurchaseCategory: "Sugar, confectionery and desserts (ND)"
                },
                "Sugar (beet)": {
                  icon: null,
                  intensityKilograms: 0.391,
                  source: "https://iopscience.iop.org/1748-9326/13/4/044004/media/ERL_044004_SD.pdf",
                  unit: "kg",
                  displayName: "Sugar (beet)",
                  associatedPurchaseCategory: "Sugar, confectionery and desserts (ND)"
                }
              },
              coicopCode: "01.1.8",
              year: 2011,
              unit: "EUR",
              source: "https://github.com/tmrowco/bloom-contrib/tree/master/co2eq/purchase/exiobase",
              intensityKilograms: {
                AT: 0.6126820350688966,
                AU: 1.1273580389252886,
                BE: 0.7736253828938126,
                BG: 0.7023541658821603,
                BR: 1.7723194195425156,
                CA: 1.1525174575781463,
                CH: 0.846546445810762,
                CN: 3.2855984854618936,
                CY: 1.3527265195620373,
                CZ: 1.201962251715131,
                DE: 0.7698771637583146,
                DK: 1.0737339922749767,
                EE: 1.732237527585948,
                ES: 0.6649974423246919,
                FI: 0.5601605836044671,
                FR: 0.7463143015389642,
                GB: 0.8265592017927148,
                GR: 1.0967506597652679,
                HR: 0.788292950195089,
                HU: 1.0697687409234573,
                ID: 1.6971735836241655,
                IE: 1.2814869145498549,
                IN: 2.6173636336142074,
                IT: 0.783138263573042,
                JP: 1.5274231857999168,
                KR: 0.9284417918040944,
                LT: 0.9821875951606462,
                LU: 1.4230083175186798,
                LV: 1.328971008302523,
                MT: 0.45303363560190724,
                MX: 1.860417834684693,
                NL: 0.9442219523796033,
                NO: 1.0593629025865023,
                PL: 0.7984976111579608,
                PT: 0.7514868383693774,
                RO: 0.7595161287306977,
                RU: 2.0202395924785743,
                SE: 0.5940909174813171,
                SI: 0.5393775324377656,
                SK: 0.8371559886368136,
                TR: 1.841001590973744,
                TW: 1.6614532199180512,
                US: 4.284729823692803,
                WA: 3.317908358240258,
                WE: 5.05720785382447,
                WF: 6.254862033725241,
                WL: 2.4801793071978953,
                WM: 2.043758066770188,
                ZA: 1.9262341788067288
              },
              displayName: "Sugar, confectionery and desserts"
            },
            "Ready-made food and other food products n.e.c. (ND)": {
              _children: {
                Yeast: {
                  icon: null,
                  intensityKilograms: 0.96,
                  source: "https://link.springer.com/article/10.1007/s11367-018-1460-x#MOESM1",
                  unit: "kg",
                  displayName: "Yeast",
                  associatedPurchaseCategory: "Ready-made food and other food products n.e.c. (ND)"
                },
                "Baking soda": {
                  icon: null,
                  intensityKilograms: 0.0261,
                  source: "https://epdturkey.org/wp-content/uploads/eti_soda_iso_14025.pdf",
                  unit: "kg",
                  displayName: "Baking soda",
                  associatedPurchaseCategory: "Ready-made food and other food products n.e.c. (ND)"
                },
                Salt: {
                  icon: null,
                  intensityKilograms: 0.3,
                  source: "https://link.springer.com/article/10.1007/s11367-018-1460-x#MOESM1",
                  unit: "kg",
                  displayName: "Salt",
                  associatedPurchaseCategory: "Ready-made food and other food products n.e.c. (ND)"
                }
              },
              coicopCode: "01.1.9",
              year: 2011,
              unit: "EUR",
              source: "https://github.com/tmrowco/bloom-contrib/tree/master/co2eq/purchase/exiobase",
              intensityKilograms: {
                AT: 0.5307511843417203,
                AU: 0.7578693364698058,
                BE: 0.6571424945437677,
                BG: 0.7827032902525378,
                BR: 0.7108502568989945,
                CA: 0.6906977888826303,
                CH: 0.26798692947171315,
                CN: 1.2383064932678933,
                CY: 0.918250989493971,
                CZ: 0.9633504634838319,
                DE: 0.6266961893356369,
                DK: 0.8135589745198186,
                EE: 1.5603330751040618,
                ES: 0.4820883599138695,
                FI: 0.40272728449053735,
                FR: 0.5197097066237198,
                GB: 0.5455024852909219,
                GR: 0.8141565510527476,
                HR: 0.7414063915958243,
                HU: 0.9138043969824254,
                ID: 0.5886533008170447,
                IE: 0.7304324876356948,
                IN: 1.0463242680446836,
                IT: 0.5905913225662631,
                JP: 0.6155158740226323,
                KR: 0.8849412539846327,
                LT: 1.3256742149313232,
                LU: 1.3715635055369118,
                LV: 1.0812856113640463,
                MT: 0.4986270485238546,
                MX: 0.6736154847978338,
                NL: 0.7229645625649875,
                NO: 0.5153622767206141,
                PL: 1.0696490630601418,
                PT: 0.6745324642532483,
                RO: 0.5733555826857216,
                RU: 0.6390292879306094,
                SE: 0.28364438847060497,
                SI: 0.8725363001521027,
                SK: 0.8072992584637001,
                TR: 0.7662185489302121,
                TW: 0.78832298600261,
                US: 0.7432390916856488,
                WA: 1.0914068578493248,
                WE: 1.5288577455853256,
                WF: 1.7380119856233114,
                WL: 1.209105685669322,
                WM: 1.3532923105777563,
                ZA: 2.906846068253027
              },
              displayName: "Ready-made food and other food products n.e.c."
            }
          },
          year: 2011,
          unit: "EUR",
          source: "https://github.com/tmrowco/bloom-contrib/tree/master/co2eq/purchase/exiobase",
          intensityKilograms: {
            AT: 0.5407268278791255,
            AU: 1.0117255705608155,
            BE: 0.748767280015698,
            BG: 0.71082533163579,
            BR: 1.679856759846935,
            CA: 1.074040164315549,
            CH: 0.5231905479841317,
            CN: 2.391916959301301,
            CY: 1.0056955182825729,
            CZ: 0.976247351765382,
            DE: 0.658410941077094,
            DK: 0.8299242788871928,
            EE: 1.4189161385452635,
            ES: 0.5843078468373046,
            FI: 0.5076748397600044,
            FR: 0.6342850557120092,
            GB: 0.6145712466884062,
            GR: 0.8407909795337124,
            HR: 0.6578781290957287,
            HU: 0.9030700910760571,
            ID: 1.0593532632891647,
            IE: 1.0396094274620962,
            IN: 1.9344652880107587,
            IT: 0.6239722989075285,
            JP: 0.832540198994504,
            KR: 0.8595418180969248,
            LT: 1.900242391862426,
            LU: 1.2190796568202182,
            LV: 1.3818035437376597,
            MT: 0.4520673698670759,
            MX: 1.5295461988466286,
            NL: 0.8102894442042542,
            NO: 0.7541681421725377,
            PL: 1.0099599055857071,
            PT: 0.798317236187101,
            RO: 0.700204398789174,
            RU: 1.1017877587390725,
            SE: 0.415877725096185,
            SI: 0.7098224329255561,
            SK: 0.8800658803970101,
            TR: 1.0703528428459088,
            TW: 0.9362888457736139,
            US: 1.6253281586228525,
            WA: 1.793426301926004,
            WE: 2.703310521143449,
            WF: 3.0973931673815813,
            WL: 1.6101132059924514,
            WM: 1.6932048240757511,
            ZA: 2.336215380140349
          },
          displayName: "Food"
        },
        "NON-ALCOHOLIC BEVERAGES": {
          _children: {
            "Almond milk": {
              icon: "glass",
              intensityKilograms: 0.42,
              source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
              unit: "kg",
              conversions: {
                glass: {
                  kilograms: 0.225,
                  incrementStepSize: 1
                }
              },
              displayName: "Almond milk",
              associatedPurchaseCategory: "NON-ALCOHOLIC BEVERAGES"
            },
            "Coconut milk": {
              icon: "glass",
              intensityKilograms: 0.42,
              source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
              unit: "kg",
              conversions: {
                glass: {
                  kilograms: 0.225,
                  incrementStepSize: 1
                }
              },
              displayName: "Coconut milk",
              associatedPurchaseCategory: "NON-ALCOHOLIC BEVERAGES"
            },
            Coffee: {
              icon: "coffee",
              intensityKilograms: 0.33,
              source: "http://web.agrsci.dk/djfpublikation/djfpdf/DCArapport158.pdf",
              unit: "kg",
              conversions: {
                cup: {
                  kilograms: 0.15,
                  incrementStepSize: 1
                }
              },
              displayName: "Coffee",
              associatedPurchaseCategory: "NON-ALCOHOLIC BEVERAGES"
            },
            Juice: {
              icon: "glass",
              intensityKilograms: 0.93,
              source: "http://web.agrsci.dk/djfpublikation/djfpdf/DCArapport158.pdf",
              unit: "kg",
              conversions: {
                glass: {
                  kilograms: 0.225,
                  incrementStepSize: 1
                }
              },
              displayName: "Juice",
              associatedPurchaseCategory: "NON-ALCOHOLIC BEVERAGES"
            },
            "Soft drink": {
              icon: "glass",
              intensityKilograms: 1.035,
              source: "http://web.agrsci.dk/djfpublikation/djfpdf/DCArapport158.pdf",
              unit: "kg",
              conversions: {
                glass: {
                  kilograms: 0.225,
                  incrementStepSize: 1
                }
              },
              displayName: "Soft drink",
              associatedPurchaseCategory: "NON-ALCOHOLIC BEVERAGES"
            },
            "Soy milk": {
              icon: "glass",
              intensityKilograms: 0.75,
              source: "https://www.sciencedirect.com/science/article/pii/S0959652616303584",
              unit: "kg",
              conversions: {
                glass: {
                  kilograms: 0.225,
                  incrementStepSize: 1
                }
              },
              displayName: "Soy milk",
              associatedPurchaseCategory: "NON-ALCOHOLIC BEVERAGES"
            },
            Tea: {
              icon: "coffee",
              intensityKilograms: 0.184,
              source: "http://web.agrsci.dk/djfpublikation/djfpdf/DCArapport158.pdf",
              unit: "kg",
              conversions: {
                cup: {
                  kilograms: 0.15,
                  incrementStepSize: 1
                }
              },
              displayName: "Tea",
              associatedPurchaseCategory: "NON-ALCOHOLIC BEVERAGES"
            },
            "Water (bottled)": {
              icon: "glass",
              intensityKilograms: 0.215,
              source: "http://web.agrsci.dk/djfpublikation/djfpdf/DCArapport158.pdf",
              unit: "kg",
              conversions: {
                glass: {
                  kilograms: 0.225,
                  incrementStepSize: 1
                }
              },
              displayName: "Water (bottled)",
              associatedPurchaseCategory: "NON-ALCOHOLIC BEVERAGES"
            },
            "Water (tap)": {
              icon: "glass",
              intensityKilograms: 0.001,
              source: "http://web.agrsci.dk/djfpublikation/djfpdf/DCArapport158.pdf",
              unit: "kg",
              conversions: {
                glass: {
                  kilograms: 0.225,
                  incrementStepSize: 1
                }
              },
              displayName: "Water (tap)",
              associatedPurchaseCategory: "NON-ALCOHOLIC BEVERAGES"
            }
          },
          coicopCode: "01.2",
          year: 2011,
          unit: "EUR",
          source: "https://github.com/tmrowco/bloom-contrib/tree/master/co2eq/purchase/exiobase",
          intensityKilograms: {
            AT: 0.4732692141066177,
            AU: 0.5982950629919985,
            BE: 0.5596203061793769,
            BG: 0.7036451156842851,
            BR: 0.4944338375879135,
            CA: 0.49917131766520506,
            CH: 0.2454659168135893,
            CN: 1.3468525888791105,
            CY: 0.8974388467248182,
            CZ: 0.8425858643474885,
            DE: 0.5749117505545319,
            DK: 0.6967085628784565,
            EE: 1.3140618487167322,
            ES: 0.47038763588340016,
            FI: 0.3710987330329958,
            FR: 0.4586835580872408,
            GB: 0.44238703359761267,
            GR: 0.6030354541937285,
            HR: 1.0560384144362034,
            HU: 0.8218041407136095,
            ID: 0.7019193945144384,
            IE: 0.5794624125758518,
            IN: 1.4073983442534546,
            IT: 0.4933707726549671,
            JP: 0.44284784464325566,
            KR: 0.7460210602377246,
            LT: 0.9362393641216946,
            LU: 1.057040579499641,
            LV: 0.8402462018755568,
            MT: 0.5242857225297409,
            MX: 0.6544739732540766,
            NL: 0.6653278936541067,
            NO: 0.3914318021289691,
            PL: 0.8605801438809868,
            PT: 0.5970425898062914,
            RO: 0.542272053166467,
            RU: 0.5478611192225181,
            SE: 0.26384108758934566,
            SI: 0.6834031426080678,
            SK: 0.7289731220209033,
            TR: 0.6729902757993014,
            TW: 0.7504665335086983,
            US: 0.6802822495458901,
            WA: 1.173456107467512,
            WE: 1.480603562110953,
            WF: 1.1268618640557126,
            WL: 0.8551576286106815,
            WM: 1.2659827120884126,
            ZA: 1.651660390067799
          },
          displayName: "Non-alcoholic beverages"
        }
      },
      displayName: "Food and non-alcoholic beverages"
    },
    "Alcoholic beverages, tobacco and narcotics": {
      _children: {
        "ALCOHOLIC BEVERAGES": {
          _children: {
            Beer: {
              icon: null,
              intensityKilograms: 1.123,
              source: "http://web.agrsci.dk/djfpublikation/djfpdf/DCArapport158.pdf",
              unit: "kg",
              conversions: {
                glass: {
                  kilograms: 0.285,
                  incrementStepSize: 1
                }
              },
              displayName: "Beer",
              associatedPurchaseCategory: "ALCOHOLIC BEVERAGES"
            },
            Wine: {
              icon: "wine-glass-alt",
              intensityKilograms: 2.344,
              source: "http://web.agrsci.dk/djfpublikation/djfpdf/DCArapport158.pdf",
              unit: "kg",
              conversions: {
                glass: {
                  kilograms: 0.15,
                  incrementStepSize: 1
                }
              },
              displayName: "Wine",
              associatedPurchaseCategory: "ALCOHOLIC BEVERAGES"
            },
            Spirits: {
              icon: "glass-whiskey-rocks",
              intensityKilograms: 3.144,
              source: "http://web.agrsci.dk/djfpublikation/djfpdf/DCArapport158.pdf",
              unit: "kg",
              conversions: {
                glass: {
                  kilograms: 0.035,
                  incrementStepSize: 1
                }
              },
              displayName: "Spirits",
              associatedPurchaseCategory: "ALCOHOLIC BEVERAGES"
            }
          },
          icon: "wine-bottle",
          intensityKilograms: {
            AT: 0.4732692141066177,
            AU: 0.5982950629919985,
            BE: 0.5596203061793769,
            BG: 0.7036451156842851,
            BR: 0.4944338375879135,
            CA: 0.49917131766520506,
            CH: 0.2454659168135893,
            CN: 1.3468525888791105,
            CY: 0.8974388467248182,
            CZ: 0.8425858643474885,
            DE: 0.5749117505545319,
            DK: 0.6967085628784565,
            EE: 1.3140618487167322,
            ES: 0.47038763588340016,
            FI: 0.3710987330329958,
            FR: 0.4586835580872408,
            GB: 0.44238703359761267,
            GR: 0.6030354541937285,
            HR: 1.0560384144362034,
            HU: 0.8218041407136095,
            ID: 0.7019193945144384,
            IE: 0.5794624125758518,
            IN: 1.4073983442534546,
            IT: 0.4933707726549671,
            JP: 0.44284784464325566,
            KR: 0.7460210602377246,
            LT: 0.9362393641216946,
            LU: 1.057040579499641,
            LV: 0.8402462018755568,
            MT: 0.5242857225297409,
            MX: 0.6544739732540766,
            NL: 0.6653278936541067,
            NO: 0.3914318021289691,
            PL: 0.8605801438809868,
            PT: 0.5970425898062914,
            RO: 0.542272053166467,
            RU: 0.5478611192225181,
            SE: 0.26384108758934566,
            SI: 0.6834031426080678,
            SK: 0.7289731220209033,
            TR: 0.6729902757993014,
            TW: 0.7504665335086983,
            US: 0.6802822495458901,
            WA: 1.173456107467512,
            WE: 1.480603562110953,
            WF: 1.1268618640557126,
            WL: 0.8551576286106815,
            WM: 1.2659827120884126,
            ZA: 1.651660390067799
          },
          oldKeys: ["PURCHASE_CATEGORY_ENTERTAINMENT_LIQUOR_STORE", "Liquor Store", "Liquor store"],
          source: "https://github.com/tmrowco/bloom-contrib/tree/master/co2eq/purchase/exiobase",
          unit: "EUR",
          coicopCode: "02.1",
          year: 2011,
          displayName: "Alcoholic beverages",
          keywords: ["beer", "wine", "pastis", "vodka", "gin"]
        },
        TOBACCO: {
          icon: "smoking",
          intensityKilograms: {
            AT: 0.3960083585576218,
            AU: 0.7683541009074837,
            BE: 0.44399054431216184,
            BG: 0.692410699723781,
            BR: 0.44730457202390794,
            CA: 0.20966197556437272,
            CH: 0.224973909152222,
            CN: 1.98256546531643,
            CY: 0.4335260908557555,
            CZ: 0.7554379106982841,
            DE: 0.4995808550830453,
            DK: 0.314936063916008,
            ES: 0.3580722563818576,
            FR: 0.20239103335804878,
            GB: 0.536294533119958,
            GR: 0.5410575094447847,
            HR: 0.8072810785958849,
            HU: 0.5452043120067195,
            ID: 0.34306579348711075,
            IN: 1.0335797621889724,
            IT: 0.29520596791825626,
            JP: 0.02677969363607613,
            KR: 0.5699036650577667,
            LT: 0.7461632852457891,
            LU: 0.6796305379323428,
            LV: 0.18268888894687502,
            MT: 0.2645423099164805,
            MX: 0.6898507196276924,
            NL: 0.3021961812499431,
            NO: 0.6644579211514196,
            PL: 0.4910568639709221,
            PT: 0.5474819741092538,
            RO: 1.7025723966523787,
            RU: 0.7965045822293889,
            SK: 0.7378440301878315,
            TR: 0.40328716708185247,
            TW: 0.3804715353129639,
            US: 0.2127546452194046,
            WA: 2.1183167804058374,
            WE: 2.3549159107923154,
            WF: 1.3585977378364145,
            WL: 0.6903516629184402,
            WM: 0.8859777098701731,
            ZA: 0.13487787210709207
          },
          oldKeys: ["PURCHASE_CATEGORY_ENTERTAINMENT_CIGAR_STORES", "Tobacco store"],
          source: "https://github.com/tmrowco/bloom-contrib/tree/master/co2eq/purchase/exiobase",
          unit: "EUR",
          coicopCode: "02.3",
          year: 2011,
          displayName: "Tobacco"
        }
      },
      displayName: "Alcoholic beverages, tobacco and narcotics"
    },
    "CLOTHING AND FOOTWEAR": {
      _children: {
        CLOTHING: {
          _children: {
            "Shirt (viscose)": {
              icon: "tshirt",
              intensityKilograms: 12,
              source: "https://www.ademe.fr/sites/default/files/assets/documents/poids_carbone-biens-equipement-201809-rapport.pdf",
              unit: "item",
              usage: "25%",
              displayName: "Shirt (viscose)",
              associatedPurchaseCategory: "CLOTHING"
            },
            "Shirt (cotton)": {
              icon: "tshirt",
              intensityKilograms: 13,
              source: "https://www.ademe.fr/sites/default/files/assets/documents/poids_carbone-biens-equipement-201809-rapport.pdf",
              unit: "item",
              usage: "23.1%",
              displayName: "Shirt (cotton)",
              associatedPurchaseCategory: "CLOTHING"
            },
            Jeans: {
              icon: "tshirt",
              intensityKilograms: 25,
              source: "https://www.ademe.fr/sites/default/files/assets/documents/poids_carbone-biens-equipement-201809-rapport.pdf",
              unit: "item",
              usage: "20%",
              displayName: "Jeans",
              associatedPurchaseCategory: "CLOTHING"
            },
            "T-shirt (cotton)": {
              icon: "tshirt",
              intensityKilograms: 7,
              source: "https://www.ademe.fr/sites/default/files/assets/documents/poids_carbone-biens-equipement-201809-rapport.pdf",
              unit: "item",
              usage: "42.9%",
              displayName: "T-shirt (cotton)",
              associatedPurchaseCategory: "CLOTHING"
            },
            "T-shirt (polyester)": {
              icon: "tshirt",
              intensityKilograms: 6,
              source: "https://www.ademe.fr/sites/default/files/assets/documents/poids_carbone-biens-equipement-201809-rapport.pdf",
              unit: "item",
              usage: "16.7%",
              displayName: "T-shirt (polyester)",
              associatedPurchaseCategory: "CLOTHING"
            },
            "Polo shirt": {
              icon: "tshirt",
              intensityKilograms: 10,
              source: "https://www.ademe.fr/sites/default/files/assets/documents/poids_carbone-biens-equipement-201809-rapport.pdf",
              unit: "item",
              usage: "30%",
              displayName: "Polo shirt",
              associatedPurchaseCategory: "CLOTHING"
            },
            "Sweater (acrylic)": {
              icon: "tshirt",
              intensityKilograms: 28,
              source: "https://www.ademe.fr/sites/default/files/assets/documents/poids_carbone-biens-equipement-201809-rapport.pdf",
              unit: "item",
              usage: "17.9%",
              displayName: "Sweater (acrylic)",
              associatedPurchaseCategory: "CLOTHING"
            },
            "Fleece (recycled polyester)": {
              icon: "tshirt",
              intensityKilograms: 26,
              source: "https://www.ademe.fr/sites/default/files/assets/documents/poids_carbone-biens-equipement-201809-rapport.pdf",
              unit: "item",
              usage: "23.1%",
              displayName: "Fleece (recycled polyester)",
              associatedPurchaseCategory: "CLOTHING"
            },
            "Sweater (cotton)": {
              icon: "tshirt",
              intensityKilograms: 31,
              source: "https://www.ademe.fr/sites/default/files/assets/documents/poids_carbone-biens-equipement-201809-rapport.pdf",
              unit: "item",
              usage: "25.8%",
              displayName: "Sweater (cotton)",
              associatedPurchaseCategory: "CLOTHING"
            },
            "Pullover (wool)": {
              icon: "tshirt",
              intensityKilograms: 56,
              source: "https://www.ademe.fr/sites/default/files/assets/documents/poids_carbone-biens-equipement-201809-rapport.pdf",
              unit: "item",
              usage: "12.5%",
              displayName: "Pullover (wool)",
              associatedPurchaseCategory: "CLOTHING"
            },
            "Pullover (recycled cotton)": {
              icon: "tshirt",
              intensityKilograms: 12,
              source: "https://www.ademe.fr/sites/default/files/assets/documents/poids_carbone-biens-equipement-201809-rapport.pdf",
              unit: "item",
              usage: "41.7%",
              displayName: "Pullover (recycled cotton)",
              associatedPurchaseCategory: "CLOTHING"
            },
            "Jacket (generic)": {
              icon: "tshirt",
              intensityKilograms: 89,
              source: "https://www.ademe.fr/sites/default/files/assets/documents/poids_carbone-biens-equipement-201809-rapport.pdf",
              unit: "item",
              usage: "13.5%",
              displayName: "Jacket (generic)",
              associatedPurchaseCategory: "CLOTHING"
            },
            "Jacket (weatherproof)": {
              icon: "tshirt",
              intensityKilograms: 39,
              source: "https://www.ademe.fr/sites/default/files/assets/documents/poids_carbone-biens-equipement-201809-rapport.pdf",
              unit: "item",
              usage: "7.7%",
              displayName: "Jacket (weatherproof)",
              associatedPurchaseCategory: "CLOTHING"
            },
            "Jacket (faux leather)": {
              icon: "tshirt",
              intensityKilograms: 25,
              source: "https://www.ademe.fr/sites/default/files/assets/documents/poids_carbone-biens-equipement-201809-rapport.pdf",
              unit: "item",
              usage: "20%",
              displayName: "Jacket (faux leather)",
              associatedPurchaseCategory: "CLOTHING"
            },
            "Dress (polyester)": {
              icon: "tshirt",
              intensityKilograms: 56,
              source: "https://www.ademe.fr/sites/default/files/assets/documents/poids_carbone-biens-equipement-201809-rapport.pdf",
              unit: "item",
              usage: "19.6%",
              displayName: "Dress (polyester)",
              associatedPurchaseCategory: "CLOTHING"
            },
            "Dress (cotton)": {
              icon: "tshirt",
              intensityKilograms: 56,
              source: "https://www.ademe.fr/sites/default/files/assets/documents/poids_carbone-biens-equipement-201809-rapport.pdf",
              unit: "item",
              usage: "23.2%",
              displayName: "Dress (cotton)",
              associatedPurchaseCategory: "CLOTHING"
            },
            "Dress (viscose)": {
              icon: "tshirt",
              intensityKilograms: 51,
              source: "https://www.ademe.fr/sites/default/files/assets/documents/poids_carbone-biens-equipement-201809-rapport.pdf",
              unit: "item",
              usage: "25.5%",
              displayName: "Dress (viscose)",
              associatedPurchaseCategory: "CLOTHING"
            }
          },
          icon: "tshirt",
          intensityKilograms: {
            AT: 0.253390853011105,
            AU: 0.4131845929344703,
            BE: 0.48074857254393333,
            BG: 2.8455837416222627,
            BR: 0.4318050995344224,
            CA: 0.7966135460834114,
            CH: 0.410096636309399,
            CN: 1.4779834849543707,
            CY: 0.3372031022608125,
            CZ: 0.7806967478008914,
            DE: 0.43292028620585843,
            DK: 0.09421234904452092,
            EE: 1.0915267301891929,
            ES: 0.37187678981793293,
            FI: 0.6453443620619685,
            FR: 0.34786926534290263,
            GB: 0.4148024010947975,
            GR: 0.990761589421719,
            HR: 1.4043377116960214,
            HU: 0.5332451051140055,
            ID: 0.7511187667355645,
            IE: 0.41269441898464027,
            IN: 1.1550354348547172,
            IT: 0.3879568921476907,
            JP: 0.510435170763359,
            KR: 0.7593006455605364,
            LT: 0.3753219955032082,
            LU: 0.994250681845442,
            LV: 0.5502942412355077,
            MT: 0.9040377054777434,
            MX: 0.9587023145625289,
            NL: 0.34333207812377553,
            NO: 0.323977100811201,
            PL: 0.48393279150019175,
            PT: 0.5986489535166464,
            RO: 0.3741930932801246,
            RU: 0.7793139018271031,
            SE: 0.20024090920822735,
            SI: 0.8891761863933874,
            SK: 1.376305343448177,
            TR: 0.5030973748483708,
            TW: 1.4187699980722366,
            US: 0.542847160038323,
            WA: 0.8989864331393973,
            WE: 1.2783881720319956,
            WF: 1.3874863737179357,
            WL: 0.6084630928176069,
            WM: 1.0240309489129382,
            ZA: 4.589816574844106
          },
          oldKeys: ["PURCHASE_CATEGORY_STORE_CLOTHING", "Clothing", "Department store"],
          source: "https://github.com/tmrowco/bloom-contrib/tree/master/co2eq/purchase/exiobase",
          unit: "EUR",
          coicopCode: "03.1",
          year: 2011,
          displayName: "Clothing",
          keywords: ["garment", "footwear", "accessories", "fashion", "retail", "apparel", "fabrics", "tailor"]
        },
        FOOTWEAR: {
          _children: {
            "Shoes (leather)": {
              icon: "boot",
              intensityKilograms: 15,
              source: "https://www.ademe.fr/sites/default/files/assets/documents/poids_carbone-biens-equipement-201809-rapport.pdf",
              unit: "item",
              usage: "46.7%",
              displayName: "Shoes (leather)",
              associatedPurchaseCategory: "FOOTWEAR"
            },
            "Shoes (fabric)": {
              icon: "boot",
              intensityKilograms: 19,
              source: "https://www.ademe.fr/sites/default/files/assets/documents/poids_carbone-biens-equipement-201809-rapport.pdf",
              unit: "item",
              usage: "31.6%",
              displayName: "Shoes (fabric)",
              associatedPurchaseCategory: "FOOTWEAR"
            },
            "Shoes (sports)": {
              icon: "boot",
              intensityKilograms: 20,
              source: "https://www.ademe.fr/sites/default/files/assets/documents/poids_carbone-biens-equipement-201809-rapport.pdf",
              unit: "item",
              usage: "30%",
              displayName: "Shoes (sports)",
              associatedPurchaseCategory: "FOOTWEAR"
            }
          },
          coicopCode: "03.2",
          year: 2011,
          unit: "EUR",
          source: "https://github.com/tmrowco/bloom-contrib/tree/master/co2eq/purchase/exiobase",
          intensityKilograms: {
            AT: 0.24090536171805382,
            AU: 0.4184398004774378,
            BE: 0.3771574194271655,
            BG: 1.8880397360743504,
            BR: 0.4975649481529154,
            CA: 0.7214733038856421,
            CH: 0.40458910632478484,
            CN: 1.4586240024963357,
            CY: 0.25888335990027056,
            CZ: 0.7747413732090183,
            DE: 0.4341843070714043,
            DK: 0.10636915885347656,
            EE: 0.9510717427026463,
            ES: 0.38925966504527065,
            FI: 0.5190916403476701,
            FR: 0.3047166155607818,
            GB: 0.41933635324680457,
            GR: 0.8318953173943304,
            HR: 1.1093492577496655,
            HU: 0.5732434492113387,
            ID: 0.5726471902938298,
            IE: 0.3615677590789257,
            IN: 6.111314460097521,
            IT: 0.3713310838413173,
            JP: 0.4407338214748968,
            KR: 0.6663666935874455,
            LT: 0.4465058795415917,
            LU: 0.5562480551652003,
            LV: 0.5532626977799776,
            MT: 0.6631281517779815,
            MX: 0.8019184909023285,
            NL: 0.28641755318597206,
            NO: 0.3585862358641318,
            PL: 0.4742757041046192,
            PT: 0.5332033557727319,
            RO: 0.4159822581858271,
            RU: 0.7742474241737047,
            SE: 0.20094377451342343,
            SI: 0.6017068609492053,
            SK: 0.7780650677794003,
            TR: 0.42583457613214026,
            TW: 1.1565595234597734,
            US: 0.47035227781775757,
            WA: 0.580512836961183,
            WE: 0.5323203657677447,
            WF: 1.6095829019899133,
            WL: 0.6815591951288342,
            WM: 0.9834796551204319,
            ZA: 5.003082036520036
          },
          displayName: "Footwear",
          keywords: ["shoe", "sneaker"]
        }
      },
      displayName: "Clothing and footwear"
    },
    "HOUSING, WATER, ELECTRICITY, GAS AND OTHER FUELS": {
      _children: {
        "ACTUAL RENTALS FOR HOUSING": {
          coicopCode: "04.1",
          year: 2011,
          unit: "EUR",
          source: "https://github.com/tmrowco/bloom-contrib/tree/master/co2eq/purchase/exiobase",
          icon: "home",
          intensityKilograms: {
            AT: 0.14087843881478576,
            AU: 0.07724554347685257,
            BE: 0.10670738502338477,
            BG: 0.19073146273296998,
            BR: 0.12350207137977903,
            CA: 0.12708693581891156,
            CH: 0.04872002274735951,
            CN: 0.3039852377485612,
            CY: 0.04000056135610389,
            CZ: 0.5252875508792632,
            DE: 0.12692611941920828,
            DK: 0.09031475845305104,
            EE: 0.5890092987288703,
            ES: 0.07903330688395253,
            FI: 0.20796774269718335,
            FR: 0.0393095917054685,
            GB: 0.05280719601998783,
            GR: 0.2530276258456156,
            HR: 0.116512231746727,
            HU: 0.27176219477185015,
            ID: 0.02551032742393036,
            IE: 0.0895774489762848,
            IN: 0.09103445178636534,
            IT: 0.05119973211421865,
            JP: 0.025036645585469076,
            KR: 0.30837288119252965,
            LT: 0.12610650828845915,
            LU: 0.046321622496912775,
            LV: 0.32265441736917844,
            MT: 0.32952936925899273,
            MX: 0.09584562051312001,
            NL: 0.13293644894191053,
            NO: 0.09420251118079781,
            PL: 0.33295842506621204,
            PT: 0.0629800464619541,
            RO: 0.07795217325732379,
            RU: 0.30497484279542325,
            SE: 0.10910771798226894,
            SI: 0.17186349579031776,
            SK: 0.43011244425412704,
            TR: 0.2447889492010231,
            TW: 0.13325109453940942,
            US: 0.13868003269738485,
            WA: 0.5176966707277799,
            WE: 0.5618010534920103,
            WF: 0.48866636676591646,
            WL: 0.18294375802241053,
            WM: 0.4284458202413502,
            ZA: 0.27258596954249964
          },
          displayName: "Actual rentals for housing",
          keywords: ["rent", "office space", "office", "building"]
        },
        "IMPUTED RENTALS FOR HOUSING": {
          coicopCode: "04.2",
          year: 2011,
          unit: "EUR",
          source: "https://github.com/tmrowco/bloom-contrib/tree/master/co2eq/purchase/exiobase",
          intensityKilograms: {
            AT: 0.14087843881478576,
            AU: 0.07724554347685257,
            BE: 0.10670738502338477,
            BG: 0.19073146273296998,
            BR: 0.12350207137977903,
            CA: 0.12708693581891156,
            CH: 0.04872002274735951,
            CN: 0.3039852377485612,
            CY: 0.04000056135610389,
            CZ: 0.5252875508792632,
            DE: 0.12692611941920828,
            DK: 0.09031475845305104,
            EE: 0.5890092987288703,
            ES: 0.07903330688395253,
            FI: 0.20796774269718335,
            FR: 0.0393095917054685,
            GB: 0.05280719601998783,
            GR: 0.2530276258456156,
            HR: 0.116512231746727,
            HU: 0.27176219477185015,
            ID: 0.02551032742393036,
            IE: 0.0895774489762848,
            IN: 0.09103445178636534,
            IT: 0.05119973211421865,
            JP: 0.025036645585469076,
            KR: 0.30837288119252965,
            LT: 0.12610650828845915,
            LU: 0.046321622496912775,
            LV: 0.32265441736917844,
            MT: 0.32952936925899273,
            MX: 0.09584562051312001,
            NL: 0.13293644894191053,
            NO: 0.09420251118079781,
            PL: 0.33295842506621204,
            PT: 0.0629800464619541,
            RO: 0.07795217325732379,
            RU: 0.30497484279542325,
            SE: 0.10910771798226894,
            SI: 0.17186349579031776,
            SK: 0.43011244425412704,
            TR: 0.2447889492010231,
            TW: 0.13325109453940942,
            US: 0.13868003269738485,
            WA: 0.5176966707277799,
            WE: 0.5618010534920103,
            WF: 0.48866636676591646,
            WL: 0.18294375802241053,
            WM: 0.4284458202413502,
            ZA: 0.27258596954249964
          },
          displayName: "Imputed rentals for housing"
        },
        "MAINTENANCE, REPAIR AND SECURITY OF THE DWELLING": {
          coicopCode: "04.3",
          year: 2011,
          unit: "EUR",
          source: "https://github.com/tmrowco/bloom-contrib/tree/master/co2eq/purchase/exiobase",
          intensityKilograms: {
            AT: 0.38056491587650726,
            AU: 0.31363569561974763,
            BE: 0.5327162213358766,
            BG: 1.142696032768812,
            BR: 0.7083627948671403,
            CA: 0.7091603012547355,
            CH: 0.25954439459203116,
            CN: 5.50375005251571,
            CY: 0.4873721500054855,
            CZ: 0.8400762395019767,
            DE: 0.5336191483406998,
            DK: 0.2470801255549953,
            EE: 1.3149345176945915,
            ES: 0.379935572675977,
            FI: 0.49446924143828125,
            FR: 0.41855981872666054,
            GB: 0.2757080049696702,
            GR: 1.1782349103711773,
            HR: 0.8475261637033945,
            HU: 0.5558320583536431,
            ID: 1.3074843462268309,
            IE: 0.7093651800182804,
            IN: 2.644718923978338,
            IT: 0.38262247532237803,
            JP: 0.5446859289108252,
            KR: 1.3962146189340188,
            LT: 0.37524627851307646,
            LU: 0.6684341367598621,
            LV: 0.7482763287106312,
            MT: 2.185532421117849,
            MX: 0.7788159692572044,
            NL: 0.43127954416979164,
            NO: 0.2652223119448648,
            PL: 0.5174830737306876,
            PT: 0.8550452559778604,
            RO: 0.5777784800260016,
            RU: 0.6088267790403529,
            SE: 0.21270814848792335,
            SI: 0.6573679491988916,
            SK: 1.0925373815391846,
            TR: 3.2399175034323595,
            TW: 1.973287571856806,
            US: 0.5069271453086515,
            WA: 2.248243115492252,
            WE: 2.310355713348901,
            WF: 1.552719765899245,
            WL: 1.2297285340902775,
            WM: 2.345575427724313,
            ZA: 2.978342773344058
          },
          displayName: "Maintenance, repair and security of the dwelling",
          keywords: ["refurbish", "material", "decoration", "paint", "door", "fire", "plumbing", "plaster", "detector"]
        },
        "WATER SUPPLY AND MISCELLANEOUS SERVICES RELATING TO THE DWELLING": {
          coicopCode: "04.4",
          year: 2011,
          unit: "EUR",
          source: "https://github.com/tmrowco/bloom-contrib/tree/master/co2eq/purchase/exiobase",
          intensityKilograms: {
            AT: 0.6924904836402103,
            AU: 1.2765332668876004,
            BE: 0.6005941755046043,
            BG: 1.7433985682963475,
            BR: 0.4324434161792927,
            CA: 1.0521446007282598,
            CH: 0.777342688463588,
            CN: 4.887759674303415,
            CY: 1.0589285050358581,
            CZ: 1.4921746656870758,
            DE: 0.6929071242016593,
            DK: 1.0724863739284263,
            EE: 2.2241994822350573,
            ES: 1.1717109071147929,
            FI: 1.2287435705118295,
            FR: 0.6713718630279998,
            GB: 0.6492483574568171,
            GR: 1.4986875458837108,
            HR: 2.403063712068436,
            HU: 1.5723874865619862,
            ID: 0.5412049600205517,
            IE: 0.7858895757808324,
            IN: 0.4848668870472895,
            IT: 0.5094185241210248,
            JP: 1.044992541214308,
            KR: 1.5715077892356157,
            LT: 3.895892730612256,
            LU: 0.8885128682552699,
            LV: 2.574336112745879,
            MT: 0.7299750293817311,
            MX: 10.819833985207872,
            NL: 0.7779666187879928,
            NO: 0.5879682329980473,
            PL: 1.5465215732256392,
            PT: 1.4433513010422279,
            RO: 1.082708094906795,
            RU: 46.03999351022175,
            SE: 0.927055704632754,
            SI: 1.0958007375328633,
            SK: 2.3802866140211356,
            TR: 15.018367525063164,
            TW: 5.9426183555502226,
            US: 1.740042110313676,
            WA: 1.1597301719753954,
            WE: 1.7130285231035414,
            WF: 0.6740883414924835,
            WL: 0.522962693981658,
            WM: 0.9040625405202691,
            ZA: 0.0035860385282699757
          },
          displayName: "Water supply and miscellaneous services relating to the dwelling"
        },
        "ELECTRICITY, GAS AND OTHER FUELS": {
          _children: {
            "Electricity (ND)": {
              coicopCode: "04.5.1",
              year: 2011,
              unit: "EUR",
              source: "https://github.com/tmrowco/bloom-contrib/tree/master/co2eq/purchase/exiobase",
              intensityKilograms: {
                AT: 1.4050013479316374,
                AU: 7.695917305376748,
                BE: 1.7904693981903526,
                BG: 11.692535762267488,
                BR: 8.77488078457484,
                CA: 4.5785107267840965,
                CH: 0.16623923663439397,
                CN: 9.308926488953453,
                CY: 0.02673824764779694,
                CZ: 1.4992570610678564,
                DE: 1.559014665094756,
                DK: 0.09722296892639815,
                EE: 4.151910248384676,
                ES: 1.4787095923942275,
                FI: 1.917259841078271,
                FR: 1.593271888905867,
                GB: 2.0855040051492555,
                GR: 2.181878748729753,
                HR: 1.052143004280502,
                HU: 1.3836906270460416,
                ID: 15.95136970099661,
                IE: 2.3973594554062525,
                IN: 10.223257703793497,
                IT: 1.3686306548875091,
                JP: 2.083166698667554,
                KR: 6.484213332644906,
                LT: 0.3980548209628017,
                LU: 0.5165426299016823,
                LV: 0.616012303581656,
                MT: 2.9600846222579706,
                MX: 5.973546657325275,
                NL: 0.7726291069888447,
                NO: 0.6598653019615786,
                PL: 0.49427838940520397,
                PT: 2.120820291148387,
                RO: 1.527767547920675,
                RU: 0.5031957251128836,
                SE: 0.2573779154246152,
                SI: 0.45571751306092695,
                SK: 0.7051550795938286,
                TR: 8.692512655568844,
                TW: 6.378997502449978,
                US: 2.805976908139529,
                WA: 7.861099349947519,
                WE: 6.240595092545955,
                WF: 2.7909950763838283,
                WL: 10.269472507479598,
                WM: 3.1189092743343405,
                ZA: 31.398858545353633
              },
              displayName: "Electricity",
              activityType: "ACTIVITY_TYPE_ELECTRICITY"
            },
            "Gas (ND)": {
              coicopCode: "04.5.2",
              year: 2011,
              unit: "EUR",
              source: "https://github.com/tmrowco/bloom-contrib/tree/master/co2eq/purchase/exiobase",
              intensityKilograms: {
                AT: 3.7908293499585253,
                AU: 12.866038513759591,
                BE: 0.22801719036196502,
                BG: 10.391342772559614,
                BR: 36.71943961147449,
                CA: 5.34190332814613,
                CH: 2.364416313704334,
                CN: 4.254282901395678,
                CY: 1.4170718224290382,
                CZ: 4.841869887202356,
                DE: 2.6977100615381646,
                DK: 1.474873393829097,
                EE: 0.4123856330596746,
                ES: 340.58632906162757,
                FI: 6.344979980807749,
                FR: 1.345985474131509,
                GB: 2.6097823132571563,
                GR: 32.74689395157272,
                HR: 0.7546056663632088,
                HU: 2.3026612117784273,
                ID: 9.164476043322772,
                IE: 1.8870946855537687,
                IN: 4.776584610199037,
                IT: 6.7834012969354625,
                JP: 0.832709832925362,
                KR: 7.049042713577621,
                LT: 0.4049416821151202,
                LU: 1.6308529451873028,
                LV: 0.1165779338841207,
                MT: 0.0037879474076528055,
                MX: 22.891220952285412,
                NL: 1.120102506320077,
                NO: 0.2913809527797746,
                PL: 148.0349438746864,
                PT: 0.15464100575981843,
                RO: 9.068458941572198,
                RU: 27.688789329181525,
                SE: 1.2683489558819814,
                SI: 9.411869680223427,
                SK: 10.354092588886354,
                TR: 17.166898896170782,
                TW: 3.5171037652762744,
                US: 9.247968904743885,
                WA: 7.169541028757777,
                WE: 7.381485661858353,
                WF: 2.0572290517001948,
                WL: 10.312540485728922,
                WM: 1.9622288219797128,
                ZA: 0.34186634039669
              },
              displayName: "Gas"
            },
            "Liquid fuels (ND)": {
              coicopCode: "04.5.3",
              year: 2011,
              unit: "EUR",
              source: "https://github.com/tmrowco/bloom-contrib/tree/master/co2eq/purchase/exiobase",
              intensityKilograms: {
                AT: 1.2548419017767323,
                AU: 0.8783021491431163,
                BE: 1.934999691722785,
                BG: 1.289566609345954,
                BR: 0.7062201021927407,
                CA: 1.0020064260400272,
                CH: 0.4189964321188203,
                CN: 2.6994895569864514,
                CY: 1.57320039336844,
                CZ: 1.5929033735525113,
                DE: 0.9222048607279091,
                DK: 0.7154237595736346,
                EE: 5.784077812850609,
                ES: 1.0593571047963892,
                FI: 0.9820319333931878,
                FR: 0.7177937554091687,
                GB: 0.8657702968362166,
                GR: 1.2804689984308917,
                HR: 1.0223091679339444,
                HU: 1.1175168683951102,
                ID: 2.5948482434354974,
                IE: 0.3673099018481015,
                IN: 1.6706730302089545,
                IT: 1.0739722175293087,
                JP: 0.38298109159590343,
                KR: 1.3052465359339038,
                LT: 2.016707887156004,
                LU: 0.02207470812862963,
                LV: 0.6026310850893052,
                MT: 0.8817902027168844,
                MX: 1.511243337073765,
                NL: 1.3514050226555925,
                NO: 0.4876839360095171,
                PL: 1.7177894774416695,
                PT: 1.1409600553878183,
                RO: 2.173767907648932,
                RU: 1.3022620263912552,
                SE: 1.283888109331933,
                SI: 0.4257584614312955,
                SK: 48.16016327470712,
                TR: 0.8775760491824325,
                TW: 0.8805811225566327,
                US: 1.217146416034423,
                WA: 1.5405214792644109,
                WE: 2.593793490933578,
                WF: 1.489813742003256,
                WL: 2.4496582800147664,
                WM: 1.698204500905777,
                ZA: 1.238736639033815
              },
              displayName: "Liquid fuels"
            },
            "Solid fuels (ND)": {
              coicopCode: "04.5.4",
              year: 2011,
              unit: "EUR",
              source: "https://github.com/tmrowco/bloom-contrib/tree/master/co2eq/purchase/exiobase",
              intensityKilograms: {
                AT: 1.2599037475375774,
                AU: 0.7912623205504323,
                BE: 0.6750562414545608,
                BG: 1.4499087377955335,
                BR: 0.5517350795621234,
                CA: 1.4637605768461412,
                CH: 0.2672351754834452,
                CN: 1.9208077235751766,
                CY: 0.5151165084058091,
                CZ: 0.6994435593467304,
                DE: 0.8075810105829797,
                DK: 0.332194249141169,
                EE: 1.0054060493058732,
                ES: 0.7193017945396827,
                FI: 0.7685080384596321,
                FR: 0.9840555429781047,
                GB: 0.4070115943498066,
                GR: 1.3859579566211588,
                HR: 1.2624755013598707,
                HU: 0.6676504919121474,
                ID: 0.8563841222956554,
                IE: 0.4605025712763898,
                IN: 1.1557487040705805,
                IT: 0.3818222487243326,
                JP: 0.6281891156688468,
                KR: 1.1762260651592316,
                LT: 0.31197750264159324,
                LU: 0.9532875953327011,
                LV: 0.5276013025137378,
                MT: 0.595553088277656,
                MX: 0.941617831092648,
                NL: 0.39884784427774106,
                NO: 0.2933146401347524,
                PL: 0.6170065258993201,
                PT: 0.5355356704107725,
                RO: 0.45010020585525057,
                RU: 0.7613898857419609,
                SE: 0.2507751503346377,
                SI: 0.6209391059580668,
                SK: 4.868195421531696,
                TR: 0.8077384964454637,
                TW: 1.373597021363655,
                US: 1.1104919094826509,
                WA: 2.0966912941996045,
                WE: 1.6633203656472906,
                WF: 1.237242564173339,
                WL: 0.4085998177953727,
                WM: 1.0281298314554723,
                ZA: 2.304744290285429
              },
              displayName: "Solid fuels"
            },
            "Other energy for heating and cooling (ND)": {
              coicopCode: "04.5.5",
              year: 2011,
              unit: "EUR",
              source: "https://github.com/tmrowco/bloom-contrib/tree/master/co2eq/purchase/exiobase",
              intensityKilograms: {
                AT: 6.807844457727781,
                BE: 8.20457678931672,
                BG: 165.3870561281466,
                BR: 0.1555620096693078,
                CA: 91.21159997378231,
                CH: 0.3838169957006586,
                CN: 137.89832707220862,
                CY: 0.24827270524153947,
                CZ: 11.635361859665332,
                DE: 16.129513317583474,
                DK: 16.18580360036345,
                EE: 10.677171869822725,
                ES: 0.1620920230941908,
                FI: 103.9277479483118,
                FR: 2.1160612712733116,
                GB: 0.47636570936769007,
                GR: 10.249299894046452,
                HR: 19.493164000504624,
                HU: 5.896619447149667,
                ID: 23.9037640571933,
                IE: 0.5879077109226091,
                IN: 11.922906806158789,
                IT: 2.629404531582401,
                JP: 1.538807503707293,
                KR: 54.06915306654912,
                LT: 9.946186004235255,
                LU: 0.4664264632567642,
                LV: 338.60327821794414,
                MT: 0.518896558639905,
                MX: 0.8259653712401153,
                NL: 90.95338155095826,
                NO: 4.68366447240329,
                PL: 78.31177821786342,
                PT: 70.5295245229974,
                RO: 23.12405461672594,
                RU: 182.82872322026668,
                SE: 5.593239440523202,
                SI: 17.718834253203372,
                SK: 71.8000532969884,
                TR: 16.25948424069271,
                TW: 147.7800166652341,
                US: 100.61524026038519,
                WA: 124.2402277393991,
                WE: 106.95104742037086,
                WF: 2.107725437725905,
                WL: 11.972499123299174,
                WM: 10.095579870864537,
                ZA: 0.5929225821588607
              },
              displayName: "Other energy for heating and cooling"
            }
          },
          displayName: "Electricity, gas and other fuels"
        }
      },
      displayName: "Housing, water, electricity, gas and other fuels"
    },
    "FURNISHINGS, HOUSEHOLD EQUIPMENT AND ROUTINE HOUSEHOLD MAINTENANCE": {
      _children: {
        "FURNITURE, FURNISHINGS, AND LOOSE CARPETS": {
          _children: {
            "Furniture, furnishings and loose carpets (D)": {
              _children: {
                "Chair (wood)": {
                  icon: "chair",
                  intensityKilograms: 25.2,
                  source: "https://www.ademe.fr/sites/default/files/assets/documents/poids_carbone-biens-equipement-201809-rapport.pdf",
                  unit: "item",
                  displayName: "Chair (wood)",
                  associatedPurchaseCategory: "Furniture, furnishings and loose carpets (D)"
                },
                "Chair (plastic)": {
                  icon: "chair",
                  intensityKilograms: 28,
                  source: "https://www.ademe.fr/sites/default/files/assets/documents/poids_carbone-biens-equipement-201809-rapport.pdf",
                  unit: "item",
                  displayName: "Chair (plastic)",
                  associatedPurchaseCategory: "Furniture, furnishings and loose carpets (D)"
                },
                "Chair (wood and fabric)": {
                  icon: "chair",
                  intensityKilograms: 12,
                  source: "https://www.ademe.fr/sites/default/files/assets/documents/poids_carbone-biens-equipement-201809-rapport.pdf'",
                  unit: "item",
                  displayName: "Chair (wood and fabric)",
                  associatedPurchaseCategory: "Furniture, furnishings and loose carpets (D)"
                },
                "Table (wood)": {
                  icon: "chair",
                  intensityKilograms: 130,
                  source: "https://www.ademe.fr/sites/default/files/assets/documents/poids_carbone-biens-equipement-201809-rapport.pdf",
                  unit: "item",
                  displayName: "Table (wood)",
                  associatedPurchaseCategory: "Furniture, furnishings and loose carpets (D)"
                },
                "Table (generic)": {
                  icon: "chair",
                  intensityKilograms: 96,
                  source: "https://www.ademe.fr/sites/default/files/assets/documents/poids_carbone-biens-equipement-201809-rapport.pdf",
                  unit: "item",
                  displayName: "Table (generic)",
                  associatedPurchaseCategory: "Furniture, furnishings and loose carpets (D)"
                },
                Cabinet: {
                  icon: "chair",
                  intensityKilograms: 858,
                  source: "https://www.ademe.fr/sites/default/files/assets/documents/poids_carbone-biens-equipement-201809-rapport.pdf",
                  unit: "item",
                  displayName: "Cabinet",
                  associatedPurchaseCategory: "Furniture, furnishings and loose carpets (D)"
                },
                "Sofa (fabric)": {
                  icon: "couch",
                  intensityKilograms: 180,
                  source: "https://www.ademe.fr/sites/default/files/assets/documents/poids_carbone-biens-equipement-201809-rapport.pdf",
                  unit: "item",
                  displayName: "Sofa (fabric)",
                  associatedPurchaseCategory: "Furniture, furnishings and loose carpets (D)"
                },
                "Sofa (leather)": {
                  icon: "couch",
                  intensityKilograms: 200,
                  source: "https://www.ademe.fr/sites/default/files/assets/documents/poids_carbone-biens-equipement-201809-rapport.pdf",
                  unit: "item",
                  displayName: "Sofa (leather)",
                  associatedPurchaseCategory: "Furniture, furnishings and loose carpets (D)"
                },
                "Pullout sofa": {
                  icon: "couch",
                  intensityKilograms: 204,
                  source: "https://www.ademe.fr/sites/default/files/assets/documents/poids_carbone-biens-equipement-201809-rapport.pdf",
                  unit: "item",
                  displayName: "Pullout sofa",
                  associatedPurchaseCategory: "Furniture, furnishings and loose carpets (D)"
                },
                "Box spring": {
                  icon: "bed",
                  intensityKilograms: 110,
                  source: "https://www.ademe.fr/sites/default/files/assets/documents/poids_carbone-biens-equipement-201809-rapport.pdf",
                  unit: "item",
                  displayName: "Box spring",
                  associatedPurchaseCategory: "Furniture, furnishings and loose carpets (D)"
                },
                "Slatted bed base": {
                  icon: "bed",
                  intensityKilograms: 69,
                  source: "https://www.ademe.fr/sites/default/files/assets/documents/poids_carbone-biens-equipement-201809-rapport.pdf",
                  unit: "item",
                  displayName: "Slatted bed base",
                  associatedPurchaseCategory: "Furniture, furnishings and loose carpets (D)"
                },
                "Bed frame": {
                  icon: "bed",
                  intensityKilograms: 147,
                  source: "https://www.ademe.fr/sites/default/files/assets/documents/poids_carbone-biens-equipement-201809-rapport.pdf",
                  unit: "item",
                  displayName: "Bed frame",
                  associatedPurchaseCategory: "Furniture, furnishings and loose carpets (D)"
                },
                "Spring mattress": {
                  icon: "bed",
                  intensityKilograms: 219,
                  source: "https://www.ademe.fr/sites/default/files/assets/documents/poids_carbone-biens-equipement-201809-rapport.pdf",
                  unit: "item",
                  displayName: "Spring mattress",
                  associatedPurchaseCategory: "Furniture, furnishings and loose carpets (D)"
                },
                "Garden furniture (wood)": {
                  icon: "chair",
                  intensityKilograms: 103,
                  source: "https://www.ademe.fr/sites/default/files/assets/documents/poids_carbone-biens-equipement-201809-rapport.pdf",
                  unit: "item",
                  displayName: "Garden furniture (wood)",
                  associatedPurchaseCategory: "Furniture, furnishings and loose carpets (D)"
                },
                "Garden furniture (metal)": {
                  icon: "chair",
                  intensityKilograms: 224,
                  source: "https://www.ademe.fr/sites/default/files/assets/documents/poids_carbone-biens-equipement-201809-rapport.pdf",
                  unit: "item",
                  displayName: "Garden furniture (metal)",
                  associatedPurchaseCategory: "Furniture, furnishings and loose carpets (D)"
                },
                "Garden furniture (plastic)": {
                  icon: "chair",
                  intensityKilograms: 215,
                  source: "https://www.ademe.fr/sites/default/files/assets/documents/poids_carbone-biens-equipement-201809-rapport.pdf",
                  unit: "item",
                  displayName: "Garden furniture (plastic)",
                  associatedPurchaseCategory: "Furniture, furnishings and loose carpets (D)"
                },
                "Furnishings, loose carpets and rugs (D)": {
                  icon: "couch",
                  intensityKilograms: {
                    AT: 0.2701773389819761,
                    AU: 0.36646707905192283,
                    BE: 0.6387620419397695,
                    BG: 2.761567858917087,
                    BR: 0.5846197232265815,
                    CA: 0.9933494421738558,
                    CH: 0.38679577764430373,
                    CN: 1.6729881532948694,
                    CY: 0.38559753390362295,
                    CZ: 0.6789694049102933,
                    DE: 0.3770251579606425,
                    DK: 0.2381962130669464,
                    EE: 1.2188101427929525,
                    ES: 0.3998157339542213,
                    FI: 0.6265249605804429,
                    FR: 0.36391167766711796,
                    GB: 0.4214205726565066,
                    GR: 1.7550590219562388,
                    HR: 1.3370103446630908,
                    HU: 0.5597442891569346,
                    ID: 1.1178945068518962,
                    IE: 0.8623519619792797,
                    IN: 1.8291723679953522,
                    IT: 0.4384612155269755,
                    JP: 0.5270101195533702,
                    KR: 0.8728906598389281,
                    LT: 0.3421636133502123,
                    LU: 0.9724861482985139,
                    LV: 0.5458752056178451,
                    MT: 0.8232120339137996,
                    MX: 1.1026781497170384,
                    NL: 0.34359655650158816,
                    NO: 0.29892098665392425,
                    PL: 0.4458132856560437,
                    PT: 0.5420673702147083,
                    RO: 0.9110705511422169,
                    RU: 0.9355026292459665,
                    SE: 0.23589523840882956,
                    SI: 0.8298522703288547,
                    SK: 3.2776119689654033,
                    TR: 0.7924313551303377,
                    TW: 1.3970916171679713,
                    US: 0.6268807255339877,
                    WA: 3.1668192988593686,
                    WE: 1.645186950685415,
                    WF: 1.4559979309967364,
                    WL: 0.8154998534959756,
                    WM: 3.099437495692274,
                    ZA: 3.3695236105118425
                  },
                  oldKeys: ["PURCHASE_CATEGORY_STORE_HOUSE_FURNISHING", "House furnishing"],
                  source: "https://github.com/tmrowco/bloom-contrib/tree/master/co2eq/purchase/exiobase",
                  unit: "EUR",
                  coicopCode: "05.1.1.4",
                  year: 2011,
                  displayName: "Furnishings, loose carpets and rugs",
                  keywords: ["clock", "artwork", "statue", "sculpture", "porcelain"]
                }
              },
              icon: "credit-card",
              intensityKilograms: {
                AT: 0.23255623291602703,
                AU: 0.38319001322297114,
                BE: 0.6552729264711564,
                BG: 2.96430960275739,
                BR: 0.7545659277375393,
                CA: 0.9534197862272903,
                CH: 0.39299544764016625,
                CN: 1.6353714001298192,
                CY: 0.49421007734769096,
                CZ: 0.5673239468597487,
                DE: 0.32641341288675924,
                DK: 0.3421907749757975,
                EE: 1.0529522023790987,
                ES: 0.4042512362388052,
                FI: 0.650674876989362,
                FR: 0.37662938123759315,
                GB: 0.44853658092027204,
                GR: 2.4058815176261836,
                HR: 1.292536485756606,
                HU: 0.5830181109264072,
                ID: 1.4463169442581867,
                IE: 1.2231974387798354,
                IN: 2.109566998133541,
                IT: 0.5029762316258776,
                JP: 0.4724001637518687,
                KR: 0.7965293515637408,
                LT: 0.3017771450621389,
                LU: 0.933631804361737,
                LV: 0.4736170247933149,
                MT: 0.6666043757233315,
                MX: 1.3605503567465724,
                NL: 0.2770889255375272,
                NO: 0.26533647103152036,
                PL: 0.3901031247190196,
                PT: 0.4976577687462722,
                RO: 1.361636297492367,
                RU: 1.2391279068414929,
                SE: 0.260944709353076,
                SI: 0.5102084569390909,
                SK: 4.623196843992273,
                TR: 0.9933387015631712,
                TW: 1.2069635365749143,
                US: 0.48308465618127977,
                WA: 5.05401629237283,
                WE: 1.6104153941025483,
                WF: 1.6275257010333444,
                WL: 1.0497257015563455,
                WM: 4.9451473927847935,
                ZA: 1.5468146279914532
              },
              oldKeys: ["PURCHASE_CATEGORY_STORE_EQUIPMENT_FURNITURE", "Equipment furniture"],
              source: "https://github.com/tmrowco/bloom-contrib/tree/master/co2eq/purchase/exiobase",
              unit: "EUR",
              coicopCode: "05.1.1",
              year: 2011,
              displayName: "Furniture, furnishings and loose carpets",
              keywords: ["office furniture", "desk", "sofa", "couch", "chair", "drawer", "shelf", "stand", "bed", "table", "cupboard", "camping", "artwork", "statue", "sculpture", "porcelain"]
            },
            "Repair, installation and hire of furniture, furnishings and loose carpets (S)": {
              coicopCode: "05.1.2",
              year: 2011,
              unit: "EUR",
              source: "https://github.com/tmrowco/bloom-contrib/tree/master/co2eq/purchase/exiobase",
              intensityKilograms: {
                AT: 0.22812402805976995,
                AU: 0.3649665078033194,
                BE: 1.6874665945533747,
                BG: 2.166329217044064,
                BR: 0.6408375383784887,
                CA: 0.8571375338740083,
                CH: 0.31181512547407025,
                CN: 1.1793918334265954,
                CY: 0.30708808672129156,
                CZ: 0.5508795650629839,
                DE: 0.37093158525235076,
                DK: 0.26299493242930805,
                EE: 0.7791487843877188,
                ES: 0.3281642231966779,
                FI: 0.4989593604553273,
                FR: 0.48667090820818953,
                GB: 0.32743730755268774,
                GR: 1.8397488484312516,
                HR: 1.135132166035059,
                HU: 0.5028963659605776,
                ID: 1.0528546143171558,
                IE: 0.9054308707738451,
                IN: 1.5855294620623162,
                IT: 0.40015578762309145,
                JP: 0.35028476304772344,
                KR: 0.6831456797088793,
                LT: 0.2672449837928056,
                LU: 0.6986622652011534,
                LV: 0.397313450041312,
                MT: 0.5372811716052389,
                MX: 1.0058630949612495,
                NL: 0.268510203132327,
                NO: 0.20959700697566805,
                PL: 0.32792119212549403,
                PT: 0.40403021877137135,
                RO: 1.0708461729548109,
                RU: 0.9459958698972752,
                SE: 0.21633548544063594,
                SI: 0.3919206259972508,
                SK: 3.2848507239366778,
                TR: 0.7531075010078829,
                TW: 1.3195457005329967,
                US: 1.3015923538434437,
                WA: 3.674922458208131,
                WE: 1.2889324548417185,
                WF: 1.3128109844469764,
                WL: 0.8166904382166188,
                WM: 3.644825472072012,
                ZA: 1.206156079478417
              },
              displayName: "Repair, installation and hire of furniture, furnishings and loose carpets",
              keywords: ["restoration"]
            }
          },
          displayName: "Furniture, furnishings, and loose carpets"
        },
        "HOUSEHOLD TEXTILES": {
          coicopCode: "05.2",
          year: 2011,
          unit: "EUR",
          source: "https://github.com/tmrowco/bloom-contrib/tree/master/co2eq/purchase/exiobase",
          intensityKilograms: {
            AT: 0.29520755617955524,
            AU: 0.34154449856580765,
            BE: 0.6280009522535023,
            BG: 2.914583244070493,
            BR: 0.366624903727637,
            CA: 1.0392168000450117,
            CH: 0.39212965712287196,
            CN: 1.5507063246612813,
            CY: 0.3754597263315342,
            CZ: 0.8277519513741775,
            DE: 0.43031379329811603,
            DK: 0.10292203301873777,
            EE: 1.2630109079599003,
            ES: 0.3862058621179412,
            FI: 0.6273721651371462,
            FR: 0.35588387667384214,
            GB: 0.4020276888291083,
            GR: 1.087886386854641,
            HR: 1.5576417637519921,
            HU: 0.5289854645691409,
            ID: 0.8376172238866337,
            IE: 0.4865955921904551,
            IN: 1.4319167518040832,
            IT: 0.3791325791228933,
            JP: 0.5201592315898137,
            KR: 0.9174713478463458,
            LT: 0.39409133149566844,
            LU: 1.0884816980262613,
            LV: 0.6660790138805311,
            MT: 1.0746214236323455,
            MX: 0.8779343791093155,
            NL: 0.42719238637392637,
            NO: 0.31377423772281715,
            PL: 0.5078335511607108,
            PT: 0.6157926102039853,
            RO: 0.37601808074686893,
            RU: 0.6554605188824757,
            SE: 0.19508417082838292,
            SI: 1.2226323169546105,
            SK: 2.010684908392691,
            TR: 0.5641449759829291,
            TW: 1.6640260352995784,
            US: 0.7155303019573163,
            WA: 1.119397911912834,
            WE: 1.94589840024156,
            WF: 1.309501685252197,
            WL: 0.5924941399221746,
            WM: 1.1178986891609513,
            ZA: 5.563781733172359
          },
          displayName: "Household textiles",
          keywords: ["fabric", "curtain", "bedding", "hammock", "linen", "sheet", "blanket", "plaid", "bag", "mat", "home"]
        },
        "HOUSEHOLD APPLIANCES": {
          _children: {
            "Electric oven": {
              icon: "blender",
              intensityKilograms: 319,
              source: "https://www.ademe.fr/sites/default/files/assets/documents/poids_carbone-biens-equipement-201809-rapport.pdf",
              unit: "item",
              usage: "41.4%",
              displayName: "Electric oven",
              associatedPurchaseCategory: "HOUSEHOLD APPLIANCES"
            },
            "Gas oven": {
              icon: "blender",
              intensityKilograms: 846,
              source: "https://www.ademe.fr/sites/default/files/assets/documents/poids_carbone-biens-equipement-201809-rapport.pdf",
              unit: "item",
              usage: "84.4%",
              displayName: "Gas oven",
              associatedPurchaseCategory: "HOUSEHOLD APPLIANCES"
            },
            "Mini electric oven": {
              icon: "blender",
              intensityKilograms: 190,
              source: "https://www.ademe.fr/sites/default/files/assets/documents/poids_carbone-biens-equipement-201809-rapport.pdf",
              unit: "item",
              usage: "62.6%",
              displayName: "Mini electric oven",
              associatedPurchaseCategory: "HOUSEHOLD APPLIANCES"
            },
            "Microwave oven": {
              icon: "blender",
              intensityKilograms: 118,
              source: "https://www.ademe.fr/sites/default/files/assets/documents/poids_carbone-biens-equipement-201809-rapport.pdf",
              unit: "item",
              usage: "33.1%",
              displayName: "Microwave oven",
              associatedPurchaseCategory: "HOUSEHOLD APPLIANCES"
            },
            Dishwasher: {
              icon: "blender",
              intensityKilograms: 513,
              source: "https://www.ademe.fr/sites/default/files/assets/documents/poids_carbone-biens-equipement-201809-rapport.pdf",
              unit: "item",
              usage: "57.1%",
              displayName: "Dishwasher",
              associatedPurchaseCategory: "HOUSEHOLD APPLIANCES"
            },
            "Mini dishwasher": {
              icon: "blender",
              intensityKilograms: 431,
              source: "https://www.ademe.fr/sites/default/files/assets/documents/poids_carbone-biens-equipement-201809-rapport.pdf",
              unit: "item",
              usage: "55.2%",
              displayName: "Mini dishwasher",
              associatedPurchaseCategory: "HOUSEHOLD APPLIANCES"
            },
            "Top load laundry machine": {
              icon: "blender",
              intensityKilograms: 468,
              source: "https://www.ademe.fr/sites/default/files/assets/documents/poids_carbone-biens-equipement-201809-rapport.pdf",
              unit: "item",
              usage: "47%",
              displayName: "Top load laundry machine",
              associatedPurchaseCategory: "HOUSEHOLD APPLIANCES"
            },
            "Front load laundry machine": {
              icon: "blender",
              intensityKilograms: 539,
              source: "https://www.ademe.fr/sites/default/files/assets/documents/poids_carbone-biens-equipement-201809-rapport.pdf",
              unit: "item",
              usage: "49%",
              displayName: "Front load laundry machine",
              associatedPurchaseCategory: "HOUSEHOLD APPLIANCES"
            },
            "Heat pump dryer": {
              icon: "blender",
              intensityKilograms: 506,
              source: "https://www.ademe.fr/sites/default/files/assets/documents/poids_carbone-biens-equipement-201809-rapport.pdf",
              unit: "item",
              usage: "48.6%",
              displayName: "Heat pump dryer",
              associatedPurchaseCategory: "HOUSEHOLD APPLIANCES"
            },
            "Dewatering dryer": {
              icon: "blender",
              intensityKilograms: 588,
              source: "https://www.ademe.fr/sites/default/files/assets/documents/poids_carbone-biens-equipement-201809-rapport.pdf",
              unit: "item",
              usage: "55.8%",
              displayName: "Dewatering dryer",
              associatedPurchaseCategory: "HOUSEHOLD APPLIANCES"
            },
            "Evacuation dryer": {
              icon: "blender",
              intensityKilograms: 545,
              source: "https://www.ademe.fr/sites/default/files/assets/documents/poids_carbone-biens-equipement-201809-rapport.pdf",
              unit: "item",
              usage: "57.4%",
              displayName: "Evacuation dryer",
              associatedPurchaseCategory: "HOUSEHOLD APPLIANCES"
            },
            Refrigerator: {
              icon: "blender",
              intensityKilograms: 343,
              source: "https://www.ademe.fr/sites/default/files/assets/documents/poids_carbone-biens-equipement-201809-rapport.pdf",
              unit: "item",
              usage: "30.9%",
              displayName: "Refrigerator",
              associatedPurchaseCategory: "HOUSEHOLD APPLIANCES"
            },
            "Integrated fridge freezer": {
              icon: "blender",
              intensityKilograms: 431,
              source: "https://www.ademe.fr/sites/default/files/assets/documents/poids_carbone-biens-equipement-201809-rapport.pdf",
              unit: "item",
              usage: "48.7%",
              displayName: "Integrated fridge freezer",
              associatedPurchaseCategory: "HOUSEHOLD APPLIANCES"
            },
            "Mini Refrigerator": {
              icon: "blender",
              intensityKilograms: 159,
              source: "https://www.ademe.fr/sites/default/files/assets/documents/poids_carbone-biens-equipement-201809-rapport.pdf",
              unit: "item",
              usage: "56.6%",
              displayName: "Mini refrigerator",
              associatedPurchaseCategory: "HOUSEHOLD APPLIANCES"
            },
            "Chest freezer": {
              icon: "blender",
              intensityKilograms: 492,
              source: "https://www.ademe.fr/sites/default/files/assets/documents/poids_carbone-biens-equipement-201809-rapport.pdf",
              unit: "item",
              usage: "50.6%",
              displayName: "Chest freezer",
              associatedPurchaseCategory: "HOUSEHOLD APPLIANCES"
            },
            "Upright freezer": {
              icon: "blender",
              intensityKilograms: 587,
              source: "https://www.ademe.fr/sites/default/files/assets/documents/poids_carbone-biens-equipement-201809-rapport.pdf",
              unit: "item",
              usage: "43.4%",
              displayName: "Upright freezer",
              associatedPurchaseCategory: "HOUSEHOLD APPLIANCES"
            },
            "Vacuum cleaner": {
              icon: "blender",
              intensityKilograms: 67,
              source: "https://www.ademe.fr/sites/default/files/assets/documents/poids_carbone-biens-equipement-201809-rapport.pdf",
              unit: "item",
              usage: "41.8%",
              displayName: "Vacuum cleaner",
              associatedPurchaseCategory: "HOUSEHOLD APPLIANCES"
            },
            "Bagless vacuum cleaner": {
              icon: "blender",
              intensityKilograms: 69,
              source: "https://www.ademe.fr/sites/default/files/assets/documents/poids_carbone-biens-equipement-201809-rapport.pdf",
              unit: "item",
              usage: "37.7%",
              displayName: "Bagless vacuum cleaner",
              associatedPurchaseCategory: "HOUSEHOLD APPLIANCES"
            },
            "Stand mixer": {
              icon: "blender",
              intensityKilograms: 43,
              source: "https://www.ademe.fr/sites/default/files/assets/documents/poids_carbone-biens-equipement-201809-rapport.pdf",
              unit: "item",
              usage: "16.3%",
              displayName: "Stand mixer",
              associatedPurchaseCategory: "HOUSEHOLD APPLIANCES"
            },
            "Bread machine": {
              icon: "blender",
              intensityKilograms: 96,
              source: "https://www.ademe.fr/sites/default/files/assets/documents/poids_carbone-biens-equipement-201809-rapport.pdf",
              unit: "item",
              usage: "17%",
              displayName: "Bread machine",
              associatedPurchaseCategory: "HOUSEHOLD APPLIANCES"
            },
            "Yogurt maker": {
              icon: "blender",
              intensityKilograms: 96,
              source: "https://www.ademe.fr/sites/default/files/assets/documents/poids_carbone-biens-equipement-201809-rapport.pdf",
              unit: "item",
              usage: "52.1%",
              displayName: "Yogurt maker",
              associatedPurchaseCategory: "HOUSEHOLD APPLIANCES"
            }
          },
          icon: "blender",
          intensityKilograms: {
            AT: 0.28983740072392083,
            AU: 0.4428823364363346,
            BE: 0.4716074378382041,
            BG: 0.6287641687792758,
            BR: 0.45748098985015206,
            CA: 0.5645275796804563,
            CH: 0.22974090060411834,
            CN: 2.087510066542569,
            CY: 0.5385237838373667,
            CZ: 0.617588050343671,
            DE: 0.3269247757250511,
            DK: 0.4028253119428596,
            EE: 0.8773915918662959,
            ES: 0.4293866708919007,
            FI: 0.2986151522433091,
            FR: 0.2767048552576672,
            GB: 0.37853812565796824,
            GR: 0.9983239164570219,
            HR: 0.6596876494483792,
            HU: 0.45315027790824414,
            ID: 0.6997994096874489,
            IE: 0.4069777745823788,
            IN: 1.6860769030852074,
            IT: 0.38266543551872395,
            JP: 0.48178540400488296,
            KR: 0.8401632180090477,
            LT: 0.4168720058363592,
            LU: 0.5373443343892618,
            LV: 0.553922401158853,
            MT: 0.8695281026057554,
            MX: 0.5636192094942262,
            NL: 0.39478448460497745,
            NO: 0.30550010822018964,
            PL: 0.4630254182978983,
            PT: 0.4099996879113437,
            RO: 0.8132467672558613,
            RU: 0.42454901352717744,
            SE: 0.2192265492281977,
            SI: 0.5144052087221539,
            SK: 0.5123346716922281,
            TR: 0.7040704226113464,
            TW: 0.9363337093738255,
            US: 0.5483315813421249,
            WA: 0.9550095967983326,
            WE: 1.2916317178960173,
            WF: 0.8817141724385771,
            WL: 0.40974686570344915,
            WM: 1.0247746852479052,
            ZA: 1.0797960266097255
          },
          oldKeys: ["PURCHASE_CATEGORY_STORE_HOUSEHOLD_APPLIANCE", "Household appliances"],
          source: "https://github.com/tmrowco/bloom-contrib/tree/master/co2eq/purchase/exiobase",
          unit: "EUR",
          coicopCode: "05.3",
          year: 2011,
          displayName: "Household appliances",
          keywords: ["fridge", "refrigerator", "dishwasher", "panel", "oven", "cooker", "microwave", "washing", "machine", "dryer", "vacuum", "air-conditioner", "ac", "heater", "radiator"]
        },
        "GLASSWARE, TABLEWARE AND HOUSEHOLD UTENSILS": {
          coicopCode: "05.4",
          year: 2011,
          unit: "EUR",
          source: "https://github.com/tmrowco/bloom-contrib/tree/master/co2eq/purchase/exiobase",
          intensityKilograms: {
            AT: 0.437999418642222,
            AU: 1.1190644116807336,
            BE: 1.3639808883629927,
            BG: 1.491455641002224,
            BR: 0.6322142432703549,
            CA: 1.5160539549596657,
            CH: 0.34812804346731563,
            CN: 2.145899243023115,
            CY: 0.5747113047651009,
            CZ: 0.6691416500191035,
            DE: 0.427090047116639,
            DK: 0.40662829065379297,
            EE: 1.0548853877980962,
            ES: 0.7526948514765835,
            FI: 0.4907565835858043,
            FR: 0.4842353387949653,
            GB: 0.42950046423904525,
            GR: 1.5047679141252857,
            HR: 1.2570465257449668,
            HU: 0.5777216962559967,
            ID: 1.815741310323189,
            IE: 0.6441546032773147,
            IN: 2.3424700661088944,
            IT: 0.530447773445601,
            JP: 0.5310331854256797,
            KR: 0.8337945789112535,
            LT: 0.4484718189533674,
            LU: 0.8213727814427072,
            LV: 1.2119847623795617,
            MT: 0.8123890303000072,
            MX: 0.8873648486803378,
            NL: 0.5351606522995807,
            NO: 0.4225295204655181,
            PL: 0.5328279258168243,
            PT: 0.7812954386552222,
            RO: 1.2027800845527905,
            RU: 2.12996197927833,
            SE: 0.2533199138415807,
            SI: 0.8812338419263167,
            SK: 1.5657465519945344,
            TR: 0.7449269355995234,
            TW: 1.5635982549851364,
            US: 0.8553572670375935,
            WA: 2.7876787703545793,
            WE: 2.2413352193590175,
            WF: 1.8162705977448057,
            WL: 1.1843870997169927,
            WM: 3.1134126618679163,
            ZA: 4.583158027166673
          },
          displayName: "Glassware, tableware and household utensils",
          keywords: ["cutlery", "pan"]
        },
        "TOOLS AND EQUIPMENT FOR HOUSE AND GARDEN": {
          icon: "tools",
          intensityKilograms: {
            AT: 0.44209788523310034,
            AU: 0.4392948649719302,
            BE: 0.6394015332182413,
            BG: 1.0136039842722402,
            BR: 1.1615325830265504,
            CA: 1.1707791086784638,
            CH: 0.30038216563452375,
            CN: 2.8668003933851827,
            CY: 0.46253527333708644,
            CZ: 0.9570147348188918,
            DE: 0.40082815709893527,
            DK: 0.44964936858541066,
            EE: 1.021230436153108,
            ES: 0.6227919580890828,
            FI: 0.3791242111938249,
            FR: 0.329177868698114,
            GB: 0.4272396003602901,
            GR: 1.5379405810741513,
            HR: 1.159819771604233,
            HU: 0.7602716524710723,
            ID: 1.4098657297563664,
            IE: 0.46876703198182434,
            IN: 3.2459938570204483,
            IT: 0.42841253112599187,
            JP: 1.1380748263026634,
            KR: 1.153178930575163,
            LT: 0.5772492174121572,
            LU: 0.7525375346420458,
            LV: 0.6452060135893057,
            MT: 0.7006706206483901,
            MX: 0.7257423995782588,
            NL: 0.37475527448097345,
            NO: 0.31425964423150304,
            PL: 0.5225072360465812,
            PT: 0.5152991676629628,
            RO: 0.79061462017218,
            RU: 1.1219349458801466,
            SE: 0.21842977639803313,
            SI: 0.6448156198213382,
            SK: 1.1363045893146269,
            TR: 0.7138817378427375,
            TW: 1.2561596016017889,
            US: 0.810529450420403,
            WA: 3.941237165372381,
            WE: 2.4124576944168763,
            WF: 1.796628050274384,
            WL: 1.2204449278198721,
            WM: 3.733946595736375,
            ZA: 3.818349413575256
          },
          oldKeys: ["PURCHASE_CATEGORY_STORE_HARDWARE", "Hardware"],
          source: "https://github.com/tmrowco/bloom-contrib/tree/master/co2eq/purchase/exiobase",
          unit: "EUR",
          coicopCode: "05.5",
          year: 2011,
          displayName: "Tools and equipment for house and garden",
          keywords: ["diy", "construction", "hardware", "lawn", "utensils", "paint", "building", "plumbing", "tool"]
        },
        "GOODS AND SERVICES FOR ROUTINE HOUSEHOLD MAINTENANCE": {
          _children: {
            "Non-durable household goods (ND)": {
              coicopCode: "05.6.1",
              year: 2011,
              unit: "EUR",
              source: "https://github.com/tmrowco/bloom-contrib/tree/master/co2eq/purchase/exiobase",
              intensityKilograms: {
                AT: 0.5775486189019716,
                AU: 0.482957600141181,
                BE: 1.455848890019726,
                BG: 1.3789029931725116,
                BR: 0.501371048073081,
                CA: 0.8729079997026763,
                CH: 0.28192097446425995,
                CN: 2.562036384393309,
                CY: 0.8377210326949068,
                CZ: 1.1111787573184941,
                DE: 0.5451279552347507,
                DK: 0.30984681849849366,
                EE: 1.438423093420543,
                ES: 0.560718997106285,
                FI: 0.4195650928803802,
                FR: 0.3530166558895466,
                GB: 0.5715691007059142,
                GR: 1.1872643512357814,
                HR: 1.1312669422370847,
                HU: 0.8010027651999587,
                ID: 2.997247078026601,
                IE: 0.439230161349211,
                IN: 1.6536886781689761,
                IT: 0.4727225997328898,
                JP: 0.7354951736599652,
                KR: 1.102023443967957,
                LT: 1.3628763045983814,
                LU: 0.9716821386313074,
                LV: 0.6092271125907834,
                MT: 1.0188936486425728,
                MX: 0.8097090973357174,
                NL: 1.009867340646306,
                NO: 0.44733642308368593,
                PL: 0.8670376443462937,
                PT: 0.6202500491055618,
                RO: 1.3782823569827265,
                RU: 0.8584710618769164,
                SE: 0.5044417006156428,
                SI: 0.7011919001918604,
                SK: 0.9952818389682339,
                TR: 0.7896261914690831,
                TW: 1.6338054680905962,
                US: 0.7568535746345095,
                WA: 1.621653096926872,
                WE: 2.312356990433212,
                WF: 1.277915241627425,
                WL: 0.9646990685749921,
                WM: 2.2249220190723413,
                ZA: 5.362984598238365
              },
              displayName: "Non-durable household goods",
              keywords: ["cleaning", "detergent", "cleanser", "disinfectant", "bleach", "disposable", "chemical"]
            },
            "Domestic services and household services (S)": {
              coicopCode: "05.6.2",
              year: 2011,
              unit: "EUR",
              source: "https://github.com/tmrowco/bloom-contrib/tree/master/co2eq/purchase/exiobase",
              intensityKilograms: {
                AT: 0.09816295861178499,
                AU: 0.4104469659589552,
                BE: 0.37169362483426527,
                BG: 0.3442257041432851,
                BR: 0.028958280315797842,
                CA: 0.2081525989207375,
                CH: 0.18609261020801582,
                CN: 1.1033842632307755,
                CY: 0.08356832035999891,
                CZ: 0.3633929594356488,
                DE: 0.10891354489312496,
                DK: 0.25407834413859537,
                EE: 0.46708039865345613,
                ES: 0.1366756384905113,
                FI: 0.23158293748431297,
                FR: 0.07856056707331513,
                GB: 0.07620416486692001,
                GR: 2.464374525985924,
                HR: 0.7774335684730844,
                HU: 0.31063852485399146,
                ID: 0.38638438278642573,
                IE: 0.1653916603280943,
                IN: 1.3603920230403972,
                IT: 0.22846928492822222,
                JP: 0.16704753696904664,
                KR: 0.5845994321685558,
                LT: 0.19733768960246428,
                LU: 0.1999128314327482,
                LV: 0.19876731910066964,
                MT: 0.438970530961354,
                MX: 0.6868455475777204,
                NL: 0.25604443491689055,
                NO: 0.4007785941946066,
                PL: 0.2547979808675991,
                PT: 0.1520324748446749,
                RO: 0.1527879590773185,
                RU: 0.39305257508658503,
                SE: 0.06963302828720415,
                SI: 0.6865599472832368,
                SK: 0.4099684928273011,
                TR: 0.14596824478328344,
                TW: 0.2957385934641998,
                US: 0.05723060102061075,
                WA: 0.5499057759689083,
                WE: 1.275256132219043,
                WF: 0.8179918119416781,
                WL: 0.24936972167512025,
                WM: 0.6129236529946916,
                ZA: 0.8345173072377863
              },
              displayName: "Domestic services and household services",
              keywords: ["cook", "butler", "maid", "cleaner", "gardener", "babysittig", "dry-cleaning", "pest", "fumigation", "laundering", "laundry"]
            }
          },
          displayName: "Goods and services for routine household maintenance"
        }
      },
      displayName: "Furnishings, household equipment and routine household maintenance"
    },
    HEALTH: {
      _children: {
        "MEDICINES AND HEALTH PRODUCTS": {
          icon: "pills",
          intensityKilograms: {
            AT: 0.7395254482943652,
            AU: 0.5412973131567629,
            BE: 1.9607022106136907,
            BG: 1.074699583299521,
            BR: 0.4659233876910027,
            CA: 0.8357708646777808,
            CH: 0.23433300217438977,
            CN: 2.809711381383113,
            CY: 1.002541791891021,
            CZ: 1.349606466300698,
            DE: 0.6198178220969699,
            DK: 0.3630657756971128,
            EE: 1.4964176341330198,
            ES: 0.6002903270677339,
            FI: 0.38602972392801005,
            FR: 0.35507770396195626,
            GB: 0.6630658337882962,
            GR: 1.2200770706608397,
            HR: 1.0326980376998622,
            HU: 0.8472383309153063,
            ID: 3.703428291556138,
            IE: 0.27083507153462966,
            IN: 1.5995324398161754,
            IT: 0.5061063840649023,
            JP: 0.8693305427539222,
            KR: 1.1714835979156,
            LT: 1.9729045267125422,
            LU: 0.9986110518636353,
            LV: 0.5754517135563836,
            MT: 1.0358108910882067,
            MX: 0.7082111098905375,
            NL: 1.3500291925975636,
            NO: 0.4841227052129984,
            PL: 1.102501589363694,
            PT: 0.6571616374584642,
            RO: 1.7821352474226684,
            RU: 1.0295078706462921,
            SE: 0.6870477579977976,
            SI: 0.5761269367531472,
            SK: 0.541713706974588,
            TR: 0.7244429274655846,
            TW: 1.6967316429629495,
            US: 0.7743095987040018,
            WA: 1.2862241646737926,
            WE: 2.45627206220066,
            WF: 0.9919360330302116,
            WL: 0.7619785457975273,
            WM: 1.9645181296086742,
            ZA: 5.797453734929942
          },
          oldKeys: ["PURCHASE_CATEGORY_HEALTHCARE_PHARMARCY", "Drug store or pharmacy"],
          source: "https://github.com/tmrowco/bloom-contrib/tree/master/co2eq/purchase/exiobase",
          unit: "EUR",
          coicopCode: "06.1",
          year: 2011,
          displayName: "Medicines and health products",
          keywords: ["pharmacy", "care", "medication", "drugstore", "apothecary"]
        },
        "OUTPATIENT CARE SERVICES": {
          icon: "user-md",
          intensityKilograms: {
            AT: 0.19637013890293112,
            AU: 0.1736482164120421,
            BE: 0.27540268589183337,
            BG: 0.42721444059514957,
            BR: 0.19899937721648303,
            CA: 0.1079942527987319,
            CH: 0.11499976822275346,
            CN: 1.689975330609178,
            CY: 0.25004435777846523,
            CZ: 0.4398003704979697,
            DE: 0.20458647924101406,
            DK: 0.24335006191175448,
            EE: 0.8858590591925467,
            ES: 0.19177140980017374,
            FI: 0.2056902510237252,
            FR: 0.10968207491434957,
            GB: 0.1718751282710591,
            GR: 0.18069092684744295,
            HR: 0.31002115464586794,
            HU: 0.44118057868552296,
            ID: 1.217960555490836,
            IE: 0.13091149538357047,
            IN: 0.5270336649160979,
            IT: 0.1955219597230482,
            JP: 0.3066215488825217,
            KR: 0.5722764605792913,
            LT: 0.13136780347962246,
            LU: 0.3200708519285589,
            LV: 0.31085302956175315,
            MT: 0.41812626661538155,
            MX: 0.2520071949138837,
            NL: 0.13462219327584915,
            NO: 0.11409037074458804,
            PL: 0.3456207059974974,
            PT: 0.2255202764827933,
            RO: 0.232068209054501,
            RU: 0.48027504725661746,
            SE: 0.05659730974157014,
            SI: 0.2936946162028552,
            SK: 0.49118628393366526,
            TR: 0.46011631979817275,
            TW: 0.7815313483099299,
            US: 0.15128725774540414,
            WA: 0.6775707654860539,
            WE: 0.6537671569186151,
            WF: 0.611263835164792,
            WL: 0.2864219112063709,
            WM: 0.5789407333691907,
            ZA: 0.5626692859782424
          },
          oldKeys: ["PURCHASE_CATEGORY_HEALTHCARE_DOCTOR", "Doctor"],
          source: "https://github.com/tmrowco/bloom-contrib/tree/master/co2eq/purchase/exiobase",
          unit: "EUR",
          coicopCode: "06.2",
          year: 2011,
          displayName: "Outpatient care services",
          keywords: ["ambulatory", "rehabilitation", "consultation", "lab test", "psychological", "therapy"]
        },
        "INPATIENT CARE SERVICES": {
          coicopCode: "06.3",
          year: 2011,
          unit: "EUR",
          source: "https://github.com/tmrowco/bloom-contrib/tree/master/co2eq/purchase/exiobase",
          intensityKilograms: {
            AT: 0.19637013890293112,
            AU: 0.1736482164120421,
            BE: 0.27540268589183337,
            BG: 0.42721444059514957,
            BR: 0.19899937721648303,
            CA: 0.1079942527987319,
            CH: 0.11499976822275346,
            CN: 1.689975330609178,
            CY: 0.25004435777846523,
            CZ: 0.4398003704979697,
            DE: 0.20458647924101406,
            DK: 0.24335006191175448,
            EE: 0.8858590591925467,
            ES: 0.19177140980017374,
            FI: 0.2056902510237252,
            FR: 0.10968207491434957,
            GB: 0.1718751282710591,
            GR: 0.18069092684744295,
            HR: 0.31002115464586794,
            HU: 0.44118057868552296,
            ID: 1.217960555490836,
            IE: 0.13091149538357047,
            IN: 0.5270336649160979,
            IT: 0.1955219597230482,
            JP: 0.3066215488825217,
            KR: 0.5722764605792913,
            LT: 0.13136780347962246,
            LU: 0.3200708519285589,
            LV: 0.31085302956175315,
            MT: 0.41812626661538155,
            MX: 0.2520071949138837,
            NL: 0.13462219327584915,
            NO: 0.11409037074458804,
            PL: 0.3456207059974974,
            PT: 0.2255202764827933,
            RO: 0.232068209054501,
            RU: 0.48027504725661746,
            SE: 0.05659730974157014,
            SI: 0.2936946162028552,
            SK: 0.49118628393366526,
            TR: 0.46011631979817275,
            TW: 0.7815313483099299,
            US: 0.15128725774540414,
            WA: 0.6775707654860539,
            WE: 0.6537671569186151,
            WF: 0.611263835164792,
            WL: 0.2864219112063709,
            WM: 0.5789407333691907,
            ZA: 0.5626692859782424
          },
          displayName: "Inpatient care services",
          keywords: ["treatment", "hospital", "medical", "health"]
        }
      },
      displayName: "Health"
    },
    TRANSPORT: {
      _children: {
        "PURCHASE OF VEHICLES": {
          coicopCode: "07.1",
          year: 2011,
          unit: "EUR",
          source: "https://github.com/tmrowco/bloom-contrib/tree/master/co2eq/purchase/exiobase",
          intensityKilograms: {
            AT: 0.2929329824286619,
            AU: 0.5078416503301589,
            BE: 0.4263886527912504,
            BG: 0.547058430903503,
            BR: 0.5410018799253561,
            CA: 0.48378605398079805,
            CH: 0.2812815075572784,
            CN: 1.2347518923568075,
            CY: 0.6617287734712347,
            CZ: 0.4889956443240513,
            DE: 0.3088096681738378,
            DK: 0.40599029461005054,
            EE: 0.8034224670617682,
            ES: 0.4342143665232741,
            FI: 0.3404679074138218,
            FR: 0.2874199166179554,
            GB: 0.3353555529608455,
            GR: 0.7134677496401098,
            HR: 0.5729675127191298,
            HU: 0.4671260388716026,
            ID: 0.3205678874346394,
            IE: 0.3367575944020062,
            IN: 1.3307334888795523,
            IT: 0.35889934905920706,
            JP: 0.3826171109179261,
            KR: 1.1288459920605183,
            LT: 0.34576561036046555,
            LU: 0.6504855119704309,
            LV: 0.7493640540680238,
            MT: 0.47722223977069145,
            MX: 0.6207720053938673,
            NL: 0.2759666166947706,
            NO: 0.4934772944284854,
            PL: 0.41509362468448713,
            PT: 0.4198469032993296,
            RO: 0.40133848833166935,
            RU: 0.638260271090604,
            SE: 0.23616292888469598,
            SI: 0.4522295363622671,
            SK: 0.437577879289406,
            TR: 0.42638996051285494,
            TW: 0.35558831468897756,
            US: 0.46888790168419536,
            WA: 0.8062266582764641,
            WE: 1.238265898234773,
            WF: 0.7683652547653657,
            WL: 0.4738551603332311,
            WM: 0.7619484069170387,
            ZA: 1.5214888293712263
          },
          displayName: "Purchase of vehicles",
          keywords: ["car", "bike", "scooter", "dealer"]
        },
        "OPERATION OF PERSONAL TRANSPORT EQUIPMENT": {
          _children: {
            "Parts and accessories for personal transport equipment (SD)": {
              icon: "credit-card",
              intensityKilograms: {
                AT: 0.2505746605616965,
                AU: 0.3037342644944647,
                BE: 0.4024561830089067,
                BG: 0.4886431262923067,
                BR: 0.31592086818197096,
                CA: 0.41166896351446125,
                CH: 0.21604176826557975,
                CN: 1.4866674002780975,
                CY: 0.16729654110245493,
                CZ: 0.5415148348793624,
                DE: 0.31068500567282575,
                DK: 0.3066717381780605,
                EE: 0.6228204088548257,
                ES: 0.3013270986682197,
                FI: 0.32163487670353946,
                FR: 0.24143984243507982,
                GB: 0.3254880340950471,
                GR: 2.163372611480346,
                HR: 0.5153701146433421,
                HU: 0.5396914345132835,
                ID: 0.7786688738488747,
                IE: 0.17836545536483273,
                IN: 1.6388567408467016,
                IT: 0.2836931035213458,
                JP: 0.39962591899136,
                KR: 0.628655120191018,
                LT: 0.4057411662782367,
                LU: 0.6565811626665735,
                LV: 0.5225668405961946,
                MT: 0.7517600116846157,
                MX: 0.6108155766740936,
                NL: 0.28366405004214473,
                NO: 0.2511736702808356,
                PL: 0.4379777697394981,
                PT: 0.41312096656818187,
                RO: 0.44221459591629514,
                RU: 0.5756488265036923,
                SE: 0.21009502000486915,
                SI: 0.4130969643837526,
                SK: 0.5502631935980182,
                TR: 0.4663509133920093,
                TW: 0.4868929985104594,
                US: 0.24332349174937767,
                WA: 0.8262860832841716,
                WE: 1.1810729851228294,
                WF: 0.8176238130689387,
                WL: 0.4570085251523637,
                WM: 0.7837328103821521,
                ZA: 0.9417280606932121
              },
              oldKeys: ["PURCHASE_CATEGORY_TRANSPORTATION_AUTOMOTIVE_PARTS", "Automotive parts or accessories"],
              source: "https://github.com/tmrowco/bloom-contrib/tree/master/co2eq/purchase/exiobase",
              unit: "EUR",
              coicopCode: "07.2.1",
              year: 2011,
              displayName: "Parts and accessories for personal transport equipment"
            },
            "Fuels and lubricants for personal transport equipment (ND)": {
              _children: {
                Diesel: {
                  icon: "oil-can",
                  intensityKilograms: 3.17,
                  source: "http://www.bilans-ges.ademe.fr/static/documents/[Base%20Carbone]%20Documentation%20g%C3%A9n%C3%A9rale%20v11.0.pdf",
                  unit: "L",
                  displayName: "Diesel",
                  associatedPurchaseCategory: "Fuels and lubricants for personal transport equipment (ND)"
                },
                Gasoline: {
                  icon: "oil-can",
                  intensityKilograms: 2.8,
                  source: "http://www.bilans-ges.ademe.fr/static/documents/[Base%20Carbone]%20Documentation%20g%C3%A9n%C3%A9rale%20v11.0.pdf",
                  unit: "L",
                  displayName: "Gasoline",
                  associatedPurchaseCategory: "Fuels and lubricants for personal transport equipment (ND)"
                },
                "Heating oil": {
                  icon: "oil-can",
                  intensityKilograms: 3.26,
                  source: "http://www.bilans-ges.ademe.fr/static/documents/[Base%20Carbone]%20Documentation%20g%C3%A9n%C3%A9rale%20v11.0.pdf",
                  unit: "L",
                  oldKeys: ["Heating Oil"],
                  displayName: "Heating oil",
                  associatedPurchaseCategory: "Fuels and lubricants for personal transport equipment (ND)"
                },
                LPG: {
                  icon: "burn",
                  intensityKilograms: 1.88,
                  source: "http://www.bilans-ges.ademe.fr/static/documents/[Base%20Carbone]%20Documentation%20g%C3%A9n%C3%A9rale%20v11.0.pdf",
                  unit: "L",
                  displayName: "Lpg",
                  associatedPurchaseCategory: "Fuels and lubricants for personal transport equipment (ND)"
                },
                "Natural gas": {
                  icon: "burn",
                  intensityKilograms: 0.00026409,
                  source: "https://www.gov.uk/government/publications/greenhouse-gas-reporting-conversion-factors-2019",
                  unit: "L",
                  oldKeys: ["Natural Gas"],
                  conversions: {
                    kWh: {
                      liter: 100.6096406528,
                      incrementStepSize: 1,
                      source: "https://www.gov.uk/government/publications/greenhouse-gas-reporting-conversion-factors-2019"
                    }
                  },
                  displayName: "Natural gas",
                  associatedPurchaseCategory: "Fuels and lubricants for personal transport equipment (ND)"
                }
              },
              icon: "gas-pump",
              intensityKilograms: {
                AT: 1.9970721272222949,
                AU: 1.3778824545293922,
                BE: 1.2136322197951868,
                BG: 1.6481810897953435,
                BR: 1.0288388612932853,
                CA: 1.424990311916803,
                CH: 0.7821914562203666,
                CN: 2.3010792149281754,
                CY: 16.07214357475986,
                CZ: 2.2852600349644545,
                DE: 1.305222510931771,
                DK: 1.2530594027372912,
                EE: 0.5465837365343125,
                ES: 1.7593848975010844,
                FI: 1.9668854897178671,
                FR: 1.2560465325872645,
                GB: 1.1302220288830254,
                GR: 1.3738234040713948,
                HR: 0.7173851441959489,
                HU: 1.353224265121926,
                ID: 0.6446467889888448,
                IE: 0.5009910322001723,
                IN: 1.7666205082979192,
                IT: 1.9337941776346697,
                JP: 1.0190726021188108,
                KR: 1.4864132567867954,
                LT: 1.2296713088103106,
                LU: 0.06458507131275926,
                LV: 0.10798866841999664,
                MT: 0.4802391210286868,
                MX: 3.8422568620778104,
                NL: 1.0695675341269977,
                NO: 0.4504444050721632,
                PL: 1.399770889317885,
                PT: 1.7514721873962755,
                RO: 2.5413241525442203,
                RU: 2.044672635680266,
                SE: 1.2058556993843197,
                SI: 0.13700521838495525,
                SK: 2.6705847980609745,
                TR: 1.0241697645127843,
                TW: 2.3091930546095156,
                US: 1.6575757995286007,
                WA: 1.2854845769410428,
                WE: 1.8137103936731216,
                WF: 1.8243100148925426,
                WL: 2.3939397736856436,
                WM: 1.5639845675377353,
                ZA: 3.0935853188520084
              },
              oldKeys: ["PURCHASE_CATEGORY_TRANSPORTATION_FUEL", "Fuel"],
              source: "https://github.com/tmrowco/bloom-contrib/tree/master/co2eq/purchase/exiobase",
              unit: "EUR",
              coicopCode: "07.2.2",
              year: 2011,
              displayName: "Fuels and lubricants for personal transport equipment (ND)ipment"
            },
            "Maintenance and repair of personal transport equipment (S)": {
              icon: "credit-card",
              intensityKilograms: {
                AT: 0.20778461559563483,
                AU: 0.2633424874075986,
                BE: 0.36292536588673807,
                BG: 0.5449919291946956,
                BR: 0.7045792942533335,
                CA: 0.3106119339799669,
                CH: 0.14512357976997484,
                CN: 0.4085097757874268,
                CY: 0.36100000526058107,
                CZ: 0.5207413475501352,
                DE: 0.1623296910166624,
                DK: 0.34385557354802265,
                EE: 0.5686970197093393,
                ES: 0.43906389024332326,
                FI: 0.3309459655107,
                FR: 0.17180246184308312,
                GB: 0.19139617365180012,
                GR: 0.44953279607430163,
                HR: 0.38846938788309704,
                HU: 0.45193892631575694,
                ID: 0.19412130601291366,
                IE: 0.25579796426708723,
                IN: 0.4749804460535513,
                IT: 0.26168582623063896,
                JP: 0.19936273863421158,
                KR: 2.544919243661124,
                LT: 0.33212106243795064,
                LU: 0.1715789957171095,
                LV: 0.30955671696706366,
                MT: 0.4146149423065255,
                MX: 0.5265532285465144,
                NL: 0.3373306029647175,
                NO: 0.43002660556697825,
                PL: 0.323397825989694,
                PT: 0.4943405007542531,
                RO: 0.25175224470792656,
                RU: 0.7257833651445388,
                SE: 0.12553758308268265,
                SI: 0.259785470964029,
                SK: 0.3331101753371985,
                TR: 0.33686608672024854,
                TW: 0.23317106558964196,
                US: 0.15378737326510727,
                WA: 0.4048792460755102,
                WE: 0.8805882089431735,
                WF: 0.5774365105152244,
                WL: 0.22688327701974303,
                WM: 0.6559616640759571,
                ZA: 0.3955561221388898
              },
              oldKeys: ["PURCHASE_CATEGORY_TRANSPORTATION_AUTOMOTIVE_SERVICE", "Automotive services", "Parking lot"],
              source: "https://github.com/tmrowco/bloom-contrib/tree/master/co2eq/purchase/exiobase",
              unit: "EUR",
              coicopCode: "07.2.3",
              year: 2011,
              displayName: "Maintenance and repair of personal transport equipment"
            },
            "Other services in respect of personal transport equipment (S)": {
              coicopCode: "07.2.4",
              year: 2011,
              unit: "EUR",
              source: "https://github.com/tmrowco/bloom-contrib/tree/master/co2eq/purchase/exiobase",
              intensityKilograms: {
                AT: 0.16013877400743093,
                AU: 0.24653367138483467,
                BE: 0.42560165308666703,
                BG: 0.545520553640902,
                BR: 0.169788925002793,
                CA: 0.3207394955932621,
                CH: 0.18269318173161753,
                CN: 1.2405777849460682,
                CY: 0.20830709490066532,
                CZ: 0.5411136611643298,
                DE: 0.19688346661728318,
                DK: 0.40086881225416526,
                EE: 0.6863278795803369,
                ES: 0.2690371884698317,
                FI: 0.32130250838382335,
                FR: 0.15040709598737745,
                GB: 0.1797108510026693,
                GR: 3.9354132682226908,
                HR: 1.006404802960059,
                HU: 0.42926614068692853,
                ID: 0.41952443674279716,
                IE: 0.24895389963038062,
                IN: 1.5333582394990057,
                IT: 0.28782252228516425,
                JP: 0.20360446953357147,
                KR: 0.48056697949540184,
                LT: 0.283749212751505,
                LU: 0.40532473231119304,
                LV: 0.3362804733610287,
                MT: 0.6472792615418693,
                MX: 0.8205243384355797,
                NL: 0.30139842768256553,
                NO: 0.43976649755365205,
                PL: 0.33227480111849994,
                PT: 0.2836339871439638,
                RO: 0.2911606022560409,
                RU: 0.5196659587000363,
                SE: 0.12390815301422628,
                SI: 0.7771212705506503,
                SK: 0.49454589182133657,
                TR: 0.33895139200076363,
                TW: 0.44740742855906146,
                US: 0.1627902570389641,
                WA: 0.7233154909715465,
                WE: 0.9291498334607555,
                WF: 0.8165447681359683,
                WL: 0.27954289888316086,
                WM: 0.6953733434843732,
                ZA: 0.805322125077863
              },
              displayName: "Other services in respect of personal transport equipment",
              keywords: ["garage", "parking", "permit", "toll", "driving"]
            }
          },
          displayName: "Operation of personal transport equipment"
        },
        "PASSENGER TRANSPORT SERVICES": {
          _children: {
            "Passenger transport by railway (S)": {
              coicopCode: "07.3.1",
              year: 2011,
              unit: "EUR",
              source: "https://github.com/tmrowco/bloom-contrib/tree/master/co2eq/purchase/exiobase",
              intensityKilograms: {
                AT: 0.23689995526780824,
                AU: 0.40189654374834216,
                BE: 0.4174035940582454,
                BG: 0.5515196603971408,
                BR: 0.23201243960179033,
                CA: 0.9450938811137843,
                CH: 0.15588833467391802,
                CN: 1.980154774329301,
                CY: 0.03099604145881424,
                CZ: 0.6324070803814494,
                DE: 0.19508298410536246,
                DK: 0.5430763054644973,
                EE: 0.9139609998071143,
                ES: 0.7461717361444207,
                FI: 0.13982101026861984,
                FR: 0.26145492970549816,
                GB: 0.30177083995263043,
                GR: 0.9849084440884545,
                HR: 0.502833373912909,
                HU: 0.39578604732454126,
                ID: 0.7889021213764004,
                IE: 0.25136050956584627,
                IN: 1.7358851539178255,
                IT: 0.1850524908455684,
                JP: 0.05104996834755616,
                KR: 0.35999372429307885,
                LT: 0.6018434049311621,
                LU: 0.4689196488185049,
                LV: 0.763066662693254,
                MT: 0.35796830940881225,
                MX: 4.349316898982831,
                NL: 0.3883345554054619,
                NO: 0.11484348989335022,
                PL: 0.33846697812184295,
                PT: 0.2618115692412381,
                RO: 0.3207599077897271,
                RU: 1.0939633774356419,
                SE: 0.12599735676498314,
                SI: 0.2455132926620346,
                SK: 0.33514901183463025,
                TR: 0.10844652712459014,
                TW: 0.8033705038076563,
                US: 1.4446968493857193,
                WA: 0.9732577240545243,
                WE: 1.514734646553936,
                WF: 0.7622564605974411,
                WL: 0.3919723158574185,
                WM: 0.7120818294124031,
                ZA: 0.22043272641899714
              },
              displayName: "Passenger transport by railway",
              keywords: ["train", "metro", "underground", "tram"],
              activityType: "ACTIVITY_TYPE_TRANSPORTATION",
              transportationMode: "train"
            },
            "Passenger transport by road (S)": {
              coicopCode: "07.3.2",
              year: 2011,
              unit: "EUR",
              source: "https://github.com/tmrowco/bloom-contrib/tree/master/co2eq/purchase/exiobase",
              intensityKilograms: {
                AT: 0.14329582412825928,
                AU: 0.1592667554464537,
                BE: 0.3839999921170653,
                BG: 0.5644679453364444,
                BR: 0.3174010126230956,
                CA: 0.26530479813275726,
                CH: 0.1605604358079687,
                CN: 1.4425758020272919,
                CY: 0.19545623851173421,
                CZ: 0.6660911843452327,
                DE: 0.17339597072345425,
                DK: 0.9246976791670614,
                EE: 0.8419699408128906,
                ES: 0.3421441643623257,
                FI: 0.2636890936580304,
                FR: 0.17414716610152686,
                GB: 0.18320496453651638,
                GR: 2.0272429429749934,
                HR: 0.6974070746877971,
                HU: 0.43332689257613816,
                ID: 0.7363840881337742,
                IE: 0.18405734055272785,
                IN: 1.199729056259406,
                IT: 0.18771049331871595,
                JP: 0.19299369009085615,
                KR: 0.4543368392701182,
                LT: 0.24960299281366527,
                LU: 0.671596494626558,
                LV: 0.5966698984452423,
                MT: 0.6323285571396888,
                MX: 0.21191440008866783,
                NL: 0.415926905881485,
                NO: 0.3291193078175159,
                PL: 0.4251929710945734,
                PT: 0.36101579939376144,
                RO: 0.2777010198335145,
                RU: 0.6043760611053944,
                SE: 0.1456204504642788,
                SI: 0.32129694242492185,
                SK: 0.5507552938401753,
                TR: 0.1470731684254348,
                TW: 0.18766473261072114,
                US: 0.21231287526255477,
                WA: 0.7722190265626012,
                WE: 0.691181554284456,
                WF: 0.5449086719788503,
                WL: 0.35232179929812973,
                WM: 0.5900063059961445,
                ZA: 0.3873130910882631
              },
              displayName: "Passenger transport by road",
              keywords: ["bus", "coach", "car", "taxi", "driver", "auto", "moto", "ridesharing"],
              activityType: "ACTIVITY_TYPE_TRANSPORTATION",
              transportationMode: "car"
            },
            "Passenger transport by air (S)": {
              coicopCode: "07.3.3",
              year: 2011,
              unit: "EUR",
              source: "https://github.com/tmrowco/bloom-contrib/tree/master/co2eq/purchase/exiobase",
              intensityKilograms: {
                AT: 1.024562601907154,
                AU: 1.3216460338378595,
                BE: 1.129867048631216,
                BG: 1.2965681508912241,
                BR: 0.773024222571991,
                CA: 1.4981122985531572,
                CH: 0.7248937075775487,
                CN: 2.273822331336432,
                CY: 1.247387189149098,
                CZ: 1.3297189726446956,
                DE: 1.1364834648623874,
                DK: 0.8656996669564138,
                EE: 1.3010244849373342,
                ES: 1.7699165269622419,
                FI: 1.4871509758526642,
                FR: 1.4201434641219588,
                GB: 1.718866687664697,
                GR: 1.7599492644431853,
                HR: 1.3076792209730452,
                HU: 0.9882783691138002,
                ID: 1.4689620916409278,
                IE: 1.1535626375479442,
                IN: 2.6050312738918944,
                IT: 1.5117494065885482,
                JP: 0.9797955633186253,
                KR: 2.4818457254137463,
                LT: 0.5366231002010717,
                LU: 2.764530038391473,
                LV: 1.3843729436192844,
                MT: 1.0758480787641098,
                MX: 1.8409125325826503,
                NL: 1.6241420813898138,
                NO: 0.6353395197902632,
                PL: 1.2740601512727365,
                PT: 1.1475749666642834,
                RO: 1.5822819301176017,
                RU: 1.6037276211445568,
                SE: 0.6011632144842417,
                SI: 1.0556097229406871,
                SK: 0.8436700330948868,
                TR: 1.0148353331510427,
                TW: 2.9422552534145523,
                US: 2.0173641445281287,
                WA: 2.102271126587242,
                WE: 1.4855744404176359,
                WF: 1.5387713619168668,
                WL: 1.4977618142283924,
                WM: 3.1270321193427693,
                ZA: 3.1806258132953453
              },
              displayName: "Passenger transport by air",
              keywords: ["flight", "plane"],
              activityType: "ACTIVITY_TYPE_TRANSPORTATION",
              transportationMode: "plane"
            },
            "Passenger transport by sea and inland waterway (S)": {
              coicopCode: "07.3.4",
              year: 2011,
              unit: "EUR",
              source: "https://github.com/tmrowco/bloom-contrib/tree/master/co2eq/purchase/exiobase",
              intensityKilograms: {
                AT: 0.798184617532687,
                AU: 3.5656213549229276,
                BE: 1.3138419735005824,
                BG: 0.7132765805559186,
                BR: 1.6806536058600492,
                CA: 5.656101151383927,
                CH: 0.5234520962085463,
                CN: 10.575843526144407,
                CY: 5.953785918500256,
                CZ: 4.0956454666268165,
                DE: 2.896785280156379,
                DK: 2.9950922194664207,
                EE: 1.3663725859472948,
                ES: 23.81627766713278,
                FI: 8.40735138095053,
                FR: 2.6787454255091476,
                GB: 4.316295381170185,
                GR: 10.261912310936347,
                HR: 3.3163591314211716,
                HU: 0.8404645087646445,
                ID: 4.634302460647262,
                IE: 0.8904159378924423,
                IN: 8.70652129334539,
                IT: 7.605859400474809,
                JP: 25.086710994127685,
                KR: 2.695775506700818,
                LT: 2.003085074833448,
                LU: 3.362186772420249,
                LV: 7.846510385856008,
                MT: 1.0536453324218413,
                MX: 18.039393201022108,
                NL: 1.7478855804059275,
                NO: 200.2558313836995,
                PL: 0.27355252288851334,
                PT: 3.3684149922525277,
                RO: 2.2072074819240814,
                RU: 2.588799363030442,
                SE: 1.682168841595301,
                SI: 0.9421968450820246,
                SK: 0.5341374280265153,
                TR: 2.488465238796061,
                TW: 14.942385375512597,
                US: 2.1932601738280266,
                WA: 3.3707774073696686,
                WE: 2.2517138137992245,
                WF: 1.661022364918163,
                WL: 6.312064100937999,
                WM: 2.080746791517273,
                ZA: 0.9637843911205218
              },
              displayName: "Passenger transport by sea and inland waterway",
              keywords: ["ship", "boat", "ferry"],
              activityType: "ACTIVITY_TYPE_TRANSPORTATION",
              transportationMode: "ferry"
            },
            "Combined passenger transport (S)": {
              coicopCode: "07.3.5",
              year: 2011,
              unit: "EUR",
              source: "https://github.com/tmrowco/bloom-contrib/tree/master/co2eq/purchase/exiobase",
              intensityKilograms: {
                AT: 0.1374337367650893,
                AU: 0.16397221933734732,
                BE: 0.37984171220587076,
                BG: 0.5739356484816667,
                BR: 0.3484411193343159,
                CA: 0.2428584880151186,
                CH: 0.16487324445174031,
                CN: 1.5921993748720884,
                CY: 0.22125657599187706,
                CZ: 0.6936090598905217,
                DE: 0.1467448870398087,
                DK: 1.0175773838788575,
                EE: 0.8744081475316559,
                ES: 0.3414542866809518,
                FI: 0.2515465180663927,
                FR: 0.17983313343238191,
                GB: 0.18888017356002107,
                GR: 1.321379357465392,
                HR: 0.7435898730149173,
                HU: 0.4484657456663488,
                ID: 0.7733374689948174,
                IE: 0.18339495832619163,
                IN: 1.1583869950012118,
                IT: 0.17819190079154024,
                JP: 0.20945051958441704,
                KR: 0.5048758882377882,
                LT: 0.24779434456709434,
                LU: 0.5533675394035006,
                LV: 0.565927290211588,
                MT: 0.6136193045060886,
                MX: 0.21582639725196318,
                NL: 0.4174580320706783,
                NO: 0.3316079880796086,
                PL: 0.4263397995781428,
                PT: 0.3996740959262809,
                RO: 0.28012528372895545,
                RU: 0.6374465085284903,
                SE: 0.1291880868418653,
                SI: 0.3248924074668413,
                SK: 0.5566669979250355,
                TR: 0.15159063502322537,
                TW: 0.2072581840897266,
                US: 0.2209859494128679,
                WA: 0.7603468881126303,
                WE: 0.6999400825430615,
                WF: 0.535306696208601,
                WL: 0.36347771651818406,
                WM: 0.5816755974827273,
                ZA: 0.43075789372134865
              },
              displayName: "Combined passenger transport",
              activityType: "ACTIVITY_TYPE_TRANSPORTATION",
              transportationMode: "public_transport"
            },
            "Other purchased transport services (S)": {
              coicopCode: "07.3.6",
              year: 2011,
              unit: "EUR",
              source: "https://github.com/tmrowco/bloom-contrib/tree/master/co2eq/purchase/exiobase",
              intensityKilograms: {
                AT: 0.35132482243943225,
                AU: 0.5207236634397208,
                BE: 0.8742976267116568,
                BG: 1.0863637605175902,
                BR: 0.3657342603096244,
                CA: 0.4572070390633048,
                CH: 0.18580102182097524,
                CN: 1.5528904374819616,
                CY: 0.23752610861176623,
                CZ: 1.0410366529385366,
                DE: 0.5141467506850318,
                DK: 1.082051651576009,
                EE: 0.8182185139971977,
                ES: 0.36426409400867565,
                FI: 0.2587668958929021,
                FR: 0.4352002920873382,
                GB: 0.20353389657124793,
                GR: 1.3859871223941156,
                HR: 0.7017938947353058,
                HU: 0.4281126646851739,
                ID: 0.7205412341274281,
                IE: 0.3630784333920348,
                IN: 1.1686170369013278,
                IT: 0.28488100003306194,
                JP: 0.20473913285107925,
                KR: 0.48342707432074056,
                LT: 0.7487332594481667,
                LU: 0.6282093196325401,
                LV: 0.5314637521358619,
                MT: 0.5878883148699686,
                MX: 0.3403016504893319,
                NL: 0.4637383074485859,
                NO: 0.33031264677726857,
                PL: 0.5117620487192108,
                PT: 0.4378581718958067,
                RO: 0.29467340123643265,
                RU: 3.4038412807724296,
                SE: 0.1456832439651873,
                SI: 0.5655545383244232,
                SK: 1.0578391240681992,
                TR: 0.1651549201734505,
                TW: 0.3210723656669702,
                US: 1.9187724894757479,
                WA: 0.9653768164152715,
                WE: 1.8366050135375163,
                WF: 0.6477655960197922,
                WL: 0.405044373584727,
                WM: 0.6491589211543322,
                ZA: 0.594045690074334
              },
              displayName: "Other purchased transport services",
              keywords: ["funicular", "elevator", "bridge", "freight", "movers"],
              activityType: "ACTIVITY_TYPE_TRANSPORTATION",
              transportationMode: "public_transport"
            }
          },
          displayName: "Passenger transport services"
        }
      },
      displayName: "Transport"
    },
    "INFORMATION AND COMMUNICATION": {
      _children: {
        "Information and communication equipment": {
          _children: {
            "Mobile phone": {
              icon: "mobile",
              intensityKilograms: 32,
              source: "https://www.ademe.fr/sites/default/files/assets/documents/poids_carbone-biens-equipement-201809-rapport.pdf",
              unit: "item",
              usage: "20%",
              _children: {
                "Feature phone": {
                  icon: "mobile",
                  intensityKilograms: 16,
                  source: "https://www.ademe.fr/sites/default/files/assets/documents/poids_carbone-biens-equipement-201809-rapport.pdf",
                  unit: "item",
                  usage: "20%",
                  displayName: "Feature phone",
                  associatedPurchaseCategory: "Information and communication equipment"
                },
                "iPhone 11": {
                  deviceId: "iPhone12,1",
                  icon: "mobile",
                  intensityKilograms: 72,
                  source: "https://www.apple.com/lae/environment/pdf/products/iphone/iPhone_11_PER_sept2019.pdf",
                  unit: "item",
                  usage: "17%",
                  displayName: "Iphone 11",
                  associatedPurchaseCategory: "Information and communication equipment"
                },
                "iPhone 11 Pro": {
                  deviceId: "iPhone12,3",
                  icon: "mobile",
                  intensityKilograms: 80,
                  source: "https://www.apple.com/lae/environment/pdf/products/iphone/iPhone_11_Pro_PER_sept2019.pdf",
                  unit: "item",
                  usage: "13%",
                  displayName: "Iphone 11 pro",
                  associatedPurchaseCategory: "Information and communication equipment"
                },
                "iPhone 11 Pro Max": {
                  deviceId: "iPhone12,5",
                  icon: "mobile",
                  intensityKilograms: 86,
                  source: "https://www.apple.com/lae/environment/pdf/products/iphone/iPhone_11_Pro_Max_PER_sept2019.pdf",
                  unit: "item",
                  usage: "18%",
                  displayName: "Iphone 11 pro max",
                  associatedPurchaseCategory: "Information and communication equipment"
                },
                "iPhone 8": {
                  deviceId: "iPhone10,1",
                  icon: "mobile",
                  intensityKilograms: 57,
                  source: "https://www.apple.com/lae/environment/pdf/products/iphone/iPhone_8_PER_sept2017.pdf",
                  unit: "item",
                  usage: "16%",
                  displayName: "Iphone 8",
                  associatedPurchaseCategory: "Information and communication equipment"
                },
                "iPhone 8 Plus": {
                  deviceId: "iPhone10,2",
                  icon: "mobile",
                  intensityKilograms: 68,
                  source: "https://www.apple.com/lae/environment/pdf/products/iphone/iPhone_8_Plus_PER_sept2017.pdf",
                  unit: "item",
                  usage: "17%",
                  displayName: "Iphone 8 plus",
                  associatedPurchaseCategory: "Information and communication equipment"
                },
                "iPhone XR": {
                  deviceId: "iPhone11,8",
                  icon: "mobile",
                  intensityKilograms: 62,
                  source: "https://www.apple.com/lae/environment/pdf/products/iphone/iPhone_XR_PER_sept2018.pdf",
                  unit: "item",
                  usage: "19%",
                  displayName: "Iphone xr",
                  associatedPurchaseCategory: "Information and communication equipment"
                },
                "iPhone SE": {
                  deviceId: "iPhone8,4",
                  icon: "mobile",
                  intensityKilograms: 45,
                  source: "https://www.apple.com/lae/environment/pdf/products/iphone/iPhone_SE_PER_sept2017.pdf",
                  unit: "item",
                  displayName: "Iphone se",
                  associatedPurchaseCategory: "Information and communication equipment"
                }
              },
              displayName: "Mobile phone",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "AirPort Express": {
              icon: "network-wired",
              intensityKilograms: 95,
              source: "https://www.apple.com/lae/environment/pdf/products/airport/AirPortExpress_PER_june2012.pdf",
              unit: "item",
              usage: "60%",
              displayName: "Airport express",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "AirPort Extreme": {
              icon: "network-wired",
              intensityKilograms: 250,
              source: "https://www.apple.com/lae/environment/pdf/products/airport/AirPortExtreme_PER_june2013.pdf",
              unit: "item",
              usage: "76%",
              displayName: "Airport extreme",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "AirPort Time Capsule": {
              icon: "network-wired",
              intensityKilograms: 310,
              source: "https://www.apple.com/lae/environment/pdf/products/airport/AirPortTimeCapsule_PER_june2013.pdf",
              unit: "item",
              usage: "70%",
              displayName: "Airport time capsule",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Apple TV": {
              icon: "network-wired",
              intensityKilograms: 65,
              source: "https://www.apple.com/lae/environment/pdf/products/appletv/Apple_TV_PER_sept2017.pdf",
              unit: "item",
              usage: "30%",
              displayName: "Apple tv",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Apple TV 4K": {
              icon: "network-wired",
              intensityKilograms: 58,
              source: "https://www.apple.com/lae/environment/pdf/products/appletv/Apple_TV_4K_PER_sept2017.pdf",
              unit: "item",
              usage: "29%",
              displayName: "Apple tv 4k",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Apple Watch Series 3 (GPS + Cellular)": {
              icon: "watch-fitness",
              intensityKilograms: 36,
              source: "https://www.apple.com/lae/environment/pdf/products/watch/Apple_Watch_Series3_GPSCellular_PER_sept2018.pdf",
              unit: "item",
              usage: "15%",
              displayName: "Apple watch series 3 (gps + cellular)",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Apple Watch Series 3 (GPS)": {
              icon: "watch-fitness",
              intensityKilograms: 28,
              source: "https://www.apple.com/lae/environment/pdf/products/watch/Apple_Watch_Series3_GPS_PER_sept2018.pdf",
              unit: "item",
              usage: "20%",
              displayName: "Apple watch series 3 (gps)",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Apple Watch Series 5 (GPS + Cellular)": {
              icon: "watch-fitness",
              intensityKilograms: 40,
              source: "https://www.apple.com/lae/environment/pdf/products/watch/Apple_Watch_Series5_PER_sept2019.pdf",
              unit: "item",
              usage: "13%",
              displayName: "Apple watch series 5 (gps + cellular)",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            Homepod: {
              icon: "volume",
              intensityKilograms: 146,
              source: "https://www.apple.com/lae/environment/pdf/products/homepod/HomePod_PER_feb2018.pdf",
              unit: "item",
              usage: "41%",
              displayName: "Homepod",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Latitude 3150": {
              icon: "laptop",
              intensityKilograms: 216,
              source: "https://i.dell.com/sites/csdocuments/CorpComm_Docs/en/carbon-footprint-latitude-3150.pdf",
              unit: "item",
              usage: "17.6%",
              displayName: "Latitude 3150",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Latitude 3160": {
              icon: "laptop",
              intensityKilograms: 244,
              source: "https://i.dell.com/sites/csdocuments/CorpComm_Docs/en/carbon-footprint-latitude-3160.pdf",
              unit: "item",
              usage: "27.6%",
              displayName: "Latitude 3160",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Latitude 3180": {
              icon: "laptop",
              intensityKilograms: 243,
              source: "https://i.dell.com/sites/csdocuments/CorpComm_Docs/en/carbon-footprint-latitude-3180.pdf",
              unit: "item",
              usage: "10.4%",
              displayName: "Latitude 3180",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Latitude 3189": {
              icon: "laptop",
              intensityKilograms: 257,
              source: "https://i.dell.com/sites/csdocuments/CorpComm_Docs/en/carbon-footprint-latitude-3189.pdf",
              unit: "item",
              usage: "12.1%",
              displayName: "Latitude 3189",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Latitude 3190": {
              icon: "laptop",
              intensityKilograms: 226,
              source: "https://i.dell.com/sites/csdocuments/CorpComm_Docs/en/carbon-footprint-latitude-3190.pdf",
              unit: "item",
              usage: "11.5%",
              displayName: "Latitude 3190",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Latitude 3190 2-in-1": {
              icon: "laptop",
              intensityKilograms: 230,
              source: "https://i.dell.com/sites/csdocuments/CorpComm_Docs/en/carbon-footprint-latitude-3190-2.pdf",
              unit: "item",
              usage: "12.9%",
              displayName: "Latitude 3190 2-in-1",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Latitude 3380": {
              icon: "laptop",
              intensityKilograms: 252,
              source: "https://i.dell.com/sites/csdocuments/CorpComm_Docs/en/carbon-footprint-latitude-3380.pdf",
              unit: "item",
              usage: "18.9%",
              displayName: "Latitude 3380",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Latitude 3460": {
              icon: "laptop",
              intensityKilograms: 279,
              source: "https://i.dell.com/sites/csdocuments/CorpComm_Docs/en/carbon-footprint-latitude-3460.pdf",
              unit: "item",
              usage: "15.1%",
              displayName: "Latitude 3460",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Latitude 3470": {
              icon: "laptop",
              intensityKilograms: 286,
              source: "https://i.dell.com/sites/csdocuments/CorpComm_Docs/en/carbon-footprint-latitude-3470.pdf",
              unit: "item",
              usage: "14.7%",
              displayName: "Latitude 3470",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Latitude 3480": {
              icon: "laptop",
              intensityKilograms: 324,
              source: "https://i.dell.com/sites/csdocuments/CorpComm_Docs/en/carbon-footprint-latitude-3480.pdf",
              unit: "item",
              usage: "24.1%",
              displayName: "Latitude 3480",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Latitude 3490": {
              icon: "laptop",
              intensityKilograms: 243,
              source: "https://i.dell.com/sites/csdocuments/CorpComm_Docs/en/carbon-footprint-latitude-3490.pdf",
              unit: "item",
              usage: "18.5%",
              displayName: "Latitude 3490",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Latitude 3550": {
              icon: "laptop",
              intensityKilograms: 263,
              source: "https://i.dell.com/sites/csdocuments/CorpComm_Docs/en/carbon-footprint-latitude-3550.pdf",
              unit: "item",
              usage: "11.8%",
              displayName: "Latitude 3550",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Latitude 3560": {
              icon: "laptop",
              intensityKilograms: 298,
              source: "https://i.dell.com/sites/csdocuments/CorpComm_Docs/en/carbon-footprint-latitude-3560.pdf",
              unit: "item",
              usage: "14.5%",
              displayName: "Latitude 3560",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Latitude 3570": {
              icon: "laptop",
              intensityKilograms: 302,
              source: "https://i.dell.com/sites/csdocuments/CorpComm_Docs/en/carbon-footprint-latitude-3570.pdf",
              unit: "item",
              usage: "14.6%",
              displayName: "Latitude 3570",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Latitude 3580": {
              icon: "laptop",
              intensityKilograms: 311,
              source: "https://i.dell.com/sites/csdocuments/CorpComm_Docs/en/carbon-footprint-latitude-3580.pdf",
              unit: "item",
              usage: "24.8%",
              displayName: "Latitude 3580",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Latitude 3590": {
              icon: "laptop",
              intensityKilograms: 254,
              source: "https://i.dell.com/sites/csdocuments/CorpComm_Docs/en/carbon-footprint-latitude-3590.pdf",
              unit: "item",
              usage: "17.8%",
              displayName: "Latitude 3590",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Latitude 5250": {
              icon: "laptop",
              intensityKilograms: 235,
              source: "https://i.dell.com/sites/csdocuments/CorpComm_Docs/en/carbon-footprint-latitude-5250.pdf",
              unit: "item",
              usage: "17.2%",
              displayName: "Latitude 5250",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Latitude 5280": {
              icon: "laptop",
              intensityKilograms: 225,
              source: "https://i.dell.com/sites/csdocuments/CorpComm_Docs/en/carbon-footprint-latitude-5280.pdf",
              unit: "item",
              usage: "16.8%",
              displayName: "Latitude 5280",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Latitude 5285 2-in-1": {
              icon: "laptop",
              intensityKilograms: 258,
              source: "https://i.dell.com/sites/csdocuments/CorpComm_Docs/en/carbon-footprint-latitude-5285.pdf",
              unit: "item",
              usage: "20%",
              displayName: "Latitude 5285 2-in-1",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Latitude 5289 2-in-1": {
              icon: "laptop",
              intensityKilograms: 259,
              source: "https://i.dell.com/sites/csdocuments/CorpComm_Docs/en/carbon-footprint-latitude-5289.pdf",
              unit: "item",
              usage: "16.7%",
              displayName: "Latitude 5289 2-in-1",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Latitude 5290": {
              icon: "laptop",
              intensityKilograms: 218,
              source: "https://i.dell.com/sites/csdocuments/CorpComm_Docs/en/carbon-footprint-latitude-5290.pdf",
              unit: "item",
              usage: "20%",
              displayName: "Latitude 5290",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Latitude 5290 2-in-1": {
              icon: "laptop",
              intensityKilograms: 268,
              source: "https://i.dell.com/sites/csdocuments/CorpComm_Docs/en/carbon-footprint-latitude-5290-2.pdf",
              unit: "item",
              usage: "14.3%",
              displayName: "Latitude 5290 2-in-1",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Latitude 5450": {
              icon: "laptop",
              intensityKilograms: 247,
              source: "https://i.dell.com/sites/csdocuments/CorpComm_Docs/en/carbon-footprint-latitude-5450.pdf",
              unit: "item",
              usage: "16.1%",
              displayName: "Latitude 5450",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Latitude 5480": {
              icon: "laptop",
              intensityKilograms: 250,
              source: "https://i.dell.com/sites/csdocuments/CorpComm_Docs/en/carbon-footprint-latitude-5480.pdf",
              unit: "item",
              usage: "17.5%",
              displayName: "Latitude 5480",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Latitude 5490": {
              icon: "laptop",
              intensityKilograms: 251,
              source: "https://i.dell.com/sites/csdocuments/CorpComm_Docs/en/carbon-footprint-latitude-5490.pdf",
              unit: "item",
              usage: "17.6%",
              displayName: "Latitude 5490",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Latitude 5491": {
              icon: "laptop",
              intensityKilograms: 254,
              source: "https://i.dell.com/sites/csdocuments/CorpComm_Docs/en/carbon-footprint-latitude-5491.pdf",
              unit: "item",
              usage: "14.9%",
              displayName: "Latitude 5491",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Latitude 5495": {
              icon: "laptop",
              intensityKilograms: 255,
              source: "https://i.dell.com/sites/csdocuments/CorpComm_Docs/en/carbon-footprint-latitude-5495.pdf",
              unit: "item",
              usage: "20.5%",
              displayName: "Latitude 5495",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Latitude 5550": {
              icon: "laptop",
              intensityKilograms: 259,
              source: "https://i.dell.com/sites/csdocuments/CorpComm_Docs/en/carbon-footprint-latitude-5550.pdf",
              unit: "item",
              usage: "13.4%",
              displayName: "Latitude 5550",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Latitude 5580": {
              icon: "laptop",
              intensityKilograms: 299,
              source: "https://i.dell.com/sites/csdocuments/CorpComm_Docs/en/carbon-footprint-latitude-5580.pdf",
              unit: "item",
              usage: "17.4%",
              displayName: "Latitude 5580",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Latitude 5590": {
              icon: "laptop",
              intensityKilograms: 271,
              source: "https://i.dell.com/sites/csdocuments/CorpComm_Docs/en/carbon-footprint-latitude-5590.pdf",
              unit: "item",
              usage: "22.2%",
              displayName: "Latitude 5590",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Latitude 5591": {
              icon: "laptop",
              intensityKilograms: 305,
              source: "https://i.dell.com/sites/csdocuments/CorpComm_Docs/en/carbon-footprint-latitude-5591.pdf",
              unit: "item",
              usage: "16.2%",
              displayName: "Latitude 5591",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Latitude 7280": {
              icon: "laptop",
              intensityKilograms: 222,
              source: "https://i.dell.com/sites/csdocuments/CorpComm_Docs/en/carbon-footprint-latitude-7280.pdf",
              unit: "item",
              usage: "15.4%",
              displayName: "Latitude 7280",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Latitude 7285": {
              icon: "laptop",
              intensityKilograms: 282,
              source: "https://i.dell.com/sites/csdocuments/CorpComm_Docs/en/carbon-footprint-latitude-7285.pdf",
              unit: "item",
              usage: "12.8%",
              displayName: "Latitude 7285",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Latitude 7290": {
              icon: "laptop",
              intensityKilograms: 209,
              source: "https://i.dell.com/sites/csdocuments/CorpComm_Docs/en/carbon-footprint-latitude-7290.pdf",
              unit: "item",
              usage: "14.1%",
              displayName: "Latitude 7290",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Latitude 7350": {
              icon: "laptop",
              intensityKilograms: 297,
              source: "https://i.dell.com/sites/csdocuments/CorpComm_Docs/en/carbon-footprint-latitude-7350.pdf",
              unit: "item",
              usage: "5.3%",
              displayName: "Latitude 7350",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Latitude 7370": {
              icon: "laptop",
              intensityKilograms: 288,
              source: "https://i.dell.com/sites/csdocuments/CorpComm_Docs/en/carbon-footprint-latitude-7370.pdf",
              unit: "item",
              usage: "15.1%",
              displayName: "Latitude 7370",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Latitude 7380": {
              icon: "laptop",
              intensityKilograms: 259,
              source: "https://i.dell.com/sites/csdocuments/CorpComm_Docs/en/carbon-footprint-latitude-7380.pdf",
              unit: "item",
              usage: "17.9%",
              displayName: "Latitude 7380",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Latitude 7389": {
              icon: "laptop",
              intensityKilograms: 289,
              source: "https://i.dell.com/sites/csdocuments/CorpComm_Docs/en/carbon-footprint-latitude-7389.pdf",
              unit: "item",
              usage: "16.6%",
              displayName: "Latitude 7389",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Latitude 7390": {
              icon: "laptop",
              intensityKilograms: 222,
              source: "https://i.dell.com/sites/csdocuments/CorpComm_Docs/en/carbon-footprint-latitude-7390.pdf",
              unit: "item",
              usage: "12.1%",
              displayName: "Latitude 7390",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Latitude 7390 2-in-1": {
              icon: "laptop",
              intensityKilograms: 332,
              source: "https://i.dell.com/sites/csdocuments/CorpComm_Docs/en/carbon-footprint-latitude-7390-2.pdf",
              unit: "item",
              usage: "12.4%",
              displayName: "Latitude 7390 2-in-1",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Latitude 7480": {
              icon: "laptop",
              intensityKilograms: 249,
              source: "https://i.dell.com/sites/csdocuments/CorpComm_Docs/en/carbon-footprint-latitude-7480.pdf",
              unit: "item",
              usage: "17.4%",
              displayName: "Latitude 7480",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Latitude 7490": {
              icon: "laptop",
              intensityKilograms: 241,
              source: "https://i.dell.com/sites/csdocuments/CorpComm_Docs/en/carbon-footprint-latitude-7490.pdf",
              unit: "item",
              usage: "12.6%",
              displayName: "Latitude 7490",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Latitude E5270": {
              icon: "laptop",
              intensityKilograms: 240,
              source: "https://i.dell.com/sites/csdocuments/CorpComm_Docs/en/carbon-footprint-latitude-e5270.pdf",
              unit: "item",
              usage: "18.1%",
              displayName: "Latitude e5270",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Latitude E5570": {
              icon: "laptop",
              intensityKilograms: 240,
              source: "https://i.dell.com/sites/csdocuments/CorpComm_Docs/en/carbon-footprint-latitude-e5570.pdf",
              unit: "item",
              usage: "17.4%",
              displayName: "Latitude e5570",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Latitude E7250": {
              icon: "laptop",
              intensityKilograms: 223,
              source: "https://i.dell.com/sites/csdocuments/CorpComm_Docs/en/carbon-footprint-latitude-e7250.pdf",
              unit: "item",
              usage: "13.7%",
              displayName: "Latitude e7250",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Latitude E7270": {
              icon: "laptop",
              intensityKilograms: 249,
              source: "https://i.dell.com/sites/csdocuments/CorpComm_Docs/en/carbon-footprint-latitude-e7270.pdf",
              unit: "item",
              usage: "19.8%",
              displayName: "Latitude e7270",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Latitude E7450": {
              icon: "laptop",
              intensityKilograms: 238,
              source: "https://i.dell.com/sites/csdocuments/CorpComm_Docs/en/carbon-footprint-latitude-e7450.pdf",
              unit: "item",
              usage: "15.3%",
              displayName: "Latitude e7450",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Latitude E7470": {
              icon: "laptop",
              intensityKilograms: 261,
              source: "https://i.dell.com/sites/csdocuments/CorpComm_Docs/en/carbon-footprint-latitude-e7470.pdf",
              unit: "item",
              usage: "19%",
              displayName: "Latitude e7470",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Mac Pro": {
              icon: "desktop",
              intensityKilograms: 1000,
              source: "https://www.apple.com/lae/environment/pdf/products/desktops/MacPro_PER_June2017.pdf",
              unit: "item",
              usage: "50%",
              displayName: "Mac pro",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Mac mini": {
              icon: "desktop",
              intensityKilograms: 226,
              source: "https://www.apple.com/lae/environment/pdf/products/desktops/Macmini_PER_oct2018.pdf",
              unit: "item",
              usage: "3%",
              displayName: "Mac mini",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "MacBook 12-inch": {
              icon: "laptop",
              intensityKilograms: 233,
              source: "https://www.apple.com/environment/pdf/products/notebooks/12inch_MacBook_PER_June2019.pdf",
              unit: "item",
              usage: "12%",
              displayName: "Macbook 12-inch",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "MacBook Air 13-inch": {
              icon: "laptop",
              intensityKilograms: 176,
              source: "https://www.apple.com/lae/environment/pdf/products/notebooks/13-inch_MacBookAir_w_Retina_PER_June2019.pdf",
              unit: "item",
              usage: "6%",
              displayName: "Macbook air 13-inch",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "MacBook Pro 13-inch": {
              icon: "laptop",
              intensityKilograms: 210,
              source: "https://www.apple.com/lae/environment/pdf/products/notebooks/13-inch_MacBookPro_PER_June2019.pdf",
              unit: "item",
              usage: "6%",
              displayName: "Macbook pro 13-inch",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "MacBook Pro 15-inch": {
              icon: "laptop",
              intensityKilograms: 334,
              source: "https://www.apple.com/lae/environment/pdf/products/notebooks/15-inch_MacBookPro_PER_may2019.pdf",
              unit: "item",
              usage: "21%",
              displayName: "Macbook pro 15-inch",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "MacBook Pro 16-inch": {
              icon: "laptop",
              intensityKilograms: 394,
              source: "https://www.apple.com/environment/pdf/products/notebooks/16-inch_MacBookPro_PER_Nov2019.pdf",
              unit: "item",
              usage: "19%",
              displayName: "Macbook pro 16-inch",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "iMac 21.5-inch": {
              icon: "desktop",
              intensityKilograms: 494,
              source: "https://www.apple.com/lae/environment/pdf/products/desktops/21.5-inch_iMac_PER_June2017.pdf",
              unit: "item",
              usage: "54%",
              displayName: "Imac 21.5-inch",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "iMac 21.5-inch with Retina 4k": {
              icon: "desktop",
              intensityKilograms: 588,
              source: "https://www.apple.com/lae/environment/pdf/products/desktops/21.5-inch_iMac_with_Retina4KDisplay_PER_Mar2019.pdf",
              unit: "item",
              usage: "51%",
              displayName: "Imac 21.5-inch with retina 4k",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "iMac 27-inch": {
              icon: "desktop",
              intensityKilograms: 993,
              source: "https://www.apple.com/lae/environment/pdf/products/desktops/27-inch_iMac_with_Retina5KDisplay_PER_Mar2019.pdf",
              unit: "item",
              usage: "55%",
              displayName: "Imac 27-inch",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "iMac Pro": {
              icon: "desktop",
              intensityKilograms: 1468,
              source: "https://www.apple.com/lae/environment/pdf/products/desktops/iMac_Pro_PER_dec2017.pdf",
              unit: "item",
              usage: "54%",
              displayName: "Imac pro",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "iPad (7th generation)": {
              icon: "tablet",
              intensityKilograms: 87,
              source: "https://www.apple.com/lae/environment/pdf/products/ipad/iPad_PER_sept2019.pdf",
              unit: "item",
              usage: "14%",
              displayName: "Ipad (7th generation)",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "iPad Air (3rd generation)": {
              icon: "tablet",
              intensityKilograms: 86,
              source: "https://www.apple.com/lae/environment/pdf/products/ipad/iPadAir_PER_Mar2019.pdf",
              unit: "item",
              usage: "13%",
              displayName: "Ipad air (3rd generation)",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "iPad Pro (11-inch)": {
              icon: "tablet",
              intensityKilograms: 113,
              source: "https://www.apple.com/lae/environment/pdf/products/ipad/iPadPro_11-inch_PER_oct2018.pdf",
              unit: "item",
              usage: "5%",
              displayName: "Ipad pro (11-inch)",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "iPad Pro (12.9-inch) (3rd generation)": {
              icon: "tablet",
              intensityKilograms: 136,
              source: "https://www.apple.com/lae/environment/pdf/products/ipad/iPadPro_12.9-inch_PER_oct2018.pdf",
              unit: "item",
              usage: "6%",
              displayName: "Ipad pro (12.9-inch) (3rd generation)",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "iPad mini (5th generation)": {
              icon: "tablet",
              intensityKilograms: 70,
              source: "https://www.apple.com/lae/environment/pdf/products/ipad/iPadmini_PER_Mar2019.pdf",
              unit: "item",
              usage: "15%",
              displayName: "Ipad mini (5th generation)",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "iPod touch": {
              icon: "mobile",
              intensityKilograms: 32,
              source: "https://www.apple.com/lae/environment/pdf/products/ipod/iPodtouch_PER_may2019.pdf",
              unit: "item",
              usage: "6%",
              displayName: "Ipod touch",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "OptiPlex 7760 All-in-One": {
              icon: "desktop",
              intensityKilograms: 720,
              source: "https://i.dell.com/sites/csdocuments/CorpComm_Docs/en/carbon-footprint-optiplex-7760.pdf",
              unit: "item",
              usage: "35%",
              displayName: "Optiplex 7760 all-in-one",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Dell OptiPlex XE3 Tower": {
              icon: "desktop",
              intensityKilograms: 509,
              source: "https://i.dell.com/sites/csdocuments/CorpComm_Docs/en/carbon-footprint-optiplex-XE3-tower.pdf",
              unit: "item",
              usage: "50.8%",
              displayName: "Dell optiplex xe3 tower",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Precision 3510": {
              icon: "laptop",
              intensityKilograms: 331,
              source: "https://i.dell.com/sites/csdocuments/CorpComm_Docs/en/carbon-footprint-precision-3510.pdf",
              unit: "item",
              usage: "23%",
              displayName: "Precision 3510",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Precision 3520": {
              icon: "laptop",
              intensityKilograms: 304,
              source: "https://i.dell.com/sites/csdocuments/CorpComm_Docs/en/carbon-footprint-precision-3520.pdf",
              unit: "item",
              usage: "16.2%",
              displayName: "Precision 3520",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Precision 3530": {
              icon: "laptop",
              intensityKilograms: 335,
              source: "https://i.dell.com/sites/csdocuments/CorpComm_Docs/en/carbon-footprint-precision-3530.pdf",
              unit: "item",
              usage: "17.4%",
              displayName: "Precision 3530",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Precision 5520": {
              icon: "laptop",
              intensityKilograms: 368,
              source: "https://i.dell.com/sites/csdocuments/CorpComm_Docs/en/carbon-footprint-precision-5520.pdf",
              unit: "item",
              usage: "25.7%",
              displayName: "Precision 5520",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Precision 5530": {
              icon: "laptop",
              intensityKilograms: 340,
              source: "https://i.dell.com/sites/csdocuments/CorpComm_Docs/en/carbon-footprint-precision-5530.pdf",
              unit: "item",
              usage: "16%",
              displayName: "Precision 5530",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Precision 5530 2-in-1": {
              icon: "laptop",
              intensityKilograms: 330,
              source: "https://i.dell.com/sites/csdocuments/CorpComm_Docs/en/carbon-footprint-precision-5530-2.pdf",
              unit: "item",
              usage: "13.8%",
              displayName: "Precision 5530 2-in-1",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Precision 7520": {
              icon: "laptop",
              intensityKilograms: 399,
              source: "https://i.dell.com/sites/csdocuments/CorpComm_Docs/en/carbon-footprint-precision-7520.pdf",
              unit: "item",
              usage: "28%",
              displayName: "Precision 7520",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Precision 7720": {
              icon: "laptop",
              intensityKilograms: 416,
              source: "https://i.dell.com/sites/csdocuments/CorpComm_Docs/en/carbon-footprint-precision-7720.pdf",
              unit: "item",
              usage: "23.1%",
              displayName: "Precision 7720",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Precision 7920": {
              icon: "desktop",
              intensityKilograms: 2496,
              source: "https://i.dell.com/sites/csdocuments/CorpComm_Docs/en/carbon-footprint-precision-7920.pdf",
              unit: "item",
              usage: "74.8%",
              displayName: "Precision 7920",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "XPS 9360": {
              icon: "laptop",
              intensityKilograms: 286,
              source: "https://i.dell.com/sites/csdocuments/CorpComm_Docs/en/carbon-footprint-xps-9360.pdf",
              unit: "item",
              usage: "20%",
              displayName: "Xps 9360",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "XPS 9365": {
              icon: "laptop",
              intensityKilograms: 287,
              source: "https://i.dell.com/sites/csdocuments/CorpComm_Docs/en/carbon-footprint-xps-9365.pdf",
              unit: "item",
              usage: "16.8%",
              displayName: "Xps 9365",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "XPS 9370": {
              icon: "laptop",
              intensityKilograms: 297,
              source: "https://i.dell.com/sites/csdocuments/CorpComm_Docs/en/carbon-footprint-xps-9370.pdf",
              unit: "item",
              usage: "12.4%",
              displayName: "Xps 9370",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "XPS 9560": {
              icon: "laptop",
              intensityKilograms: 337,
              source: "https://i.dell.com/sites/csdocuments/CorpComm_Docs/en/carbon-footprint-xps-9560.pdf",
              unit: "item",
              usage: "21.3%",
              displayName: "Xps 9560",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "XPS 9570": {
              icon: "laptop",
              intensityKilograms: 324,
              source: "https://i.dell.com/sites/csdocuments/CorpComm_Docs/en/carbon-footprint-xps-15-9570.pdf",
              unit: "item",
              usage: "17.9%",
              displayName: "Xps 9570",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Lenovo Thinkpad 25": {
              icon: "laptop",
              intensityKilograms: 390,
              source: "https://github.com/rarecoil/laptop-co2e",
              unit: "item",
              usage: "28%",
              displayName: "Lenovo thinkpad 25",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Lenovo Thinkpad 11e 5th Gen": {
              icon: "laptop",
              intensityKilograms: 326,
              source: "https://www.lenovo.com/us/en/social_responsibility/PCF-ThinkPad-11e-Yoga-11e-5th.pdf",
              unit: "item",
              usage: "20%",
              displayName: "Lenovo thinkpad 11e 5th gen",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Lenovo Thinkpad A275": {
              icon: "laptop",
              intensityKilograms: 511,
              source: "https://github.com/rarecoil/laptop-co2e",
              unit: "item",
              usage: "31%",
              displayName: "Lenovo thinkpad a275",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Lenovo Thinkpad A285": {
              icon: "laptop",
              intensityKilograms: 352,
              source: "https://github.com/rarecoil/laptop-co2e",
              unit: "item",
              usage: "36%",
              displayName: "Lenovo thinkpad a285",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Lenovo Thinkpad A485": {
              icon: "laptop",
              intensityKilograms: 419,
              source: "https://github.com/rarecoil/laptop-co2e",
              unit: "item",
              usage: "35%",
              displayName: "Lenovo thinkpad a485",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Lenovo Thinkpad L380": {
              icon: "laptop",
              intensityKilograms: 406,
              source: "https://www.lenovo.com/us/en/social_responsibility/PCF-ThinkPad-L380-S2-Yoga-3rd.pdf",
              unit: "item",
              usage: "19%",
              displayName: "Lenovo thinkpad l380",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Lenovo Thinkpad L480": {
              icon: "laptop",
              intensityKilograms: 455,
              source: "https://www.lenovo.com/us/en/social_responsibility/PCF-ThinkPad-L480.pdf",
              unit: "item",
              usage: "30%",
              displayName: "Lenovo thinkpad l480",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Lenovo Thinkpad L490": {
              icon: "laptop",
              intensityKilograms: 499,
              source: "https://www.lenovo.com/us/en/pdf/social_responsibility/PCF_ThinkPad_L490.pdf",
              unit: "item",
              usage: "21%",
              displayName: "Lenovo thinkpad l490",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Lenovo Thinkpad P1": {
              icon: "laptop",
              intensityKilograms: 477,
              source: "https://www.lenovo.com/us/en/social_responsibility/PCF_ThinkPad_P1_X1_Extreme.pdf",
              unit: "item",
              usage: "16%",
              displayName: "Lenovo thinkpad p1",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Lenovo Thinkpad P52": {
              icon: "laptop",
              intensityKilograms: 693,
              source: "https://github.com/rarecoil/laptop-co2e",
              unit: "item",
              usage: "22%",
              displayName: "Lenovo thinkpad p52",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Lenovo Thinkpad P72": {
              icon: "laptop",
              intensityKilograms: 610,
              source: "https://www.lenovo.com/us/en/social_responsibility/PCF_ThinkPad_P72.pdf",
              unit: "item",
              usage: "23%",
              displayName: "Lenovo thinkpad p72",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Lenovo Thinkpad P73": {
              icon: "laptop",
              intensityKilograms: 611,
              source: "https://www.lenovo.com/us/en/pdf/social_responsibility/PCF_ThinkPad_P73.pdf",
              unit: "item",
              usage: "34%",
              displayName: "Lenovo thinkpad p73",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Lenovo Thinkpad X1 Carbon 4th Gen": {
              icon: "laptop",
              intensityKilograms: 457,
              source: "https://github.com/rarecoil/laptop-co2e",
              unit: "item",
              usage: "19%",
              displayName: "Lenovo thinkpad x1 carbon 4th gen",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Lenovo Thinkpad X1 Carbon 5th Gen": {
              icon: "laptop",
              intensityKilograms: 369,
              source: "https://github.com/rarecoil/laptop-co2e",
              unit: "item",
              usage: "17%",
              displayName: "Lenovo thinkpad x1 carbon 5th gen",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Lenovo Thinkpad X1 Carbon 6th Gen": {
              icon: "laptop",
              intensityKilograms: 333,
              source: "https://www.lenovo.com/us/en/social_responsibility/PCF-ThinkPad-X1-Carbon-6th.pdf",
              unit: "item",
              usage: "16%",
              displayName: "Lenovo thinkpad x1 carbon 6th gen",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Lenovo Thinkpad X1 Carbon 7th Gen": {
              icon: "laptop",
              intensityKilograms: 461,
              source: "https://www.lenovo.com/us/en/pdf/social_responsibility/PCF_ThinkPad_X1_Carbon_X1_Carbon_LTE_7th.pdf",
              unit: "item",
              usage: "13%",
              displayName: "Lenovo thinkpad x1 carbon 7th gen",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Lenovo Thinkpad X250": {
              icon: "laptop",
              intensityKilograms: 338,
              source: "https://github.com/rarecoil/laptop-co2e",
              unit: "item",
              usage: "24%",
              displayName: "Lenovo thinkpad x250",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Lenovo Thinkpad X260": {
              icon: "laptop",
              intensityKilograms: 489,
              source: "https://github.com/rarecoil/laptop-co2e",
              unit: "item",
              usage: "18%",
              displayName: "Lenovo thinkpad x260",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Lenovo Thinkpad X270": {
              icon: "laptop",
              intensityKilograms: 852,
              source: "https://github.com/rarecoil/laptop-co2e",
              unit: "item",
              usage: "10%",
              displayName: "Lenovo thinkpad x270",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Lenovo Thinkpad X280": {
              icon: "laptop",
              intensityKilograms: 334,
              source: "https://www.lenovo.com/us/en/social_responsibility/PCF-ThinkPad-X280.pdf",
              unit: "item",
              usage: "23%",
              displayName: "Lenovo thinkpad x280",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Lenovo Thinkpad X380 Yoga": {
              icon: "laptop",
              intensityKilograms: 339,
              source: "https://www.lenovo.com/us/en/social_responsibility/PCF-ThinkPad-S1-Yoga-4th-X380-Yoga.pdf",
              unit: "item",
              usage: "21%",
              displayName: "Lenovo thinkpad x380 yoga",
              associatedPurchaseCategory: "Information and communication equipment"
            },
            "Lenovo Thinkpad X390": {
              icon: "laptop",
              intensityKilograms: 290,
              source: "https://static.lenovo.com/ww/docs/regulatory/PCF_ThinkPad_X390.pdf",
              unit: "item",
              usage: "15%",
              displayName: "Lenovo thinkpad x390",
              associatedPurchaseCategory: "Information and communication equipment"
            }
          },
          icon: "laptop",
          intensityKilograms: {
            AT: 0.24624100774895624,
            AU: 0.31601817282454725,
            BE: 0.7800035826726511,
            BG: 0.46886426142323706,
            BR: 0.37202803161260034,
            CA: 0.500314362446506,
            CH: 0.21616609135793766,
            CN: 1.3149049835309479,
            CY: 0.11193396170781966,
            CZ: 0.6043803533862826,
            DE: 0.32790985269154505,
            DK: 0.2869304559234358,
            EE: 0.5890423115317808,
            ES: 0.28023589377384167,
            FI: 0.31140639893003674,
            FR: 0.2909223696446921,
            GB: 0.3179475069023756,
            GR: 1.3247419648006473,
            HR: 0.5578877036816511,
            HU: 0.5324524282226142,
            ID: 0.906016216884486,
            IE: 0.1987946522634447,
            IN: 1.7292534022449293,
            IT: 0.28422923451205906,
            JP: 0.445175436211432,
            KR: 0.6564379290574862,
            LT: 0.3934054493790021,
            LU: 0.5718448498802843,
            LV: 0.478347359117731,
            MT: 0.7292683118539495,
            MX: 0.6534744401138466,
            NL: 0.29056478919168227,
            NO: 0.23985013344272754,
            PL: 0.41562702135145524,
            PT: 0.373014130267382,
            RO: 0.4969127753669359,
            RU: 0.5656712598038252,
            SE: 0.2072887308211014,
            SI: 0.39315021463764227,
            SK: 0.49437977284909906,
            TR: 0.48488338918058366,
            TW: 0.6349138640879408,
            US: 0.5710900443732292,
            WA: 1.0106578068003378,
            WE: 1.2593304345708798,
            WF: 0.8975515693289027,
            WL: 0.5191879968798189,
            WM: 1.2626494239576804,
            ZA: 0.8601080863960707
          },
          oldKeys: ["PURCHASE_CATEGORY_STORE_ELECTRONIC", "Electronic store"],
          source: "https://github.com/tmrowco/bloom-contrib/tree/master/co2eq/purchase/exiobase",
          unit: "EUR",
          coicopCode: "08.1",
          year: 2011,
          displayName: "Information and communication equipment",
          keywords: ["computer", "electronics", "cables", "tv", "hardware", "telephone", "radio", "speaker", "mobile", "smartphone", "printer", "copyer", "scanner", "modem", "router", "monitor", "projector", "keyboard", "tablet", "phone"]
        }
      },
      coicopCode: "08",
      year: 2011,
      unit: "EUR",
      icon: "laptop",
      source: "https://github.com/tmrowco/bloom-contrib/tree/master/co2eq/purchase/exiobase",
      intensityKilograms: {
        AT: 0.16165337175967465,
        AU: 0.22984525614642085,
        BE: 0.36978418280718534,
        BG: 0.3424080752996095,
        BR: 0.19122161326754117,
        CA: 0.2976754337905848,
        CH: 0.15251541887292788,
        CN: 1.232399640892016,
        CY: 0.06746013838423515,
        CZ: 0.3792070188396106,
        DE: 0.220317560320911,
        DK: 0.3011930144491233,
        EE: 0.4992134664746811,
        ES: 0.20409787122343165,
        FI: 0.27213229293954877,
        FR: 0.16188942336891776,
        GB: 0.22740108103256632,
        GR: 1.0246489838523254,
        HR: 0.32333822394435535,
        HU: 0.39549286604688527,
        ID: 0.5607787731222142,
        IE: 0.1290950529064938,
        IN: 1.2869830080637987,
        IT: 0.21071717901758064,
        JP: 0.23289220480524553,
        KR: 0.423930191035941,
        LT: 0.30387431412823906,
        LU: 0.4072769545305141,
        LV: 0.43177731591193325,
        MT: 0.49046203489467016,
        MX: 0.41366111234280745,
        NL: 0.214293670435197,
        NO: 0.17303280734868337,
        PL: 0.3093440405222923,
        PT: 0.28062679728819073,
        RO: 0.3486164294385584,
        RU: 0.5645656896520772,
        SE: 0.16700589901627705,
        SI: 0.3077496939788159,
        SK: 0.3656678828793925,
        TR: 0.37279907393120176,
        TW: 0.31594561026983226,
        US: 0.14743117087983476,
        WA: 0.5858368762757311,
        WE: 0.8365760358307999,
        WF: 0.5610766243596117,
        WL: 0.3675515112225682,
        WM: 0.6399868954626976,
        ZA: 0.621587984068687
      },
      displayName: "Information and communication",
      keywords: ["software", "video", "game", "telephone", "radio", "tv", "streaming", "cloud", "computing", "hosting", "app", "plugin", "compute", "music", "film", "peripheral", "recording", "application", "operating system", "programming", "package", "online", "saas", "subscription", "postal services", "stamps"]
    },
    "RECREATION, SPORT AND CULTURE": {
      _children: {
        "RECREATIONAL DURABLES": {
          _children: {
            "Backpack (trekking)": {
              icon: "backpack",
              intensityKilograms: 6.3,
              source: "https://www.ademe.fr/sites/default/files/assets/documents/poids_carbone-biens-equipement-201809-rapport.pdf",
              unit: "item",
              displayName: "Backpack (trekking)",
              associatedPurchaseCategory: "RECREATIONAL DURABLES"
            },
            "Backpack (school)": {
              icon: "backpack",
              intensityKilograms: 9.8,
              source: "https://www.ademe.fr/sites/default/files/assets/documents/poids_carbone-biens-equipement-201809-rapport.pdf",
              unit: "item",
              displayName: "Backpack (school)",
              associatedPurchaseCategory: "RECREATIONAL DURABLES"
            },
            "Tennis racket": {
              icon: "racquet",
              intensityKilograms: 23,
              source: "https://www.ademe.fr/sites/default/files/assets/documents/poids_carbone-biens-equipement-201809-rapport.pdf",
              unit: "item",
              displayName: "Tennis racket",
              associatedPurchaseCategory: "RECREATIONAL DURABLES"
            },
            Football: {
              icon: "futbol",
              intensityKilograms: 5.1,
              source: "https://www.ademe.fr/sites/default/files/assets/documents/poids_carbone-biens-equipement-201809-rapport.pdf",
              unit: "item",
              displayName: "Football",
              associatedPurchaseCategory: "RECREATIONAL DURABLES"
            },
            Basketball: {
              icon: "basketball-ball",
              intensityKilograms: 5.9,
              source: "https://www.ademe.fr/sites/default/files/assets/documents/poids_carbone-biens-equipement-201809-rapport.pdf",
              unit: "item",
              displayName: "Basketball",
              associatedPurchaseCategory: "RECREATIONAL DURABLES"
            }
          },
          coicopCode: "09.1",
          year: 2011,
          unit: "EUR",
          source: "https://github.com/tmrowco/bloom-contrib/tree/master/co2eq/purchase/exiobase",
          intensityKilograms: {
            AT: 0.15698386401742823,
            AU: 0.16442133740445947,
            BE: 0.24211712628973503,
            BG: 0.6273403148789565,
            BR: 0.0985224681548506,
            CA: 0.4756810115174333,
            CH: 0.17552483047375356,
            CN: 0.9370482158173292,
            CY: 0.36839349047118364,
            CZ: 0.46461464743958053,
            DE: 0.21152068627884424,
            DK: 0.26712497315681305,
            EE: 1.1858879830770106,
            ES: 0.20406011142511843,
            FI: 0.30017732502846334,
            FR: 0.22029687261203787,
            GB: 0.1252864929939922,
            GR: 0.7477160565184139,
            HR: 0.5655290614978076,
            HU: 0.3668662789768609,
            ID: 0.48313395703402995,
            IE: 0.27227287281688295,
            IN: 1.1825252825994133,
            IT: 0.19984502925442466,
            JP: 0.17082660631695587,
            KR: 0.4126314168374702,
            LT: 0.1617922833994449,
            LU: 0.4249357124218203,
            LV: 0.3113521836769856,
            MT: 0.4064232930071485,
            MX: 0.24355117738845333,
            NL: 0.27100087076719803,
            NO: 0.21024227602008824,
            PL: 0.3504567451438758,
            PT: 0.22199456311611876,
            RO: 0.381612543394546,
            RU: 1.4305854410731909,
            SE: 0.11953374062012773,
            SI: 0.3522316718185896,
            SK: 0.7942064456255027,
            TR: 0.3034936007426963,
            TW: 0.31411804367183616,
            US: 0.19026047236339522,
            WA: 1.3702717047428465,
            WE: 0.980754197754967,
            WF: 1.030628730763058,
            WL: 0.3529801163792522,
            WM: 1.1452333275065105,
            ZA: 0.756769727362514
          },
          displayName: "Recreational durables",
          keywords: ["camera", "microphone", "film", "screen", "golf cart", "kayak", "bicycle", "yacht", "sailing"]
        },
        "GARDEN PRODUCTS AND PETS": {
          icon: "seedling",
          intensityKilograms: {
            AT: 0.2542210798708979,
            AU: 0.43119413328712647,
            BE: 0.5758166774802662,
            BG: 9.240417502724462,
            BR: 0.45589850521245967,
            CA: 0.9446025487981883,
            CH: 0.3402330111728814,
            CN: 1.3898536618391861,
            CY: 0.4322414421506183,
            CZ: 0.5478849336633547,
            DE: 0.4684150477293652,
            DK: 0.37577841911191173,
            EE: 1.2155657854944213,
            ES: 0.5101039214767802,
            FI: 0.5609740370242838,
            FR: 0.5025581962707519,
            GB: 0.37390082920740475,
            GR: 1.5246501958053573,
            HR: 0.976961381175776,
            HU: 0.5619291265242418,
            ID: 2.0989089503267975,
            IE: 0.7236664112462836,
            IN: 2.2973592250495534,
            IT: 0.5353313541495911,
            JP: 0.3634620654012027,
            KR: 0.6975719544486627,
            LT: 0.6288244335903131,
            LU: 0.681641291794953,
            LV: 0.8607961756538213,
            MT: 0.5836715492421118,
            MX: 1.150006948819401,
            NL: 0.4330959661871143,
            NO: 0.4674547085961894,
            PL: 0.6040520316486134,
            PT: 0.48432676354954207,
            RO: 0.9248950214115017,
            RU: 1.5001734748052387,
            SE: 0.2399610159991576,
            SI: 0.48400970236707697,
            SK: 2.8119547513873093,
            TR: 0.9367971713795745,
            TW: 0.882956454275714,
            US: 0.39586290942822266,
            WA: 2.885946129574318,
            WE: 1.7148829538691315,
            WF: 1.3468253832725936,
            WL: 0.7999050974737115,
            WM: 2.693562573695989,
            ZA: 2.134404904946476
          },
          oldKeys: ["PURCHASE_CATEGORY_STORE_GARDEN", "Lawn and garden store", "Pet shop", "Florist"],
          source: "https://github.com/tmrowco/bloom-contrib/tree/master/co2eq/purchase/exiobase",
          unit: "EUR",
          coicopCode: "09.3",
          year: 2011,
          displayName: "Garden products and pets",
          keywords: ["soil", "ornament", "flower", "plant", "pot", "tree"]
        },
        "RECREATIONAL SERVICES": {
          icon: "credit-card",
          intensityKilograms: {
            AT: 0.15871137369244454,
            AU: 0.13841312783647403,
            BE: 0.20558655446692325,
            BG: 0.39462346878649623,
            BR: 0.057692554707231655,
            CA: 0.431309486705327,
            CH: 0.15589872444073977,
            CN: 0.8819948251418707,
            CY: 0.43384545892973386,
            CZ: 0.6622025400490672,
            DE: 0.1916780196226564,
            DK: 0.2505599033717767,
            EE: 1.3135054110088449,
            ES: 0.20237623391661547,
            FI: 0.32388217879802683,
            FR: 0.2088141795603265,
            GB: 0.09286852783565482,
            GR: 0.6199731435211429,
            HR: 0.4940770105046335,
            HU: 0.34703113666891167,
            ID: 0.4769195088377223,
            IE: 0.18764301640780387,
            IN: 1.159681429165008,
            IT: 0.181054105770519,
            JP: 0.1429468631616595,
            KR: 0.3826683046179065,
            LT: 0.34021667736904504,
            LU: 0.3531007766726661,
            LV: 0.3343934873227601,
            MT: 0.44840681163911406,
            MX: 0.12554840985039217,
            NL: 0.26985511187296496,
            NO: 0.19950434944514286,
            PL: 0.4307362653052441,
            PT: 0.20480296762087158,
            RO: 0.34160894836215705,
            RU: 1.3590639473431192,
            SE: 0.10771742269662689,
            SI: 0.3915855267772943,
            SK: 0.4329962658424593,
            TR: 0.26461022655803124,
            TW: 0.2357272786265224,
            US: 0.16445850331256093,
            WA: 1.0155649458907008,
            WE: 0.9899795114621064,
            WF: 1.025819811055594,
            WL: 0.28462968353632956,
            WM: 0.7479933595363646,
            ZA: 0.6426085204014659
          },
          oldKeys: ["PURCHASE_CATEGORY_ENTERTAINMENT_AMUSEMENT_PARKS", "Amusement park", "Bar or nightclub", "Gambling", "Cinema"],
          source: "https://github.com/tmrowco/bloom-contrib/tree/master/co2eq/purchase/exiobase",
          unit: "EUR",
          coicopCode: "09.4",
          year: 2011,
          displayName: "Recreational services",
          keywords: ["golf", "bowling", "tennis", "climbing", "pool", "skiing"]
        },
        "NEWSPAPERS, BOOKS AND STATIONERY": {
          icon: "books",
          intensityKilograms: {
            AT: 0.2333103632378398,
            AU: 0.18343587617701498,
            BE: 0.2576814381181813,
            BG: 0.34921557721252766,
            BR: 0.1892564773567813,
            CA: 0.22910783615149494,
            CH: 0.18491062712039735,
            CN: 1.5689330340609418,
            CY: 0.40424300603034,
            CZ: 0.35123817029877974,
            DE: 0.20976603852757716,
            DK: 0.2095144161404695,
            EE: 0.6976660386035798,
            ES: 0.2586519106423795,
            FI: 0.19958854536942808,
            FR: 0.16242111399473122,
            GB: 0.2326378949695218,
            GR: 0.49846200432737475,
            HR: 0.636249496077233,
            HU: 0.3532938268298792,
            ID: 0.447498974308304,
            IE: 0.08485445084284877,
            IN: 1.336840688638436,
            IT: 0.19984974287135945,
            JP: 0.24240164738866418,
            KR: 0.5101026841363479,
            LT: 0.23588454143378126,
            LU: 0.5113723597717337,
            LV: 0.3792904167725706,
            MT: 0.3646392112676275,
            MX: 0.26595384508049363,
            NL: 0.22002778446159663,
            NO: 0.1781494629971245,
            PL: 0.234515315200288,
            PT: 0.2953820443067733,
            RO: 0.28285617594118384,
            RU: 0.29817939645170904,
            SE: 0.11169461922255534,
            SI: 0.2656011318325744,
            SK: 0.4174452988655871,
            TR: 0.39647576225920894,
            TW: 0.4705011979040445,
            US: 0.20888697475462772,
            WA: 1.1062818765454063,
            WE: 0.6547917406704846,
            WF: 0.8700214175468022,
            WL: 0.22100897805499337,
            WM: 0.5795983763685392,
            ZA: 1.6703420379569178
          },
          oldKeys: ["PURCHASE_CATEGORY_STORE_BOOKS", "Bookshop"],
          source: "https://github.com/tmrowco/bloom-contrib/tree/master/co2eq/purchase/exiobase",
          unit: "EUR",
          coicopCode: "09.7",
          year: 2011,
          displayName: "Newspapers, books and stationery",
          keywords: ["magazine", "periodical", "text", "drawing", "tapes", "drive", "multimedia", "guide", "paper", "pens", "office supplies", "postit"]
        },
        "PACKAGE HOLIDAYS": {
          icon: "ship",
          intensityKilograms: {
            AT: 0.18477745869577758,
            AU: 0.23772220788269532,
            BE: 0.4260607580706438,
            BG: 0.4904076727391378,
            BR: 0.1375555157319367,
            CA: 0.5218419659570881,
            CH: 0.14639042699614263,
            CN: 0.5764481195688038,
            CY: 0.16849616958425728,
            CZ: 0.5159713672744257,
            DE: 0.27458370271144733,
            DK: 0.3238674785938724,
            EE: 0.8805205541079335,
            ES: 0.2722773261881478,
            FI: 0.3127122923626017,
            FR: 0.15505594264307104,
            GB: 0.13088205516440346,
            GR: 3.739967092986632,
            HR: 0.4114439071892656,
            HU: 0.4426485410003005,
            ID: 0.3221942137448901,
            IE: 0.250585774918371,
            IN: 1.5014183443918578,
            IT: 0.23016912764689584,
            JP: 0.07178506153415548,
            KR: 0.30632931505775923,
            LT: 0.21025003593820243,
            LU: 0.9295967356812286,
            LV: 0.6027823412785304,
            MT: 0.6316048378627929,
            MX: 0.15317636810993096,
            NL: 0.37576531911266764,
            NO: 0.25365302271275014,
            PL: 0.3825931446571399,
            PT: 0.19658362190971773,
            RO: 0.19538781650819384,
            RU: 0.3811867305686719,
            SE: 0.23865436755080643,
            SI: 0.3274633511110864,
            SK: 0.5009969500293208,
            TR: 0.27323936134192506,
            TW: 0.08902019370343138,
            US: 0.1222553999673472,
            WA: 0.8891313595926491,
            WE: 0.7284400494208967,
            WF: 0.7649716245692659,
            WL: 0.3653543043239197,
            WM: 0.7366650618351462,
            ZA: 0.24769687045227254
          },
          oldKeys: ["PURCHASE_CATEGORY_ENTERTAINMENT_CRUISE_LINES", "Cruise"],
          source: "https://github.com/tmrowco/bloom-contrib/tree/master/co2eq/purchase/exiobase",
          unit: "EUR",
          coicopCode: "09.8",
          year: 2011,
          displayName: "Package holidays",
          keywords: ["trip", "cruise", "resort"]
        }
      },
      displayName: "Recreation, sport and culture"
    },
    "RESTAURANTS AND ACCOMMODATION SERVICES": {
      _children: {
        "FOOD AND BEVERAGE SERVING SERVICES": {
          coicopCode: 11.1,
          year: 2011,
          unit: "EUR",
          source: "https://github.com/tmrowco/bloom-contrib/tree/master/co2eq/purchase/exiobase",
          intensityKilograms: {
            AT: 0.197102755077923,
            AU: 0.39451879179304816,
            BE: 0.4536511458262555,
            BG: 0.45996419039812964,
            BR: 0.13166137173546888,
            CA: 0.7147675745521581,
            CH: 0.16170802251328648,
            CN: 0.5492103610746267,
            CY: 0.34635726706402487,
            CZ: 0.5246447376240954,
            DE: 0.2002497191567774,
            DK: 0.21272559016128129,
            EE: 1.2122032798143227,
            ES: 0.1622328506663801,
            FI: 0.283201395630099,
            FR: 0.17463954001114446,
            GB: 0.1008063464207837,
            GR: 0.32842575981505046,
            HR: 0.37525673849888763,
            HU: 0.5845123247559229,
            ID: 0.01673341570985204,
            IE: 0.34422084901583,
            IN: 1.601978427510277,
            IT: 0.21304547862170162,
            JP: 0.030089985282437358,
            KR: 0.512737507397552,
            LT: 0.13626376209231264,
            LU: 0.3151115992638755,
            LV: 0.3520508902412769,
            MT: 0.472387283657148,
            MX: 0.09862849554331042,
            NL: 0.3288019968549085,
            NO: 0.16212285153984576,
            PL: 0.32874470758495694,
            PT: 0.27807195498916626,
            RO: 0.09310031141098073,
            RU: 0.32780218581196147,
            SE: 0.23853084802014046,
            SI: 0.36705146696473356,
            SK: 0.476745496947243,
            TR: 0.4996122432617103,
            TW: 0.10749368498794722,
            US: 0.061233974193423635,
            WA: 0.9631697174262597,
            WE: 0.8580453786225865,
            WF: 1.0120577343283728,
            WL: 0.4790878403669391,
            WM: 0.8850067511928775,
            ZA: 0.4066581331517043
          },
          displayName: "Food and beverage serving services",
          keywords: ["restaurant", "cafe", "canteen", "cafeteria", "eating", "deli", "lunch", "dinner", "meal", "breakfast"],
          activityType: "ACTIVITY_TYPE_MEAL"
        },
        "ACCOMMODATION SERVICES": {
          icon: "credit-card",
          intensityKilograms: {
            AT: 0.197102755077923,
            AU: 0.39451879179304816,
            BE: 0.4536511458262555,
            BG: 0.45996419039812964,
            BR: 0.13166137173546888,
            CA: 0.7147675745521581,
            CH: 0.16170802251328648,
            CN: 0.5492103610746267,
            CY: 0.34635726706402487,
            CZ: 0.5246447376240954,
            DE: 0.2002497191567774,
            DK: 0.21272559016128129,
            EE: 1.2122032798143227,
            ES: 0.1622328506663801,
            FI: 0.283201395630099,
            FR: 0.17463954001114446,
            GB: 0.1008063464207837,
            GR: 0.32842575981505046,
            HR: 0.37525673849888763,
            HU: 0.5845123247559229,
            ID: 0.01673341570985204,
            IE: 0.34422084901583,
            IN: 1.601978427510277,
            IT: 0.21304547862170162,
            JP: 0.030089985282437358,
            KR: 0.512737507397552,
            LT: 0.13626376209231264,
            LU: 0.3151115992638755,
            LV: 0.3520508902412769,
            MT: 0.472387283657148,
            MX: 0.09862849554331042,
            NL: 0.3288019968549085,
            NO: 0.16212285153984576,
            PL: 0.32874470758495694,
            PT: 0.27807195498916626,
            RO: 0.09310031141098073,
            RU: 0.32780218581196147,
            SE: 0.23853084802014046,
            SI: 0.36705146696473356,
            SK: 0.476745496947243,
            TR: 0.4996122432617103,
            TW: 0.10749368498794722,
            US: 0.061233974193423635,
            WA: 0.9631697174262597,
            WE: 0.8580453786225865,
            WF: 1.0120577343283728,
            WL: 0.4790878403669391,
            WM: 0.8850067511928775,
            ZA: 0.4066581331517043
          },
          oldKeys: ["PURCHASE_CATEGORY_ENTERTAINMENT_HOTEL", "Hotel"],
          source: "https://github.com/tmrowco/bloom-contrib/tree/master/co2eq/purchase/exiobase",
          unit: "EUR",
          coicopCode: 11.2,
          year: 2011,
          displayName: "Accommodation services",
          keywords: ["hotel", "airbnb", "hostel", "b&b", "bed and breakfast", "lodge", "inn", "campsite", "dwelling", "motel"]
        }
      },
      displayName: "Restaurants and accommodation services"
    },
    "INSURANCE AND FINANCIAL SERVICES": {
      _children: {
        INSURANCE: {
          coicopCode: 12.1,
          year: 2011,
          unit: "EUR",
          source: "https://github.com/tmrowco/bloom-contrib/tree/master/co2eq/purchase/exiobase",
          intensityKilograms: {
            AT: 0.20525212768727508,
            AU: 0.20183341279967892,
            BE: 0.2918690306993321,
            BG: 0.4474419901167953,
            BR: 0.22605548293986055,
            CA: 0.15110017020380123,
            CH: 0.12568808910322787,
            CN: 1.7089204870971106,
            CY: 0.28250222545497355,
            CZ: 0.45912758017792393,
            DE: 0.21581824342662373,
            DK: 0.26245517117009637,
            EE: 0.8844066292757968,
            ES: 0.21379443862142167,
            FI: 0.21359768365995388,
            FR: 0.12651614394263846,
            GB: 0.19271899640381285,
            GR: 0.2509196761660476,
            HR: 0.34326976667532455,
            HU: 0.4406467325203005,
            ID: 1.1758355821400124,
            IE: 0.15435576053547467,
            IN: 0.6269583817033568,
            IT: 0.2110988217246453,
            JP: 0.32060057940278397,
            KR: 0.5964230310827121,
            LT: 0.15848608780822349,
            LU: 0.3367084942216505,
            LV: 0.3308801939960504,
            MT: 0.47619772401660077,
            MX: 0.28090976023059483,
            NL: 0.15921889094502012,
            NO: 0.1325717904253491,
            PL: 0.35649971093288757,
            PT: 0.2442251232488849,
            RO: 0.289942198182116,
            RU: 0.4715539823327541,
            SE: 0.07286816885387866,
            SI: 0.31689187165462623,
            SK: 0.4959058528539031,
            TR: 0.4778515198136341,
            TW: 0.7952228015228132,
            US: 0.18830799713216007,
            WA: 0.7014095674246446,
            WE: 0.7084454442100508,
            WF: 0.6388834010462799,
            WL: 0.29710995262743123,
            WM: 0.6206450758289825,
            ZA: 0.6170587484951258
          },
          displayName: "Insurance"
        },
        "FINANCIAL SERVICES": {
          coicopCode: 12.2,
          year: 2011,
          unit: "EUR",
          source: "https://github.com/tmrowco/bloom-contrib/tree/master/co2eq/purchase/exiobase",
          intensityKilograms: {
            AT: 0.20208118120307086,
            AU: 0.3274472459684225,
            BE: 0.5608457431290221,
            BG: 1.898822324345688,
            BR: 0.6230265517074598,
            CA: 0.8517398785946653,
            CH: 0.325156958625265,
            CN: 1.4835934603244765,
            CY: 0.24319055637016024,
            CZ: 0.6058405169331129,
            DE: 0.28742160135957906,
            DK: 0.30166676157530936,
            EE: 0.8868694159797308,
            ES: 0.3680132558496578,
            FI: 0.49925492756993384,
            FR: 0.3076115845368719,
            GB: 0.40327166196263214,
            GR: 1.9269934903836088,
            HR: 1.0718238842408847,
            HU: 0.5555796476520594,
            ID: 1.5733894106676374,
            IE: 0.7824951449945194,
            IN: 2.94394196840412,
            IT: 0.4065553330459095,
            JP: 0.6721256112643021,
            KR: 0.7824182953010557,
            LT: 0.33151557911246743,
            LU: 0.7425114596640342,
            LV: 0.4507896783038774,
            MT: 0.6379172028912946,
            MX: 1.1601712790666117,
            NL: 0.24813885899511987,
            NO: 0.2576280763432278,
            PL: 0.3675274293965511,
            PT: 0.39421639383609947,
            RO: 0.9999849361039067,
            RU: 1.1138050294756443,
            SE: 0.22180032681223188,
            SI: 0.4676347396742888,
            SK: 2.7998043665410894,
            TR: 0.8866680875396451,
            TW: 0.9052110155576232,
            US: 0.39543483566379856,
            WA: 4.255335290941181,
            WE: 1.5500503689035197,
            WF: 1.7666646672344477,
            WL: 1.095690289800051,
            WM: 4.960903034487888,
            ZA: 1.794318124451391
          },
          displayName: "Financial services",
          keywords: ["bank", "fee"]
        }
      },
      displayName: "Insurance and financial services"
    },
    "PERSONAL CARE, SOCIAL PROTECTION AND MISCELLANEOUS GOODS AND SERVICES": {
      _children: {
        "PERSONAL CARE": {
          icon: "cut",
          intensityKilograms: {
            AT: 0.2447046541499576,
            AU: 0.2125411643749544,
            BE: 0.32585138369980454,
            BG: 0.821459052296206,
            BR: 0.22190718981472932,
            CA: 0.3782360399750344,
            CH: 0.22305636197784678,
            CN: 1.5655777861183424,
            CY: 0.3989444610284387,
            CZ: 0.4389567951210548,
            DE: 0.25036538008796516,
            DK: 0.18989245002887883,
            EE: 0.8017370570290017,
            ES: 0.2821325688278205,
            FI: 0.2783367208426193,
            FR: 0.1980345383499118,
            GB: 0.2638198678030431,
            GR: 0.6069656789856936,
            HR: 0.8058631900608682,
            HU: 0.38563586911138636,
            ID: 0.5193135528790537,
            IE: 0.15880861933302992,
            IN: 1.3543426830101093,
            IT: 0.23285286780665554,
            JP: 0.2935324106272345,
            KR: 0.5850927901846654,
            LT: 0.2650079007424164,
            LU: 0.6176090302191941,
            LV: 0.43208364616510997,
            MT: 0.4953356691462618,
            MX: 0.3786097492641247,
            NL: 0.2581634999714242,
            NO: 0.2031158316589496,
            PL: 0.28482886488019715,
            PT: 0.3543645445727692,
            RO: 0.3000058041364812,
            RU: 0.36394918103980023,
            SE: 0.1270453122810042,
            SI: 0.44177538492863333,
            SK: 0.7107354262669237,
            TR: 0.427341003595324,
            TW: 0.6902101792293929,
            US: 0.30215197086303996,
            WA: 1.1086963305050686,
            WE: 0.8924639868348322,
            WF: 0.9509227602795168,
            WL: 0.2893935008852226,
            WM: 0.6786909211276582,
            ZA: 2.3870624969581176
          },
          oldKeys: ["PURCHASE_CATEGORY_STORE_BARBER_BEAUTY", "Barber or beauty shop"],
          source: "https://github.com/tmrowco/bloom-contrib/tree/master/co2eq/purchase/exiobase",
          unit: "EUR",
          coicopCode: 13.1,
          year: 2011,
          displayName: "Personal care",
          keywords: ["razor", "comb", "dental", "hygiene"]
        },
        "OTHER PERSONAL EFFECTS": {
          _children: {
            "Jewellery and watches (D)": {
              coicopCode: "13.2.1",
              year: 2011,
              unit: "EUR",
              source: "https://github.com/tmrowco/bloom-contrib/tree/master/co2eq/purchase/exiobase",
              intensityKilograms: {
                AT: 0.02613830423837556,
                AU: 0.7036380641575152,
                BE: 0.2462605536532087,
                BG: 0.06185480414245307,
                BR: 0.002019445448262509,
                CA: 0.43695854478485846,
                CH: 0.2719099461348349,
                CN: 1.0962368062467491,
                CY: 0.018515533515648348,
                CZ: 0.08403285750992767,
                DE: 0.03600494438195034,
                DK: 0.12050061361456962,
                EE: 0.24724769440486832,
                ES: 0.04300064019857727,
                FI: 0.04162376115212194,
                FR: 0.023636718504915256,
                GB: 0.018130906146136102,
                GR: 0.022061542748741256,
                HR: 0.07907005864181985,
                HU: 0.1365341598126777,
                ID: 0.6201386448079808,
                IE: 0.07269545515271328,
                IN: 1.0761024880078045,
                IT: 0.27156813588409595,
                JP: 0.27238435336987543,
                KR: 1.061834683834713,
                LT: 0.03920037027254397,
                LU: 0.04537470431187186,
                LV: 0.11647707220246496,
                MT: 0.10828318566079821,
                MX: 0.03918283230035161,
                NL: 0.2511359534372522,
                NO: 0.20207829250900344,
                PL: 0.23333343846318239,
                PT: 0.043244753861781046,
                RO: 0.057544022362746965,
                RU: 0.6979781733690976,
                SE: 0.03841996226636729,
                SI: 0.05867837951714139,
                SK: 0.29709905551789473,
                TR: 0.1777831338545528,
                TW: 0.025027200654510598,
                US: 0.04206450242529094,
                WA: 0.3082338493358945,
                WE: 2.20006152337362,
                WF: 0.8504757411024045,
                WL: 0.36693843933837106,
                WM: 0.6773344946787975,
                ZA: 0.8906134022451655
              },
              displayName: "Jewellery and watches"
            },
            "Other personal effects n.e.c. (SD)": {
              coicopCode: "13.2.9",
              year: 2011,
              unit: "EUR",
              source: "https://github.com/tmrowco/bloom-contrib/tree/master/co2eq/purchase/exiobase",
              intensityKilograms: {
                AT: 0.13325050330509872,
                AU: 0.0821196889822095,
                BE: 0.15763320639300904,
                BG: 0.1405924384192309,
                BR: 0.10110166409299756,
                CA: 0.1549148755866005,
                CH: 0.08331874933076598,
                CN: 0.4850406722259879,
                CY: 0.1393004104192668,
                CZ: 0.30995545352579845,
                DE: 0.16844961025247784,
                DK: 0.11318110644394606,
                EE: 0.3615877924862155,
                ES: 0.11235642799736634,
                FI: 0.1760494711930126,
                FR: 0.12961632899757092,
                GB: 0.12027993226489522,
                GR: 2.8476414415554046,
                HR: 0.43273582689034873,
                HU: 0.4320302960069738,
                ID: 0.22135499834295566,
                IE: 0.1661429175923341,
                IN: 0.4759915360486923,
                IT: 0.12707675586761674,
                JP: 0.10289375264089451,
                KR: 0.2911638116236572,
                LT: 0.21656487585997844,
                LU: 0.17225361296290728,
                LV: 0.22486013143524003,
                MT: 0.37164925405231874,
                MX: 0.23702267721914788,
                NL: 0.15917425270973148,
                NO: 0.09238199247280507,
                PL: 0.4063108610985152,
                PT: 0.11562942396175957,
                RO: 0.38317120673627203,
                RU: 0.18540247988617642,
                SE: 0.09533413722782014,
                SI: 0.1689721637820629,
                SK: 0.20133865390215538,
                TR: 0.18885356804665554,
                TW: 0.16346592503009993,
                US: 0.1709680054838577,
                WA: 0.571814859856139,
                WE: 0.645481441051063,
                WF: 0.6416313002491802,
                WL: 0.27272969147447557,
                WM: 0.5706096215440314,
                ZA: 0.16583184109376392
              },
              displayName: "Other personal effects n.e.c."
            }
          },
          displayName: "Other personal effects"
        },
        "SOCIAL PROTECTION": {
          coicopCode: 13.3,
          year: 2011,
          unit: "EUR",
          source: "https://github.com/tmrowco/bloom-contrib/tree/master/co2eq/purchase/exiobase",
          intensityKilograms: {
            AT: 0.09741379607500217,
            AU: 0.053609539335968265,
            BE: 0.18611863674210424,
            BG: 0.20238905884323188,
            BR: 0.07053036067715952,
            CA: 0.2610585735077292,
            CH: 0.06087676767800035,
            CN: 0.3352569904449342,
            CY: 0.12249416665685153,
            CZ: 0.22371004135846323,
            DE: 0.15204717342541288,
            DK: 0.1349635312741557,
            EE: 0.27816691107597913,
            ES: 0.06308242722011395,
            FI: 0.252888419172237,
            FR: 0.10718934258042785,
            GB: 0.08482415308724282,
            GR: 0.20254852102875479,
            HR: 0.19172270545775585,
            HU: 0.26797941638666295,
            ID: 0.07359703592254532,
            IE: 0.12175250934598245,
            IN: 0.33993930913415715,
            IT: 0.09709696542724913,
            JP: 0.04961839124023909,
            KR: 0.18797834657147777,
            LT: 0.23557012949611714,
            LU: 0.14861863775780645,
            LV: 0.20881125693612154,
            MT: 0.30364195229642565,
            MX: 0.1959845420711491,
            NL: 0.11524931492773524,
            NO: 0.11101634692759632,
            PL: 0.345074820055155,
            PT: 0.08445158844369037,
            RO: 0.20347746147061324,
            RU: 0.11153269625816441,
            SE: 0.11256390441278373,
            SI: 0.17135478545487462,
            SK: 0.18866254031033763,
            TR: 0.1519911261257652,
            TW: 0.12599596122946655,
            US: 0.1060640081815195,
            WA: 0.454017397001682,
            WE: 0.4069251944435491,
            WF: 0.5195670390451766,
            WL: 0.17918558288870357,
            WM: 0.45669890156583887,
            ZA: 0.08290291271354444
          },
          displayName: "Social protection"
        },
        "OTHER SERVICES": {
          coicopCode: 13.9,
          year: 2011,
          unit: "EUR",
          source: "https://github.com/tmrowco/bloom-contrib/tree/master/co2eq/purchase/exiobase",
          intensityKilograms: {
            AT: 0.11736647849656673,
            AU: 0.09097813536165757,
            BE: 0.22438088928754407,
            BG: 0.23717531105454054,
            BR: 0.08473759720052974,
            CA: 0.45642715444033094,
            CH: 0.12689550160919594,
            CN: 0.6822634797643455,
            CY: 0.12174520544090173,
            CZ: 0.2532176225873419,
            DE: 0.15524204841996875,
            DK: 0.18048267548300068,
            EE: 0.49843187059227617,
            ES: 0.13355495213807195,
            FI: 0.20327005797970782,
            FR: 0.10449324454226513,
            GB: 0.0912671732066793,
            GR: 0.7101529082316287,
            HR: 0.20592735058004422,
            HU: 0.2632321592320419,
            ID: 0.3474440671101893,
            IE: 0.1274442269514449,
            IN: 0.574757610953707,
            IT: 0.13240004375296374,
            JP: 0.09837909966199665,
            KR: 0.30614582464195267,
            LT: 0.2180443480755977,
            LU: 0.17554263597724018,
            LV: 0.27905127514382017,
            MT: 0.3327541434696918,
            MX: 0.20760631765033494,
            NL: 0.14807521977540977,
            NO: 0.15787304628864998,
            PL: 0.276925320573471,
            PT: 0.1197365105757661,
            RO: 0.26763199526740294,
            RU: 0.7700481112052564,
            SE: 0.0989029628490993,
            SI: 0.2370958899087683,
            SK: 0.23011770026298883,
            TR: 0.27876483791087336,
            TW: 0.20636545919098015,
            US: 0.13569724391387566,
            WA: 0.5583419695504661,
            WE: 0.6589715040192724,
            WF: 0.7105536777703788,
            WL: 0.23991173786792805,
            WM: 0.5816901232229408,
            ZA: 0.2601298382933392
          },
          displayName: "Other services",
          keywords: ["legal", "lawyer", "agency", "accountant", "notary", "fees", "private detective", "prostitution", "bodyguard", "administration", "photocopies", "intermediaries", "consultant", "freelancer", "upwork", "fiverr", "ads", "advertising", "advertisement", "job posts", "recruiter", "recruitment agency"]
        }
      },
      displayName: "Personal care, social protection and miscellaneous goods and services"
    }
  }
};
exports.footprints = footprints;